/*! shopify_app_compiler 2025-09-18 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite"
        },
        webhook: {
            removeAll: "||-API-ROOT-||/webhook/gar/removeAll"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateWebAlias: "||-API-ROOT-||/customer/sca/updateWebAlias",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            getDashboardSummary: "||-API-ROOT-||/customer/sca/getDashboardSummary",
            getDashboardSales: "||-API-ROOT-||/customer/sca/getDashboardSales",
            getOrderDetails: "||-API-ROOT-||/customer/sca/getOrderDetails",
            getDashboardReferrals: "||-API-ROOT-||/customer/sca/getDashboardReferrals",
            getDashboardPayouts: "||-API-ROOT-||/customer/sca/getDashboardPayouts",
            getDashboardAssets: "||-API-ROOT-||/customer/sca/getDashboardAssets",
            getReferralName: "||-API-ROOT-||/customer/sca/getReferralName",
            updateOptInStatus: "||-API-ROOT-||/customer/sca/updateOptInStatus",
            getOptInStatus: "||-API-ROOT-||/customer/sca/getOptInStatus",
            proxyDownload: "||-API-ROOT-||/customer/sca/proxyDownload",
            updateCustomerRefCode: "||-API-ROOT-||/customer/sca/updateCustomerRefCode",
            getCustomerRefCode: "||-API-ROOT-||/customer/sca/getCustomerRefCode",
            getSellerLinksCode: "||-API-ROOT-||/customer/sca/getSellerLinksCode",
            getAffiliateInfo: "||-API-ROOT-||/customer/sca/getAffiliateInfo",
            getAffiliateStatusByRefCode: "||-API-ROOT-||/customer/sca/getAffiliateStatusByRefCode",
            getConnectedSellers: "||-API-ROOT-||/customer/sca/getConnectedSellers",
            getContacts: "||-API-ROOT-||/customer/sca/getContacts"
        },
        auth: {
            sso: "||-API-ROOT-||/auth/sca/sso"
        },
        order: {},
        product: {},
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount",
            createAffiliate: "||-API-ROOT-||/enrollment/sca/createAffiliate",
            updateAffiliate: "||-API-ROOT-||/enrollment/sca/updateAffiliate",
            formRequest: "||-API-ROOT-||/enrollment/sca/formRequest",
            getFormResponse: "||-API-ROOT-||/enrollment/sca/getFormResponse",
            completeEnrollment: "||-API-ROOT-||/enrollment/sca/completeEnrollment",
            signTermsAndConditions: "||-API-ROOT-||/enrollment/sca/signTermsAndConditions",
            markTaxFormAsCompleted: "||-API-ROOT-||/enrollment/sca/markTaxFormAsCompleted"
        },
        searchSponsor: {
            getSponsorInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorInfo",
            getSponsorByPersonalInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorByPersonalInfo"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, _this.apiRoot);
                    }
                }
                return endpoints;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {}
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.send = function(options) {
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: []
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        completeOptions_1.callbackParams.unshift(request_1);
                        completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        console.log("Init : ", _this.className);
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.shareRefCodeFunctionality = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.availableRechargeUsage = exports.sponsorGenealogyTimeout = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.productVolumesConfig = exports.EProductPriceType = exports.ECustomerType = exports.defaultCorporationImage = exports.additionalRepInfo = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.corporationName = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "beautycounter";
    exports.corporationName = "Beautycounter";
    exports.lockedRepresentativeSite = false;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.additionalRepInfo = false;
    exports.defaultCorporationImage = "https://codemancystudio.com/cdm_template/wp-content/uploads/2018/03/cdm-logo-blacksmall.png";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "retail";
        ECustomerType["representative"] = "affiliate";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "affiliate";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: true,
        qv: true,
        bv: false,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "ByDesign";
    exports.representative = "representative";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.repDiscountWithPromoCode = false;
    exports.cronJobReSyncOrders = false;
    exports.downgradeRepresentativeByDesignWebhook = false;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.availableRechargeUsage = false;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.shareRefCodeFunctionality = false;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_1, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_1.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_2.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_3.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_4.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_5.StModule);
    exports.StNotification = StNotification;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_6.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_7.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_8.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType[ECurrencyFormatType["withCurrency"] = 0] = "withCurrency";
        ECurrencyFormatType[ECurrencyFormatType["withoutCurrency"] = 1] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.applyFormat = function(amount, formatType, locale, currency) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                if (locale === void 0) {
                    locale = window.shopLocale || "en";
                }
                if (currency === void 0) {
                    currency = "USD";
                }
                console.debug(formatType);
                var formatter = new Intl.NumberFormat(locale, {
                    style: formatType === ECurrencyFormatType.withoutCurrency ? "decimal" : "currency",
                    currency: currency,
                    currencyDisplay: "narrowSymbol",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return formatter.format(amount || 0);
            };
            return _this;
        }
        return StCurrency;
    }(st_module_9.StModule);
    exports.StCurrency = StCurrency;
});

define("extension/shopify-app/st-modules/seller-enrollment/seller-enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerEnrollmentClassConfig = void 0;
    var StSellerEnrollmentClassConfig = function(_super) {
        __extends(StSellerEnrollmentClassConfig, _super);
        function StSellerEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerEnrollmentClassConfig";
            _this.classNameColumnsWrapper = "bc_seller_enrollment_column--wrapper_JS";
            _this.selectorColumnsWrapper = "." + _this.classNameColumnsWrapper;
            _this.classNameColumnRight = "bc_column_right_JS";
            _this.selectorColumnRight = "." + _this.classNameColumnRight;
            _this.classNameRadioButtonLabel = "bc_seller_enrollment_label_JS";
            _this.selectorRadioButtonLabel = "." + _this.classNameRadioButtonLabel;
            _this.classNameRadioButtonWrapper = "bc_radio_button_wrapper_JS";
            _this.selectorRadioButtonWrapper = "." + _this.classNameRadioButtonWrapper;
            _this.classNameRadioButtonsWrapper = "bc_radio_buttons_wrapper_JS";
            _this.selectorRadioButtonsWrapper = "." + _this.classNameRadioButtonsWrapper;
            _this.classNameRadioButtonInput = "bc_radio_button_input_JS";
            _this.selectorRadioButtonInput = "." + _this.classNameRadioButtonInput;
            _this.classNameStartApplicationButton = "bc_seller_enrollment_application_button_JS";
            _this.selectorStartApplicationButton = "." + _this.classNameStartApplicationButton;
            _this.classNameSellerEnrollmentStepOne = "bc_seller_enrollment_step_one_JS";
            _this.selectorSellerEnrollmentStepOne = "." + _this.classNameSellerEnrollmentStepOne;
            _this.classNameSellerEnrollmentStepTwo = "bc_seller_enrollment_step_two_JS";
            _this.selectorSellerEnrollmentStepTwo = "." + _this.classNameSellerEnrollmentStepTwo;
            _this.classNameSellerEnrollmentStepThree = "bc_seller_enrollment_step_three_JS";
            _this.selectorSellerEnrollmentStepThree = "." + _this.classNameSellerEnrollmentStepThree;
            _this.classNameSellerEnrollmentThankYouPage = "bc_seller_enrollment_thank_you_wrapper_JS";
            _this.selectorSellerEnrollmentThankYouPage = "." + _this.classNameSellerEnrollmentThankYouPage;
            _this.classNameSellerEnrollmentRejectPage = "bc_seller_enrollment_reject_page_wrapper_JS";
            _this.selectorSellerEnrollmentRejectPage = "." + _this.classNameSellerEnrollmentRejectPage;
            _this.classNameSellerEnrollmentCompletedPage = "bc_seller_enrollment_completed_page_wrapper_JS";
            _this.selectorSellerEnrollmentCompletedPage = "." + _this.classNameSellerEnrollmentCompletedPage;
            _this.classNameSellerEnrollmentApprovedContent = "bc_seller_enrollment_approved_content_wrapper_JS";
            _this.selectorSellerEnrollmentApprovedContent = "." + _this.classNameSellerEnrollmentApprovedContent;
            _this.classNameSellerEnrollmentTaxFormButton = "bc_seller_enrollment_upload_tax_form_JS";
            _this.selectorSellerEnrollmentTaxFormButton = "." + _this.classNameSellerEnrollmentTaxFormButton;
            _this.classNameSellerEnrollmentTermsAndConditionsButton = "bc_terms_and_conditions_button_JS";
            _this.selectorSellerEnrollmentTermsAndConditionsButton = "." + _this.classNameSellerEnrollmentTermsAndConditionsButton;
            _this.classNameAcceptTermsAndConditionsButton = "bc_accept_terms_and_conditions_button_JS";
            _this.selectorAcceptTermsAndConditionsButton = "." + _this.classNameAcceptTermsAndConditionsButton;
            _this.classNameCompletedStep = "bc_complete_JS";
            _this.selectorCompletedStep = "." + _this.classNameCompletedStep;
            _this.classNameNotCompletedStep = "bc_origin_text_JS";
            _this.selectorNotCompletedStep = "." + _this.classNameNotCompletedStep;
            _this.classNameSellerEnrollmentAddSocialsButton = "bc_seller_enrollment_add_socials_JS";
            _this.selectorSellerEnrollmentAddSocialsButton = "." + _this.classNameSellerEnrollmentAddSocialsButton;
            _this.classNameSellerEnrollmentCredentialsWrapper = "bc_seller_enrollment_credentials--wrapper_JS";
            _this.selectorSellerEnrollmentCredentialsWrapper = "." + _this.classNameSellerEnrollmentCredentialsWrapper;
            _this.classNameSocialsWrapper = "bc_seller_enrollment_social_media--wrapper_JS";
            _this.selectorSocialsWrapper = "." + _this.classNameSocialsWrapper;
            _this.classNameSellerEnrollmentSubmitButton = "bc_seller_enrollment_submit_JS";
            _this.selectorSellerEnrollmentSubmitButton = "." + _this.classNameSellerEnrollmentSubmitButton;
            _this.classNameFirstNameInput = "bc_seller_enrollment_first_name_JS";
            _this.selectorFirstNameInput = "." + _this.classNameFirstNameInput;
            _this.classNameLastNameInput = "bc_seller_enrollment_last_name_JS";
            _this.selectorLastNameInput = "." + _this.classNameLastNameInput;
            _this.classNameInstagramInput = "bc_seller_enrollment_instagram_JS";
            _this.selectorInstagramInput = "." + _this.classNameInstagramInput;
            _this.classNameTiktokInput = "bc_seller_enrollment_tiktok_JS";
            _this.selectorTiktokInput = "." + _this.classNameTiktokInput;
            _this.classNameYoutubeInput = "bc_seller_enrollment_youtube_JS";
            _this.selectorYoutubeInput = "." + _this.classNameYoutubeInput;
            _this.classNameTwitterInput = "bc_seller_enrollment_twitter_JS";
            _this.selectorTwitterInput = "." + _this.classNameTwitterInput;
            _this.classNameTermsAndConditionsWrapper = "bc_seller_enrollment_terms_and_conditions--wrapper_JS";
            _this.selectorTermsAndConditionsWrapper = "." + _this.classNameTermsAndConditionsWrapper;
            _this.classNamePaymentInfoOverlay = "bc_seller_enrollment_payment_information--overlay_JS";
            _this.selectorPaymentInfoOverlay = "." + _this.classNamePaymentInfoOverlay;
            _this.classNamePaymentInfoWrapper = "bc_seller_enrollment_payment_information--wrapper_JS";
            _this.selectorPaymentInfoWrapper = "." + _this.classNamePaymentInfoWrapper;
            _this.classNameAddPaymentInfoButton = "bc_payment_information_JS";
            _this.selectorAddPaymentInfoButton = "." + _this.classNameAddPaymentInfoButton;
            _this.classNameTaxFormButton = "bc_seller_enrollment_tax_form_button_JS";
            _this.selectorTaxFormButton = "." + _this.classNameTaxFormButton;
            _this.classNameCancelPaymentButton = "bc_cancel_payment_JS";
            _this.selectorCancelPaymentButton = "." + _this.classNameCancelPaymentButton;
            _this.classNameSubmitPaymentButton = "bc_submit_payment_info_JS";
            _this.selectorSubmitPaymentButton = "." + _this.classNameSubmitPaymentButton;
            _this.classNamePaymentInfoContent = "bc_payment_information_popup_content_JS";
            _this.selectorPaymentInfoContent = "." + _this.classNamePaymentInfoContent;
            _this.classNamePaymentModeWrapper = "bc_payment_mode_wrapper_JS";
            _this.selectorPaymentModeWrapper = "." + _this.classNamePaymentModeWrapper;
            _this.classNamePaymentModeField = "bc_payment_mode_JS";
            _this.selectorPaymentModeField = "." + _this.classNamePaymentModeField;
            _this.classnameAccountTypeWrapper = "bc_account_type_wrapper_JS";
            _this.selectorAccountTypeWrapper = "." + _this.classnameAccountTypeWrapper;
            _this.classNamePaymentAccountTypeField = "bc_payment_account_type_JS";
            _this.selectorPaymentAccountTypeField = "." + _this.classNamePaymentAccountTypeField;
            _this.classNameBankNameField = "bc_bank_name_JS";
            _this.selectorBankNameField = "." + _this.classNameBankNameField;
            _this.classNameAccountNameField = "bc_account_name_JS";
            _this.selectorAccountNameField = "." + _this.classNameAccountNameField;
            _this.classNameAccountNumberField = "bc_account_number_JS";
            _this.selectorAccountNumberField = "." + _this.classNameAccountNumberField;
            _this.classNameRepeatAccountNumberWrapper = "bc_repeat_account_number_wrapper_JS";
            _this.selectorRepeatAccountNumberWrapper = "." + _this.classNameRepeatAccountNumberWrapper;
            _this.classNameRepeatAccountNumberField = "bc_repeat_account_number_JS";
            _this.selectorRepeatAccountNumberField = "." + _this.classNameRepeatAccountNumberField;
            _this.classNameBranchCodeField = "bc_branch_code_JS";
            _this.selectorBranchCodeField = "." + _this.classNameBranchCodeField;
            _this.classNameSwiftNameField = "bc_swift_name_JS";
            _this.selectorSwiftNameField = "." + _this.classNameSwiftNameField;
            _this.classNameCountryRadioLabel = "bc_radio_country_label_JS";
            _this.selectorCountryRadioLabel = "." + _this.classNameCountryRadioLabel;
            _this.classNameCountryButtonWrapper = "bc_radio_button_wrapper_JS";
            _this.selectorCountryButtonWrapper = "." + _this.classNameCountryButtonWrapper;
            _this.classNameCountryButtonsWrapper = "bc_radio_buttons_wrapper_JS";
            _this.selectorCountryButtonsWrapper = "." + _this.classNameCountryButtonsWrapper;
            _this.classNameSelectCountryWrapper = "bc_select_county_wrapper_JS";
            _this.selectorSelectCountryWrapper = "." + _this.classNameSelectCountryWrapper;
            _this.classNameTaxFormBackButton = "bc_seller_enrollment_back_button_JS";
            _this.selectorTaxFormBackButton = "." + _this.classNameTaxFormBackButton;
            return _this;
        }
        return StSellerEnrollmentClassConfig;
    }(st_module_10.StModule);
    exports.StSellerEnrollmentClassConfig = StSellerEnrollmentClassConfig;
});

define("extension/shopify-app/st-modules/seller-enrollment/seller-enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerEnrollment = void 0;
    var StSellerEnrollment = function(_super) {
        __extends(StSellerEnrollment, _super);
        function StSellerEnrollment(generalMethods, classConfig, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerEnrollment";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.showAppropriateContentOnPageLoad();
                    _this_1.handleRadioButtonCLick();
                    _this_1.countryRadioButtonClickHandle();
                    _this_1.handleStartApplicationClick();
                    _this_1.handleAddCredentialsClick();
                    _this_1.handleSubmitEnrollmentForm();
                    _this_1.handleShowTaxFormClick();
                    _this_1.backFromTaxForm();
                    _this_1.backToFirstStep();
                    _this_1.backToSecondStep();
                    _this_1.setTaxFormCompleteOnPageLoad();
                    _this_1.handleBackFromTermsAndConditions();
                    _this_1.handleTermsAndConditionsCheckboxClick();
                    _this_1.handleReferralFlow();
                    window.addEventListener("message", function(event) {
                        var trustedOrigins = [ "https://sbx.track1099.com", "https://track1099.com", "https://beautycounter-dev1.myshopify.com", "https://beautycounter-dev2.myshopify.com", "https://beautycounter-qa.myshopify.com", "https://beautycounter-dev1.cdmdockers.mystableserver.com", "https://beautycounter-dev2.cdmdockers.mystableserver.com", "https://beautycounter-qa.cdmdockers.mystableserver.com", "https://beautycounter-direct.azurewebsites.net", "https://www.track1099.com", "https://counter-drafts.myshopify.com", "https://g2g-counter.myshopify.com", "https://counter.com", "https://www.counter.com" ];
                        if (!trustedOrigins.includes(event.origin)) {
                            console.error("Untrusted origin:", event.origin);
                            return;
                        }
                        if (event.data.name === "complete") {
                            _this_1.setCompleted();
                            _this_1.taxFormComplete();
                            _this_1.markTaxFormCompleted();
                        }
                        if (event.data.name === "cancel") {}
                    });
                });
            };
            _this_1.setTaxFormCompleteOnPageLoad = function() {
                var taxFormPayment = window.customerTaxForm;
                if (taxFormPayment) {
                    _this_1.setCompleted();
                }
            };
            _this_1.handleReferralFlow = function() {
                var referralCode = _this_1.getCookie("ref");
                if (referralCode) {
                    var referralRequest = {
                        refCode: referralCode
                    };
                    var referralInfoBox_1 = document.querySelector(".bc_seller_enrollment_info_box_JS");
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["customer"]["getReferralName"],
                            method: "patch",
                            contentType: "json",
                            data: referralRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {
                                        referralInfoBox_1 === null || referralInfoBox_1 === void 0 ? void 0 : referralInfoBox_1.classList.remove("st_hidden");
                                        var injectValueEl = document.querySelector(".bc_seller_enrollment_referral_value_JS");
                                        if (injectValueEl) {
                                            injectValueEl.innerHTML = submitResponse.data.referralName;
                                        }
                                    } else if (submitResponse.status === 400) {
                                        referralInfoBox_1 === null || referralInfoBox_1 === void 0 ? void 0 : referralInfoBox_1.classList.add("st_hidden");
                                    } else {
                                        referralInfoBox_1 === null || referralInfoBox_1 === void 0 ? void 0 : referralInfoBox_1.classList.add("st_hidden");
                                    }
                                } catch (error) {
                                    referralInfoBox_1 === null || referralInfoBox_1 === void 0 ? void 0 : referralInfoBox_1.classList.add("st_hidden");
                                    console.error("Response error -------\x3e", error);
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                } else {
                    var referralInfoBox = document.querySelector(".bc_seller_enrollment_info_box_JS");
                    if (referralInfoBox) {
                        referralInfoBox.classList.add("st_hidden");
                    }
                }
            };
            _this_1.backToFirstStep = function() {
                var _this = _this_1;
                var backButton = document.querySelector(".bc_seller_enrollment_back_to_first_step_JS");
                if (backButton) {
                    backButton.addEventListener("click", function() {
                        var secondStep = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepTwo);
                        secondStep === null || secondStep === void 0 ? void 0 : secondStep.classList.add("st_hidden");
                        var firstStep = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepOne);
                        firstStep === null || firstStep === void 0 ? void 0 : firstStep.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.backToSecondStep = function() {
                var _this = _this_1;
                var backButton = document.querySelector(".bc_seller_enrollment_back_to_second_step_JS");
                if (backButton) {
                    backButton.addEventListener("click", function() {
                        var secondStep = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepTwo);
                        secondStep === null || secondStep === void 0 ? void 0 : secondStep.classList.remove("st_hidden");
                        var thirdStep = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepThree);
                        thirdStep === null || thirdStep === void 0 ? void 0 : thirdStep.classList.add("st_hidden");
                    });
                }
            };
            _this_1.setCompleted = function() {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnWrapper) {
                    var button = columnWrapper.querySelector(".bc_seller_enrollment_tax_form_button_JS");
                    var originalText = button.querySelector(".bc_tax_form_original_text_JS");
                    var completedText = button.querySelector(".bc_tax_form_completed_text_JS");
                    button.classList.add("active");
                    originalText.classList.add("st_hidden");
                    completedText.classList.remove("st_hidden");
                }
            };
            _this_1.taxFormComplete = function() {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnWrapper) {
                    var termsAndConditions = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentTermsAndConditionsButton);
                    var paymentInfoButton = columnWrapper.querySelector(_this_1.classConfig.selectorAddPaymentInfoButton);
                    var approvedContent_1 = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                    var sellerEnrollmentCompletedPage_1 = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentCompletedPage);
                    var loader_1 = columnWrapper.querySelector(".st_loader");
                    if (termsAndConditions.classList.contains("active") && paymentInfoButton.classList.contains("active")) {
                        loader_1.classList.remove("st_hidden");
                        approvedContent_1.classList.add("st_hidden");
                        var customerEmail = columnWrapper.getAttribute("data-customer-email");
                        var emailRequest = {
                            email: customerEmail
                        };
                        try {
                            _this_1.ajax.send({
                                endpoint: _this_1.endpoint["enrollment"]["completeEnrollment"],
                                method: "patch",
                                contentType: "json",
                                data: emailRequest,
                                callback: function(response) {
                                    try {
                                        var submitResponse = JSON.parse(response.response);
                                        if (submitResponse.status === 200) {
                                            sellerEnrollmentCompletedPage_1.classList.remove("st_hidden");
                                            loader_1.classList.add("st_hidden");
                                            setTimeout(function() {
                                                window.location.pathname = "/pages/brand-partner-dashboard";
                                            }, 5e3);
                                        } else if (submitResponse.status === 400) {
                                            sellerEnrollmentCompletedPage_1.classList.add("st_hidden");
                                            loader_1.classList.add("st_hidden");
                                            approvedContent_1.classList.remove("st_hidden");
                                        } else {
                                            sellerEnrollmentCompletedPage_1.classList.add("st_hidden");
                                            loader_1.classList.add("st_hidden");
                                            approvedContent_1.classList.remove("st_hidden");
                                        }
                                    } catch (error) {
                                        sellerEnrollmentCompletedPage_1.classList.add("st_hidden");
                                        loader_1.classList.add("st_hidden");
                                        approvedContent_1.classList.remove("st_hidden");
                                    }
                                }
                            });
                        } catch (error) {
                            console.error("Request error ---------\x3e", error);
                        }
                    }
                }
            };
            _this_1.markTaxFormCompleted = function() {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnWrapper) {
                    var customerEmail = columnWrapper.getAttribute("data-customer-email");
                    var markTermsAndConditionsRequest = {
                        email: customerEmail
                    };
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["markTaxFormAsCompleted"],
                            method: "patch",
                            contentType: "json",
                            data: markTermsAndConditionsRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {}
                                } catch (error) {
                                    console.error(error);
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                }
            };
            _this_1.showAppropriateContentOnPageLoad = function() {
                var customerTags = window.customerTags;
                _this_1.showSellerEnrollmentContentOnPageLoad(customerTags.includes("bp_approved"), customerTags.includes("bp_pending"), customerTags.includes("bp_completed"), customerTags.includes("bp_blocked"));
            };
            _this_1.handleShowTaxFormClick = function() {
                var _this = _this_1;
                var uploadTaxFormButton = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentTaxFormButton);
                if (uploadTaxFormButton) {
                    uploadTaxFormButton.addEventListener("click", function() {
                        var previousPage = document.querySelector(".bc_seller_enrollment_column--wrapper_JS");
                        var formPage = document.querySelector(".bc_seller_enrollment_tax_form_wrapper_JS");
                        previousPage === null || previousPage === void 0 ? void 0 : previousPage.classList.add("st_hidden");
                        formPage === null || formPage === void 0 ? void 0 : formPage.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.handleBackFromTermsAndConditions = function() {
                var _this = _this_1;
                var backFromTermsAndConditions = document.querySelector(".bc_seller_enrollment_back_from_terms_and_conditions_JS");
                if (backFromTermsAndConditions) {
                    backFromTermsAndConditions.addEventListener("click", function() {
                        var termsAndConditionsWrapper = document.querySelector(_this.classConfig.selectorTermsAndConditionsWrapper);
                        termsAndConditionsWrapper === null || termsAndConditionsWrapper === void 0 ? void 0 : termsAndConditionsWrapper.classList.add("st_hidden");
                        var columnWrapper = document.querySelector(_this.classConfig.selectorColumnsWrapper);
                        if (columnWrapper) {
                            columnWrapper.classList.remove("st_hidden");
                            _this.generalMethods.scrollTo(columnWrapper, 500);
                        }
                    });
                }
            };
            _this_1.handleTermsAndConditionsCheckboxClick = function() {
                var _this = _this_1;
                var termsAndConditionsCheckbox = document.querySelector(".bc_terms_and_conditions_checkbox_JS");
                if (termsAndConditionsCheckbox) {
                    termsAndConditionsCheckbox.addEventListener("click", function() {
                        !this.hasAttribute("checked") ? this.setAttribute("checked", "checked") : this.removeAttribute("checked");
                        var agreeToTermsAndConditionsButton = document.querySelector(_this.classConfig.selectorAcceptTermsAndConditionsButton);
                        agreeToTermsAndConditionsButton && !this.hasAttribute("checked") ? agreeToTermsAndConditionsButton.setAttribute("disabled", "disabled") : agreeToTermsAndConditionsButton.removeAttribute("disabled");
                    });
                }
            };
            _this_1.backFromTaxForm = function() {
                var backButton = document.querySelector(_this_1.classConfig.selectorTaxFormBackButton);
                if (backButton) {
                    backButton.addEventListener("click", function() {
                        var previousPage = document.querySelector(".bc_seller_enrollment_column--wrapper_JS");
                        var formPage = document.querySelector(".bc_seller_enrollment_tax_form_wrapper_JS");
                        previousPage === null || previousPage === void 0 ? void 0 : previousPage.classList.remove("st_hidden");
                        formPage === null || formPage === void 0 ? void 0 : formPage.classList.add("st_hidden");
                    });
                }
            };
            _this_1.handleRadioButtonCLick = function() {
                var _this = _this_1;
                var radioButtonsLabel = document.querySelectorAll(_this_1.classConfig.selectorRadioButtonLabel);
                if (radioButtonsLabel && radioButtonsLabel.length > 0) {
                    radioButtonsLabel.forEach(function(label) {
                        label.addEventListener("click", function() {
                            var closestButtonWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameRadioButtonWrapper);
                            if (closestButtonWrapper.classList.contains("active")) {
                                return;
                            }
                            var radioButtonsWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameRadioButtonsWrapper);
                            _this.removeActiveState(radioButtonsWrapper);
                            closestButtonWrapper.classList.add("active");
                            var currentInput = closestButtonWrapper.querySelector(_this.classConfig.selectorRadioButtonInput);
                            currentInput.setAttribute("checked", "checked");
                            _this.toggleApplicationButtonHandle(this);
                        });
                    });
                }
            };
            _this_1.countryRadioButtonClickHandle = function() {
                var _this = _this_1;
                var radioButtons = document.querySelectorAll(_this_1.classConfig.selectorCountryRadioLabel);
                if (radioButtons && radioButtons.length > 0) {
                    radioButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var selectedButton = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameCountryButtonWrapper);
                            if (selectedButton.classList.contains("active")) {
                                return;
                            }
                            var selectedInput = selectedButton.querySelector(".bc_radio_county_input_JS");
                            var buttonsWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameCountryButtonsWrapper);
                            var previousActiveEl = buttonsWrapper.querySelector(".active");
                            previousActiveEl === null || previousActiveEl === void 0 ? void 0 : previousActiveEl.classList.remove("active");
                            var previousActiveInput = buttonsWrapper.querySelector('.bc_radio_county_input_JS[checked="checked"]');
                            previousActiveInput === null || previousActiveInput === void 0 ? void 0 : previousActiveInput.removeAttribute("checked");
                            selectedButton.classList.add("active");
                            selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.setAttribute("checked", "checked");
                        });
                    });
                }
            };
            _this_1.handleStartApplicationClick = function() {
                var _this = _this_1;
                var startApplicationButton = document.querySelector(_this_1.classConfig.selectorStartApplicationButton);
                if (startApplicationButton) {
                    startApplicationButton.addEventListener("click", function(e) {
                        var sellerDashboardStepOne = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepOne);
                        if (sellerDashboardStepOne) {
                            sellerDashboardStepOne.classList.add("st_hidden");
                            var sellerDashboardStepTwo = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepTwo);
                            sellerDashboardStepTwo === null || sellerDashboardStepTwo === void 0 ? void 0 : sellerDashboardStepTwo.classList.remove("st_hidden");
                        }
                    });
                }
            };
            _this_1.handleAddCredentialsClick = function() {
                var _this = _this_1;
                var addSocialsButton = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentAddSocialsButton);
                if (addSocialsButton) {
                    addSocialsButton.addEventListener("click", function() {
                        var credentialsWrapper = document.querySelector(_this.classConfig.selectorSellerEnrollmentCredentialsWrapper);
                        var errorMessage = credentialsWrapper.querySelector(".bc_error_message");
                        if (errorMessage) {
                            errorMessage.remove();
                        }
                        if (credentialsWrapper) {
                            var firstNameInput = credentialsWrapper.querySelector(_this.classConfig.selectorFirstNameInput);
                            var lastNameInput = credentialsWrapper.querySelector(_this.classConfig.selectorLastNameInput);
                            if (firstNameInput && firstNameInput.value.trim() !== "" && lastNameInput && lastNameInput.value.trim() !== "") {
                                var sellerDashboardStepTwo = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepTwo);
                                sellerDashboardStepTwo === null || sellerDashboardStepTwo === void 0 ? void 0 : sellerDashboardStepTwo.classList.add("st_hidden");
                                var sellerDashboardStepThree = document.querySelector(_this.classConfig.selectorSellerEnrollmentStepThree);
                                sellerDashboardStepThree.classList.remove("st_hidden");
                            } else {
                                var errorMessage_1 = document.createElement("div");
                                errorMessage_1.classList.add("bc_error_message");
                                errorMessage_1.innerHTML = "Please fill out your First and Last name.";
                                credentialsWrapper.appendChild(errorMessage_1);
                            }
                        }
                    });
                }
            };
            _this_1.handleSubmitEnrollmentForm = function() {
                var _this = _this_1;
                var submitButton = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentSubmitButton);
                if (submitButton) {
                    submitButton.addEventListener("click", function() {
                        _this.buttonActions.prevent(this);
                        var submitDataRequest = _this.handleSellerDashboardRequest();
                        _this.sellerDashboardSubmitData(submitDataRequest, this);
                    });
                }
            };
            _this_1.handleSellerDashboardRequest = function() {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                var customerEmail = columnWrapper === null || columnWrapper === void 0 ? void 0 : columnWrapper.getAttribute("data-customer-email");
                var cookie = _this_1.getCookie("ref");
                var submitDataRequest = {
                    email: customerEmail,
                    first_name: _this_1.prepareDataForSubmit().firstNameValue,
                    last_name: _this_1.prepareDataForSubmit().lastNameValue,
                    instagram: _this_1.prepareDataForSubmit().instagramValue,
                    tiktok: _this_1.prepareDataForSubmit().tiktokValue,
                    youtube: _this_1.prepareDataForSubmit().youtubeValue,
                    twitter: _this_1.prepareDataForSubmit().twitterValue,
                    country: _this_1.prepareDataForSubmit().countryValue,
                    ref: cookie
                };
                return submitDataRequest;
            };
            _this_1.getCookie = function(name) {
                var cookies = document.cookie.split("; ");
                for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
                    var cookie = cookies_1[_i];
                    var _a = cookie.split("="), key = _a[0], value = _a[1];
                    if (key === name) return decodeURIComponent(value);
                }
                return null;
            };
            _this_1.prepareDataForSubmit = function() {
                var credentialsWrapper = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentCredentialsWrapper);
                var firstName = credentialsWrapper.querySelector(_this_1.classConfig.selectorFirstNameInput);
                var lastName = credentialsWrapper.querySelector(_this_1.classConfig.selectorLastNameInput);
                var firstNameValue = firstName.value;
                var lastNameValue = lastName.value;
                var selectCountryWrapper = document.querySelector(_this_1.classConfig.selectorSelectCountryWrapper);
                var selectedCountry = selectCountryWrapper.querySelector('.bc_radio_county_input_JS[checked="checked"]');
                var countryValue = selectedCountry.getAttribute("value");
                var socialsWrapper = document.querySelector(_this_1.classConfig.selectorSocialsWrapper);
                var instagramEl = socialsWrapper.querySelector(_this_1.classConfig.selectorInstagramInput);
                var tiktokEl = socialsWrapper.querySelector(_this_1.classConfig.selectorTiktokInput);
                var youtubeEl = socialsWrapper.querySelector(_this_1.classConfig.selectorYoutubeInput);
                var twitterEl = socialsWrapper.querySelector(_this_1.classConfig.selectorTwitterInput);
                var instagramValue = instagramEl.value;
                var tiktokValue = tiktokEl.value;
                var youtubeValue = youtubeEl.value;
                var twitterValue = twitterEl.value;
                return {
                    firstNameValue: firstNameValue,
                    lastNameValue: lastNameValue,
                    instagramValue: instagramValue,
                    tiktokValue: tiktokValue,
                    youtubeValue: youtubeValue,
                    twitterValue: twitterValue,
                    countryValue: countryValue
                };
            };
            _this_1.sellerDashboardSubmitData = function(submitDataRequest, button) {
                var _this = _this_1;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["enrollment"]["createAffiliate"],
                        method: "post",
                        contentType: "json",
                        data: submitDataRequest,
                        callback: function(response) {
                            try {
                                var submitResponse = JSON.parse(response.response);
                                if (submitResponse.status === 200) {
                                    var customerTags = window.customerTags;
                                    if (customerTags.includes("founder") || customerTags.includes("FOUNDER")) {
                                        location.reload();
                                    } else {
                                        location.reload();
                                    }
                                    _this.buttonActions.allow(button);
                                } else if (submitResponse.status === 400) {
                                    _this.buttonActions.allow(button);
                                } else {
                                    _this.buttonActions.allow(button);
                                }
                            } catch (error) {
                                _this.buttonActions.allow(button);
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    _this.buttonActions.allow(button);
                    console.error("Request error ---------\x3e", error);
                }
            };
            _this_1.showSellerEnrollmentContentOnPageLoad = function(BP_APPROVED, BP_PENDING, BP_COMPLETED, BP_BLOCKED) {
                var columnRight = document.querySelector(_this_1.classConfig.selectorColumnRight);
                if (columnRight) {
                    var sellerEnrollmentStepOne = columnRight.querySelector(_this_1.classConfig.selectorSellerEnrollmentStepOne);
                    var sellerEnrollmentApprovedContent = columnRight.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                    var sellerEnrollmentThankYouPage = columnRight.querySelector(_this_1.classConfig.selectorSellerEnrollmentThankYouPage);
                    var sellerEnrollmentRejectPage = columnRight.querySelector(_this_1.classConfig.selectorSellerEnrollmentRejectPage);
                    var sellerEnrollmentCompletedPage = columnRight.querySelector(_this_1.classConfig.selectorSellerEnrollmentCompletedPage);
                    var loader = columnRight.querySelector(".st_loader");
                    loader.classList.add("st_hidden");
                    if (BP_COMPLETED) {
                        sellerEnrollmentCompletedPage.classList.remove("st_hidden");
                        return;
                    } else if (BP_APPROVED || BP_PENDING && !BP_COMPLETED) {
                        sellerEnrollmentApprovedContent.classList.remove("st_hidden");
                    } else if (BP_PENDING) {} else if (BP_BLOCKED) {
                        sellerEnrollmentRejectPage.classList.remove("st_hidden");
                    } else {
                        sellerEnrollmentStepOne.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.showSecondPartOfEnrollmentProcess = function() {
                var sellerDashboardStepThree = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentStepThree);
                sellerDashboardStepThree === null || sellerDashboardStepThree === void 0 ? void 0 : sellerDashboardStepThree.classList.add("st_hidden");
                var sellerEnrollmentApprovedContent = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                sellerEnrollmentApprovedContent === null || sellerEnrollmentApprovedContent === void 0 ? void 0 : sellerEnrollmentApprovedContent.classList.remove("st_hidden");
            };
            _this_1.showCompletedFirstPartOfEnrollmentPage = function() {
                var sellerDashboardStepThree = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentStepThree);
                sellerDashboardStepThree === null || sellerDashboardStepThree === void 0 ? void 0 : sellerDashboardStepThree.classList.add("st_hidden");
                var sellerEnrollmentThankYouPage = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentThankYouPage);
                sellerEnrollmentThankYouPage === null || sellerEnrollmentThankYouPage === void 0 ? void 0 : sellerEnrollmentThankYouPage.classList.remove("st_hidden");
            };
            _this_1.removeActiveState = function(radioButtonsWrapper) {
                var activeEl = radioButtonsWrapper.querySelector(".active");
                var activeInput = radioButtonsWrapper.querySelector('input[checked="checked"]');
                activeEl === null || activeEl === void 0 ? void 0 : activeEl.classList.remove("active");
                activeInput === null || activeInput === void 0 ? void 0 : activeInput.removeAttribute("checked");
            };
            _this_1.toggleApplicationButtonHandle = function(label) {
                var startApplicationButton = document.querySelector(_this_1.classConfig.selectorStartApplicationButton);
                if (startApplicationButton) {
                    _this_1.toggleApplicationButtonState(label.htmlFor, startApplicationButton);
                } else {
                    console.error("Start application button not found, skipping enrollment process.");
                }
            };
            _this_1.toggleApplicationButtonState = function(label, button) {
                if (label === "under_18") {
                    button.setAttribute("disabled", "disabled");
                } else {
                    button.removeAttribute("disabled");
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StSellerEnrollment;
    }(st_module_11.StModule);
    exports.StSellerEnrollment = StSellerEnrollment;
});

define("extension/shopify-app/st-modules/seller-enrollment/validation-us-utils", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.validateUSRoutingNumber = exports.validateUSAccountNumber = exports.validateUSAccountName = void 0;
    function t(key) {
        var _a;
        return ((_a = window.stTranslations) === null || _a === void 0 ? void 0 : _a[key]) || key;
    }
    function validateUSAccountName(name) {
        var trimmed = name.trim();
        if (trimmed.length < 2 || trimmed.length > 22) return t("extension.seller_enrollment.validation.name_range");
        if (!/^[a-zA-Z0-9 ]+$/.test(trimmed)) return t("extension.seller_enrollment.validation.name_allowed");
        return null;
    }
    exports.validateUSAccountName = validateUSAccountName;
    function validateUSAccountNumber(accountNumber) {
        var trimmed = accountNumber.trim();
        if (accountNumber !== trimmed || /\s/.test(trimmed)) {
            return t("extension.seller_enrollment.validation.account_number_no_spaces");
        }
        if (trimmed === "") {
            return t("extension.seller_enrollment.validation.account_number_required");
        }
        if (!/^\d+$/.test(trimmed)) {
            return t("extension.seller_enrollment.validation.account_number_digits");
        }
        if (trimmed.length < 4 || trimmed.length > 17) {
            return t("extension.seller_enrollment.validation.account_number_range");
        }
        return null;
    }
    exports.validateUSAccountNumber = validateUSAccountNumber;
    function validateUSRoutingNumber(routing) {
        var cleaned = routing.replace(/[^\d]/g, "").trim();
        if (cleaned.length !== 9) {
            return t("extension.seller_enrollment.validation.routing_format");
        }
        var digits = cleaned.split("").map(Number);
        var checksum = 3 * (digits[0] + digits[3] + digits[6]) + 7 * (digits[1] + digits[4] + digits[7]) + (digits[2] + digits[5] + digits[8]);
        if (checksum % 10 !== 0) {
            return t("extension.seller_enrollment.validation.routing_checksum_invalid");
        }
        return null;
    }
    exports.validateUSRoutingNumber = validateUSRoutingNumber;
});

define("extension/shopify-app/st-modules/seller-enrollment/validation-ca-utils", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.validateCABranchCode = exports.validateCAAccountNumber = void 0;
    function t(key) {
        var _a;
        return ((_a = window.stTranslations) === null || _a === void 0 ? void 0 : _a[key]) || key;
    }
    function validateCAAccountNumber(accountNumber) {
        var trimmed = accountNumber.trim();
        if (trimmed === "") {
            return t("extension.seller_enrollment.validation.account_number_required");
        }
        if (accountNumber !== trimmed || /\s/.test(trimmed)) {
            return t("extension.seller_enrollment.validation.account_number_no_spaces");
        }
        if (!/^\d+$/.test(trimmed)) {
            return t("extension.seller_enrollment.validation.account_number_digits");
        }
        if (trimmed.length < 7) {
            return t("extension.seller_enrollment.validation.ca_account_number_min");
        }
        if (trimmed.length > 12) {
            return t("extension.seller_enrollment.validation.ca_account_number_max");
        }
        return null;
    }
    exports.validateCAAccountNumber = validateCAAccountNumber;
    function validateCABranchCode(branchCode) {
        if (!/^\d{5}$/.test(branchCode)) return t("extension.seller_enrollment.validation.ca_branch_format");
        return null;
    }
    exports.validateCABranchCode = validateCABranchCode;
});

define("extension/shopify-app/st-modules/seller-enrollment/seller-enrollment-approved", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "extension/shopify-app/st-modules/seller-enrollment/validation-us-utils", "extension/shopify-app/st-modules/seller-enrollment/validation-ca-utils" ], function(require, exports, st_module_12, validation_us_utils_1, validation_ca_utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerEnrollmentApproved = void 0;
    var StSellerEnrollmentApproved = function(_super) {
        __extends(StSellerEnrollmentApproved, _super);
        function StSellerEnrollmentApproved(classConfig, generalMethods, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerEnrollmentApproved";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleTermsAndConditionsClick();
                    _this_1.handleAcceptTermsAndConditionsClick();
                    _this_1.handleOpenPaymentInfoPopup();
                    _this_1.handleClosePaymentPopupClick();
                    _this_1.handleSubmitPaymentInfoClick();
                    _this_1.setTermsAndConditionsOnPageLoad();
                    _this_1.setPaymentInfoOnPageLoad();
                    _this_1.failSafeCompletedEnrollment();
                });
            };
            _this_1.setTermsAndConditionsOnPageLoad = function() {
                var termsAndConditions = window.customerTermsAndConditions;
                if (termsAndConditions) {
                    _this_1.changeTermsAndConditionButtonText();
                }
            };
            _this_1.setPaymentInfoOnPageLoad = function() {
                var customerPaymentInfo = window.customerPaymentInfo;
                if (customerPaymentInfo) {
                    var addPaymentInfoButton = document.querySelector(_this_1.classConfig.selectorAddPaymentInfoButton);
                    var originalTextEl = addPaymentInfoButton === null || addPaymentInfoButton === void 0 ? void 0 : addPaymentInfoButton.querySelector(_this_1.classConfig.selectorNotCompletedStep);
                    var completedTextEl = addPaymentInfoButton === null || addPaymentInfoButton === void 0 ? void 0 : addPaymentInfoButton.querySelector(_this_1.classConfig.selectorCompletedStep);
                    addPaymentInfoButton === null || addPaymentInfoButton === void 0 ? void 0 : addPaymentInfoButton.classList.add("active");
                    originalTextEl === null || originalTextEl === void 0 ? void 0 : originalTextEl.classList.add("st_hidden");
                    completedTextEl === null || completedTextEl === void 0 ? void 0 : completedTextEl.classList.remove("st_hidden");
                }
            };
            _this_1.handleTermsAndConditionsClick = function() {
                var _this = _this_1;
                var termsAndConditionsButton = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentTermsAndConditionsButton);
                if (termsAndConditionsButton) {
                    termsAndConditionsButton.addEventListener("click", function() {
                        if (this.classList.contains("active")) {
                            return;
                        }
                        _this.hideApprovedContent();
                        _this.showTermsAndConditions();
                    });
                }
            };
            _this_1.resetPaymentInfoFields = function() {
                var formWrapper = document.querySelector(_this_1.classConfig.selectorPaymentInfoContent);
                if (formWrapper) {
                    var inputs = formWrapper.querySelectorAll(".bc_reset_input_field_JS");
                    if (inputs && inputs.length > 0) {
                        inputs.forEach(function(input) {
                            input.value = "";
                        });
                    }
                    var selectFields = formWrapper.querySelectorAll(".bc_reset_select_field_JS");
                    if (selectFields && selectFields.length > 0) {
                        selectFields.forEach(function(select) {
                            select.selectedIndex = 0;
                        });
                    }
                    _this_1.removeErrorsFromPreviousSubmit(formWrapper);
                }
            };
            _this_1.handleAcceptTermsAndConditionsClick = function() {
                var _this = _this_1;
                var acceptTermsAndConditionsButton = document.querySelector(_this_1.classConfig.selectorAcceptTermsAndConditionsButton);
                if (acceptTermsAndConditionsButton) {
                    acceptTermsAndConditionsButton.addEventListener("click", function() {
                        _this.showApprovedContent();
                        _this.hideTermsAndConditions();
                        _this.changeTermsAndConditionButtonText();
                        var columnsWrapper = document.querySelector(_this.classConfig.selectorColumnsWrapper);
                        if (columnsWrapper) {
                            _this.generalMethods.scrollTo(columnsWrapper, 500);
                        }
                        _this.markTermsAndConditionsCompleted();
                        _this.checkIfEnrollmentCompleted(true);
                    });
                }
            };
            _this_1.markTermsAndConditionsCompleted = function() {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnWrapper) {
                    var customerEmail = columnWrapper.getAttribute("data-customer-email");
                    var markTermsAndConditionsRequest = {
                        email: customerEmail
                    };
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["signTermsAndConditions"],
                            method: "patch",
                            contentType: "json",
                            data: markTermsAndConditionsRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {}
                                } catch (error) {
                                    console.error(error);
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                }
            };
            _this_1.failSafeCompletedEnrollment = function() {
                var termsAndConditions = window.customerTermsAndConditions;
                var paymentInfo = window.customerPaymentInfo;
                var taxForm = window.customerTaxForm;
                var customerTags = window.customerTags;
                if (termsAndConditions && paymentInfo && taxForm && !customerTags.includes("bp_completed")) {
                    var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                    var approvedContent_2 = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                    var sellerEnrollmentCompletedPage_2 = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentCompletedPage);
                    approvedContent_2.classList.add("st_hidden");
                    var customerEmail = columnWrapper.getAttribute("data-customer-email");
                    var emailRequest = {
                        email: customerEmail
                    };
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["completeEnrollment"],
                            method: "patch",
                            contentType: "json",
                            data: emailRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {
                                        sellerEnrollmentCompletedPage_2.classList.remove("st_hidden");
                                        setTimeout(function() {
                                            window.location.pathname = "/pages/brand-partner-dashboard";
                                        }, 5e3);
                                    } else if (submitResponse.status === 400) {
                                        sellerEnrollmentCompletedPage_2.classList.add("st_hidden");
                                        approvedContent_2.classList.remove("st_hidden");
                                    } else {
                                        sellerEnrollmentCompletedPage_2.classList.add("st_hidden");
                                        approvedContent_2.classList.remove("st_hidden");
                                    }
                                } catch (error) {
                                    sellerEnrollmentCompletedPage_2.classList.add("st_hidden");
                                    approvedContent_2.classList.remove("st_hidden");
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                }
            };
            _this_1.handleOpenPaymentInfoPopup = function() {
                var _this = _this_1;
                var addPaymentInfoButton = document.querySelector(_this_1.classConfig.selectorAddPaymentInfoButton);
                if (addPaymentInfoButton) {
                    addPaymentInfoButton.addEventListener("click", function() {
                        _this.openPaymentInfoPopup();
                        _this.resetPaymentInfoFields();
                        _this.attachRealtimeValidationListeners();
                        document.body.style.overflow = "hidden";
                    });
                }
            };
            _this_1.handleClosePaymentPopupClick = function() {
                var _this = _this_1;
                var closePopupButton = document.querySelector(_this_1.classConfig.selectorCancelPaymentButton);
                if (closePopupButton) {
                    closePopupButton.addEventListener("click", function() {
                        _this.closePaymentInfoPopup();
                        document.body.style.overflow = "visible";
                    });
                }
                var overlayEl = document.querySelector(_this_1.classConfig.selectorPaymentInfoOverlay);
                if (overlayEl) {
                    overlayEl.addEventListener("click", function() {
                        _this.closePaymentInfoPopup();
                        document.body.style.overflow = "visible";
                    });
                }
            };
            _this_1.attachRealtimeValidationListeners = function() {
                var _a;
                var form = document.querySelector(_this_1.classConfig.selectorPaymentInfoContent);
                if (!form) return;
                var accountNameEl = form.querySelector(_this_1.classConfig.selectorAccountNameField);
                var accountNumberEl = form.querySelector(_this_1.classConfig.selectorAccountNumberField);
                var repeatAccountNumberEl = form.querySelector(_this_1.classConfig.selectorRepeatAccountNumberField);
                var branchCodeEl = form.querySelector(_this_1.classConfig.selectorBranchCodeField);
                if (accountNameEl && ((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("usa"))) {
                    accountNameEl.addEventListener("input", function() {
                        var error = (0, validation_us_utils_1.validateUSAccountName)(accountNameEl.value);
                        var existingError = accountNameEl.parentElement.querySelector(".bc_error_message");
                        if (error) {
                            accountNameEl.classList.add("error");
                            if (!existingError) {
                                var msg = document.createElement("div");
                                msg.classList.add("bc_error_message");
                                msg.innerHTML = error;
                                accountNameEl.parentElement.appendChild(msg);
                            }
                        } else {
                            accountNameEl.classList.remove("error");
                            existingError === null || existingError === void 0 ? void 0 : existingError.remove();
                        }
                    });
                }
                if (accountNumberEl) {
                    accountNumberEl.addEventListener("input", function() {
                        var _a;
                        var error = ((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("usa")) ? (0, 
                        validation_us_utils_1.validateUSAccountNumber)(accountNumberEl.value) : (0, 
                        validation_ca_utils_1.validateCAAccountNumber)(accountNumberEl.value);
                        var existingError = accountNumberEl.parentElement.querySelector(".bc_error_message");
                        if (existingError) {
                            existingError.remove();
                        }
                        if (error) {
                            accountNumberEl.classList.add("error");
                            var msg = document.createElement("div");
                            msg.classList.add("bc_error_message");
                            msg.innerHTML = error;
                            accountNumberEl.parentElement.appendChild(msg);
                        } else {
                            accountNumberEl.classList.remove("error");
                        }
                    });
                }
                if (branchCodeEl) {
                    branchCodeEl.addEventListener("input", function() {
                        var _a;
                        var error = ((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("usa")) ? (0, 
                        validation_us_utils_1.validateUSRoutingNumber)(branchCodeEl.value) : (0, 
                        validation_ca_utils_1.validateCABranchCode)(branchCodeEl.value);
                        var existingError = branchCodeEl.parentElement.querySelector(".bc_error_message");
                        if (existingError) {
                            existingError.remove();
                        }
                        if (error) {
                            branchCodeEl.classList.add("error");
                            var msg = document.createElement("div");
                            msg.classList.add("bc_error_message");
                            msg.innerHTML = error;
                            branchCodeEl.parentElement.appendChild(msg);
                        } else {
                            branchCodeEl.classList.remove("error");
                        }
                    });
                }
                if (repeatAccountNumberEl && accountNumberEl) {
                    repeatAccountNumberEl.addEventListener("input", function() {
                        var wrapper = repeatAccountNumberEl.closest(_this_1.classConfig.selectorRepeatAccountNumberWrapper);
                        var existingError = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".bc_repeat_account_number_error_JS");
                        if (repeatAccountNumberEl.value !== accountNumberEl.value) {
                            repeatAccountNumberEl.classList.add("error");
                            if (!existingError) {
                                _this_1.showRepeatAccountNumberErrorMessage(form);
                            }
                        } else {
                            repeatAccountNumberEl.classList.remove("error");
                            existingError === null || existingError === void 0 ? void 0 : existingError.remove();
                        }
                    });
                }
            };
            _this_1.handleSubmitPaymentInfoClick = function() {
                var _this = _this_1;
                var paymentInfoForm = document.querySelector(_this_1.classConfig.selectorPaymentInfoContent);
                if (paymentInfoForm) {
                    paymentInfoForm.addEventListener("submit", function(e) {
                        var _a, _b, _c, _d;
                        e.preventDefault();
                        var submitPaymentInfoButton = this.querySelector(_this.classConfig.selectorSubmitPaymentButton);
                        _this.buttonActions.prevent(submitPaymentInfoButton);
                        _this.removeErrorsFromPreviousSubmit(this);
                        var accountNumberInput = this.querySelector(_this.classConfig.selectorAccountNumberField);
                        var repeatAccountNumberInput = this.querySelector(_this.classConfig.selectorRepeatAccountNumberField);
                        if (accountNumberInput.value !== repeatAccountNumberInput.value) {
                            _this.showRepeatAccountNumberErrorMessage(this);
                            _this.buttonActions.allow(submitPaymentInfoButton);
                            _this.attachRealtimeValidationListeners();
                            return;
                        }
                        var preparedData = _this.paymentInformationPrepareDataForSubmit(this);
                        if (preparedData.paymentModeValue === "no_value_selected") {
                            _this.showPaymentModeErrorMessage(this);
                            _this.buttonActions.allow(submitPaymentInfoButton);
                            _this.attachRealtimeValidationListeners();
                            return;
                        }
                        if (preparedData.accountTypeValue === "no_value_selected") {
                            _this.showAccountTypeErrorMessage(this);
                            _this.buttonActions.allow(submitPaymentInfoButton);
                            _this.attachRealtimeValidationListeners();
                            return;
                        }
                        var hiddenBankInput = this.querySelector(".st_bank_hidden_input_JS");
                        var bankErrorEl = this.querySelector(".st_bank_error_message_JS");
                        if (((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("canada")) && !((_b = hiddenBankInput === null || hiddenBankInput === void 0 ? void 0 : hiddenBankInput.value) === null || _b === void 0 ? void 0 : _b.trim())) {
                            bankErrorEl === null || bankErrorEl === void 0 ? void 0 : bankErrorEl.classList.remove("st_hidden");
                            _this.buttonActions.allow(submitPaymentInfoButton);
                            _this.attachRealtimeValidationListeners();
                            return;
                        } else {
                            bankErrorEl === null || bankErrorEl === void 0 ? void 0 : bankErrorEl.classList.add("st_hidden");
                        }
                        var customerEmail = this.getAttribute("data-customer-email");
                        var paymentInformationRequest = {
                            email: customerEmail,
                            payment_method: preparedData.paymentModeValue,
                            payment_details: {
                                account_type: preparedData.accountTypeValue,
                                bank_name: preparedData.bankNameValue,
                                account_name: preparedData.accountNameValue,
                                account_number: preparedData.accountNumberValue,
                                branch_code: preparedData.branchCodeValue
                            }
                        };
                        var isValid = ((_c = window.customerTags) === null || _c === void 0 ? void 0 : _c.includes("usa")) ? _this.validateUSFields(paymentInfoForm, paymentInformationRequest.payment_details) : ((_d = window.customerTags) === null || _d === void 0 ? void 0 : _d.includes("canada")) ? _this.validateCAFields(paymentInfoForm, paymentInformationRequest.payment_details) : true;
                        if (!isValid) {
                            _this.buttonActions.allow(submitPaymentInfoButton);
                            _this.attachRealtimeValidationListeners();
                            return;
                        }
                        _this.sellerDashboardSubmitData(paymentInformationRequest, submitPaymentInfoButton);
                    });
                }
            };
            _this_1.removeErrorsFromPreviousSubmit = function(paymentInfoContent) {
                var paymentModeError = paymentInfoContent.querySelector(".bc_payment_mode_error_JS");
                if (paymentModeError) {
                    var paymentModeField = paymentInfoContent.querySelector(_this_1.classConfig.selectorPaymentModeField);
                    paymentModeField.classList.remove("error");
                    paymentModeError.remove();
                }
                var accountTypeError = paymentInfoContent.querySelector(".bc_account_type_error_JS");
                if (accountTypeError) {
                    var accountTypeField = paymentInfoContent.querySelector(_this_1.classConfig.selectorPaymentAccountTypeField);
                    accountTypeField.classList.remove("error");
                    accountTypeError.remove();
                }
                var repeatAccountNumberError = paymentInfoContent.querySelector(".bc_repeat_account_number_error_JS");
                if (repeatAccountNumberError) {
                    var repeatAccountNumberField = paymentInfoContent.querySelector(_this_1.classConfig.selectorRepeatAccountNumberField);
                    repeatAccountNumberField.classList.remove("error");
                    repeatAccountNumberError.remove();
                }
            };
            _this_1.showPaymentModeErrorMessage = function(paymentInfoContent) {
                var paymentModeWrapper = paymentInfoContent.querySelector(_this_1.classConfig.selectorPaymentModeWrapper);
                if (paymentModeWrapper) {
                    var paymentModeField = paymentModeWrapper.querySelector(_this_1.classConfig.selectorPaymentModeField);
                    paymentModeField.classList.add("error");
                    paymentModeWrapper.appendChild(_this_1.paymentModeNotSelected());
                }
            };
            _this_1.showAccountTypeErrorMessage = function(paymentInfoContent) {
                var accountTypeWrapper = paymentInfoContent.querySelector(_this_1.classConfig.selectorAccountTypeWrapper);
                if (accountTypeWrapper) {
                    var accountTypeField = accountTypeWrapper.querySelector(_this_1.classConfig.selectorPaymentAccountTypeField);
                    accountTypeField.classList.add("error");
                    accountTypeWrapper.appendChild(_this_1.accountTypeNotSelected());
                }
            };
            _this_1.showRepeatAccountNumberErrorMessage = function(paymentInfoContent) {
                var repeatAccountNumberWrapper = paymentInfoContent.querySelector(_this_1.classConfig.selectorRepeatAccountNumberWrapper);
                if (repeatAccountNumberWrapper) {
                    var repeatAccountNumberField = repeatAccountNumberWrapper.querySelector(_this_1.classConfig.selectorRepeatAccountNumberField);
                    repeatAccountNumberField.classList.add("error");
                    repeatAccountNumberWrapper.appendChild(_this_1.accountNumbersDontMatch());
                }
            };
            _this_1.paymentModeNotSelected = function() {
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_error_message", "bc_payment_mode_error_JS");
                errorMessage.innerHTML = "Please select Payment Mode.";
                return errorMessage;
            };
            _this_1.accountTypeNotSelected = function() {
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_error_message", "bc_account_type_error_JS");
                errorMessage.innerHTML = "Please select Account Type.";
                return errorMessage;
            };
            _this_1.accountNumbersDontMatch = function() {
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_error_message", "bc_repeat_account_number_error_JS");
                errorMessage.innerHTML = "Your Account Number is not matching.";
                return errorMessage;
            };
            _this_1.paymentInformationPrepareDataForSubmit = function(paymentInfoContent) {
                var _a, _b, _c, _d, _e;
                var paymentModeEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorPaymentModeField);
                var accountTypeEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorPaymentAccountTypeField);
                var bankNameEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorBankNameField);
                var accountNameEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorAccountNameField);
                var accountNumberEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorAccountNumberField);
                var branchCodeEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorBranchCodeField);
                var swiftNameEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorSwiftNameField);
                var caBankNameEl = paymentInfoContent.querySelector(".st_bank_hidden_input_JS");
                var usBankNameEl = paymentInfoContent.querySelector(".bc_bank_name_JS");
                var defaultBankNameEl = paymentInfoContent.querySelector(_this_1.classConfig.selectorBankNameField);
                var paymentModeValue = paymentModeEl.options[paymentModeEl.selectedIndex].value;
                var accountTypeValue = accountTypeEl.options[accountTypeEl.selectedIndex].value;
                var bankNameValue = "";
                if ((_a = window.customerTags) === null || _a === void 0 ? void 0 : _a.includes("canada")) {
                    bankNameValue = ((_b = caBankNameEl === null || caBankNameEl === void 0 ? void 0 : caBankNameEl.value) === null || _b === void 0 ? void 0 : _b.trim()) || "";
                } else if ((_c = window.customerTags) === null || _c === void 0 ? void 0 : _c.includes("usa")) {
                    bankNameValue = ((_d = usBankNameEl === null || usBankNameEl === void 0 ? void 0 : usBankNameEl.value) === null || _d === void 0 ? void 0 : _d.trim()) || "";
                } else {
                    bankNameValue = ((_e = defaultBankNameEl === null || defaultBankNameEl === void 0 ? void 0 : defaultBankNameEl.value) === null || _e === void 0 ? void 0 : _e.trim()) || "";
                }
                var accountNameValue = accountNameEl.value.trim();
                var accountNumberValue = accountNumberEl.value.trim();
                var branchCodeValue = branchCodeEl.value.trim();
                return {
                    paymentModeValue: paymentModeValue,
                    accountTypeValue: accountTypeValue,
                    bankNameValue: bankNameValue,
                    accountNameValue: accountNameValue,
                    accountNumberValue: accountNumberValue,
                    branchCodeValue: branchCodeValue
                };
            };
            _this_1.sellerDashboardSubmitData = function(submitDataRequest, paymentButton) {
                var _this = _this_1;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["enrollment"]["updateAffiliate"],
                        method: "patch",
                        contentType: "json",
                        data: submitDataRequest,
                        callback: function(response) {
                            try {
                                var submitResponse = JSON.parse(response.response);
                                if (submitResponse.status === 200) {
                                    var openPaymentPopup = document.querySelector(_this.classConfig.selectorAddPaymentInfoButton);
                                    var originalTextEl = openPaymentPopup === null || openPaymentPopup === void 0 ? void 0 : openPaymentPopup.querySelector(_this.classConfig.selectorNotCompletedStep);
                                    var completedTextEl = openPaymentPopup === null || openPaymentPopup === void 0 ? void 0 : openPaymentPopup.querySelector(_this.classConfig.selectorCompletedStep);
                                    originalTextEl === null || originalTextEl === void 0 ? void 0 : originalTextEl.classList.add("st_hidden");
                                    completedTextEl === null || completedTextEl === void 0 ? void 0 : completedTextEl.classList.remove("st_hidden");
                                    openPaymentPopup === null || openPaymentPopup === void 0 ? void 0 : openPaymentPopup.classList.add("active");
                                    _this.closePaymentInfoPopup();
                                    _this.buttonActions.allow(paymentButton);
                                    document.body.style.overflow = "visible";
                                    _this.checkIfEnrollmentCompleted(false, true);
                                } else if (submitResponse.status === 400) {
                                    _this.buttonActions.allow(paymentButton);
                                    _this.closePaymentInfoPopup();
                                    document.body.style.overflow = "visible";
                                } else {
                                    _this.buttonActions.allow(paymentButton);
                                    _this.closePaymentInfoPopup();
                                    document.body.style.overflow = "visible";
                                }
                            } catch (error) {
                                _this.buttonActions.allow(paymentButton);
                                _this.closePaymentInfoPopup();
                                document.body.style.overflow = "visible";
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    _this.buttonActions.allow(paymentButton);
                    _this.closePaymentInfoPopup();
                    document.body.style.overflow = "visible";
                    _this.buttonActions.allow(paymentButton);
                    console.error("Request error ---------\x3e", error);
                }
            };
            _this_1.checkIfEnrollmentCompleted = function(termsAndConditions, paymentInfo, taxForm) {
                var columnWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnWrapper) {
                    if (termsAndConditions) {
                        _this_1.termsAndConditionsClick(columnWrapper);
                    }
                    if (paymentInfo) {
                        _this_1.paymentInfoClick(columnWrapper);
                    }
                }
            };
            _this_1.termsAndConditionsClick = function(columnWrapper) {
                var paymentInfoButton = columnWrapper.querySelector(_this_1.classConfig.selectorAddPaymentInfoButton);
                var taxFormButton = columnWrapper.querySelector(_this_1.classConfig.selectorTaxFormButton);
                var approvedContent = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                var sellerEnrollmentCompletedPage = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentCompletedPage);
                var loader = columnWrapper.querySelector(".st_loader");
                if (paymentInfoButton.classList.contains("active") && taxFormButton.classList.contains("active")) {
                    loader.classList.remove("st_hidden");
                    approvedContent.classList.add("st_hidden");
                    var customerEmail = columnWrapper.getAttribute("data-customer-email");
                    var emailRequest = {
                        email: customerEmail
                    };
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["completeEnrollment"],
                            method: "patch",
                            contentType: "json",
                            data: emailRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {
                                        sellerEnrollmentCompletedPage.classList.remove("st_hidden");
                                        loader.classList.add("st_hidden");
                                        setTimeout(function() {
                                            window.location.pathname = "/pages/brand-partner-dashboard";
                                        }, 5e3);
                                    } else if (submitResponse.status === 400) {
                                        sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                        loader.classList.add("st_hidden");
                                        approvedContent.classList.remove("st_hidden");
                                    } else {
                                        sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                        loader.classList.add("st_hidden");
                                        approvedContent.classList.remove("st_hidden");
                                    }
                                } catch (error) {
                                    sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                    loader.classList.add("st_hidden");
                                    approvedContent.classList.remove("st_hidden");
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                }
            };
            _this_1.paymentInfoClick = function(columnWrapper) {
                var termsAndConditions = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentTermsAndConditionsButton);
                var taxFormButton = columnWrapper.querySelector(_this_1.classConfig.selectorTaxFormButton);
                var approvedContent = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentApprovedContent);
                var sellerEnrollmentCompletedPage = columnWrapper.querySelector(_this_1.classConfig.selectorSellerEnrollmentCompletedPage);
                var loader = columnWrapper.querySelector(".st_loader");
                if (termsAndConditions.classList.contains("active") && taxFormButton.classList.contains("active")) {
                    loader.classList.remove("st_hidden");
                    approvedContent.classList.add("st_hidden");
                    var customerEmail = columnWrapper.getAttribute("data-customer-email");
                    var emailRequest = {
                        email: customerEmail
                    };
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["completeEnrollment"],
                            method: "patch",
                            contentType: "json",
                            data: emailRequest,
                            callback: function(response) {
                                try {
                                    var submitResponse = JSON.parse(response.response);
                                    if (submitResponse.status === 200) {
                                        sellerEnrollmentCompletedPage.classList.remove("st_hidden");
                                        loader.classList.add("st_hidden");
                                        setTimeout(function() {
                                            window.location.pathname = "/pages/brand-partner-dashboard";
                                            console.log("timeout works");
                                        }, 5e3);
                                    } else if (submitResponse.status === 400) {
                                        sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                        loader.classList.add("st_hidden");
                                        approvedContent.classList.remove("st_hidden");
                                    } else {
                                        sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                        loader.classList.add("st_hidden");
                                        approvedContent.classList.remove("st_hidden");
                                    }
                                } catch (error) {
                                    sellerEnrollmentCompletedPage.classList.add("st_hidden");
                                    loader.classList.add("st_hidden");
                                    approvedContent.classList.remove("st_hidden");
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request error ---------\x3e", error);
                    }
                }
            };
            _this_1.openPaymentInfoPopup = function() {
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorPaymentInfoOverlay);
                var popupWrapper = document.querySelector(_this_1.classConfig.selectorPaymentInfoWrapper);
                popupOverlay === null || popupOverlay === void 0 ? void 0 : popupOverlay.classList.add("active");
                popupWrapper === null || popupWrapper === void 0 ? void 0 : popupWrapper.classList.add("active");
            };
            _this_1.closePaymentInfoPopup = function() {
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorPaymentInfoOverlay);
                var popupWrapper = document.querySelector(_this_1.classConfig.selectorPaymentInfoWrapper);
                popupOverlay === null || popupOverlay === void 0 ? void 0 : popupOverlay.classList.remove("active");
                popupWrapper === null || popupWrapper === void 0 ? void 0 : popupWrapper.classList.remove("active");
            };
            _this_1.hideApprovedContent = function() {
                var columnsWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnsWrapper) {
                    columnsWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showApprovedContent = function() {
                var columnsWrapper = document.querySelector(_this_1.classConfig.selectorColumnsWrapper);
                if (columnsWrapper) {
                    columnsWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.showTermsAndConditions = function() {
                var termsAndConditionsWrapper = document.querySelector(_this_1.classConfig.selectorTermsAndConditionsWrapper);
                if (termsAndConditionsWrapper) {
                    var customerTags = window.customerTags;
                    if (customerTags.includes("usa")) {
                        var termsAndConditions = termsAndConditionsWrapper.querySelector(".bc_terms_and_conditions_usa_JS");
                        termsAndConditions.classList.remove("st_hidden");
                    } else {
                        var termsAndConditions = termsAndConditionsWrapper.querySelector(".bc_terms_and_conditions_canada_JS");
                        termsAndConditions.classList.remove("st_hidden");
                    }
                    termsAndConditionsWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.hideTermsAndConditions = function() {
                var termsAndConditionsWrapper = document.querySelector(_this_1.classConfig.selectorTermsAndConditionsWrapper);
                if (termsAndConditionsWrapper) {
                    termsAndConditionsWrapper.classList.add("st_hidden");
                }
            };
            _this_1.changeTermsAndConditionButtonText = function() {
                var termsAndConditionsButton = document.querySelector(_this_1.classConfig.selectorSellerEnrollmentTermsAndConditionsButton);
                if (termsAndConditionsButton) {
                    termsAndConditionsButton.classList.add("active");
                    var completedStep = termsAndConditionsButton.querySelector(_this_1.classConfig.selectorCompletedStep);
                    if (completedStep) {
                        completedStep.classList.remove("st_hidden");
                    }
                    var originText = termsAndConditionsButton.querySelector(_this_1.classConfig.selectorNotCompletedStep);
                    if (originText) {
                        originText.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        StSellerEnrollmentApproved.prototype.validateUSFields = function(form, paymentDetails) {
            var account_name = paymentDetails.account_name, account_number = paymentDetails.account_number, branch_code = paymentDetails.branch_code;
            var nameError = (0, validation_us_utils_1.validateUSAccountName)(account_name);
            var numberError = (0, validation_us_utils_1.validateUSAccountNumber)(account_number);
            var routingError = (0, validation_us_utils_1.validateUSRoutingNumber)(branch_code);
            var accountNameEl = form.querySelector(this.classConfig.selectorAccountNameField);
            var existingNameError = accountNameEl.parentElement.querySelector(".bc_error_message");
            if (nameError) {
                accountNameEl.classList.add("error");
                if (!existingNameError) {
                    var msg = document.createElement("div");
                    msg.classList.add("bc_error_message");
                    msg.innerHTML = nameError;
                    accountNameEl.parentElement.appendChild(msg);
                }
            } else {
                accountNameEl.classList.remove("error");
                existingNameError === null || existingNameError === void 0 ? void 0 : existingNameError.remove();
            }
            var accountNumberEl = form.querySelector(this.classConfig.selectorAccountNumberField);
            var existingNumberError = accountNumberEl.parentElement.querySelector(".bc_error_message");
            if (numberError) {
                accountNumberEl.classList.add("error");
                if (!existingNumberError) {
                    var msg = document.createElement("div");
                    msg.classList.add("bc_error_message");
                    msg.innerHTML = numberError;
                    accountNumberEl.parentElement.appendChild(msg);
                }
            } else {
                accountNumberEl.classList.remove("error");
                existingNumberError === null || existingNumberError === void 0 ? void 0 : existingNumberError.remove();
            }
            var branchCodeEl = form.querySelector(this.classConfig.selectorBranchCodeField);
            var existingRoutingError = branchCodeEl.parentElement.querySelector(".bc_error_message");
            if (routingError) {
                branchCodeEl.classList.add("error");
                if (!existingRoutingError) {
                    var msg = document.createElement("div");
                    msg.classList.add("bc_error_message");
                    msg.innerHTML = routingError;
                    branchCodeEl.parentElement.appendChild(msg);
                }
            } else {
                branchCodeEl.classList.remove("error");
                existingRoutingError === null || existingRoutingError === void 0 ? void 0 : existingRoutingError.remove();
            }
            return !(nameError || numberError || routingError);
        };
        StSellerEnrollmentApproved.prototype.validateCAFields = function(form, paymentDetails) {
            var account_number = paymentDetails.account_number, branch_code = paymentDetails.branch_code;
            var numberError = (0, validation_ca_utils_1.validateCAAccountNumber)(account_number);
            var branchError = (0, validation_ca_utils_1.validateCABranchCode)(branch_code);
            var accountNumberEl = form.querySelector(this.classConfig.selectorAccountNumberField);
            var existingNumberError = accountNumberEl.parentElement.querySelector(".bc_error_message");
            if (numberError) {
                accountNumberEl.classList.add("error");
                if (!existingNumberError) {
                    var msg = document.createElement("div");
                    msg.classList.add("bc_error_message");
                    msg.innerHTML = numberError;
                    accountNumberEl.parentElement.appendChild(msg);
                }
            } else {
                accountNumberEl.classList.remove("error");
                existingNumberError === null || existingNumberError === void 0 ? void 0 : existingNumberError.remove();
            }
            var branchCodeEl = form.querySelector(this.classConfig.selectorBranchCodeField);
            var existingBranchError = branchCodeEl.parentElement.querySelector(".bc_error_message");
            if (branchError) {
                branchCodeEl.classList.add("error");
                if (!existingBranchError) {
                    var msg = document.createElement("div");
                    msg.classList.add("bc_error_message");
                    msg.innerHTML = branchError;
                    branchCodeEl.parentElement.appendChild(msg);
                }
            } else {
                branchCodeEl.classList.remove("error");
                existingBranchError === null || existingBranchError === void 0 ? void 0 : existingBranchError.remove();
            }
            return !(numberError || branchError);
        };
        return StSellerEnrollmentApproved;
    }(st_module_12.StModule);
    exports.StSellerEnrollmentApproved = StSellerEnrollmentApproved;
});

define("extension/shopify-app/st-modules/seller-dashboard/seller-dashboard-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardClassConfig = void 0;
    var StSellerDashboardClassConfig = function(_super) {
        __extends(StSellerDashboardClassConfig, _super);
        function StSellerDashboardClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SeSellerDashboardClassConfig";
            _this.classNameSellerDashboardPrimaryWrapper = "bc_seller_dashboard_primary--wrapper_JS";
            _this.selectorSellerDashboardPrimaryWrapper = "." + _this.classNameSellerDashboardPrimaryWrapper;
            _this.classNamePrimaryNavigationButton = "bc_seller_dashboard_navigation--button_JS";
            _this.selectorPrimaryNavigationButton = "." + _this.classNamePrimaryNavigationButton;
            _this.classNamePrimaryNavigationWrapper = "bc_seller_dashboard_primary--navigation_JS";
            _this.selectorPrimaryNavigationWrapper = "." + _this.classNamePrimaryNavigationWrapper;
            _this.classNameSellerDashboardContentWrapper = "bc_seller_dashboard_content--wrapper_JS";
            _this.selectorSellerDashboardContentWrapper = "." + _this.classNameSellerDashboardContentWrapper;
            return _this;
        }
        return StSellerDashboardClassConfig;
    }(st_module_13.StModule);
    exports.StSellerDashboardClassConfig = StSellerDashboardClassConfig;
});

define("extension/shopify-app/st-modules/seller-dashboard/shared-components/seller-dashboard-shared-components", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_14, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardSharedComponent = void 0;
    var StSellerDashboardSharedComponent = function(_super) {
        __extends(StSellerDashboardSharedComponent, _super);
        function StSellerDashboardSharedComponent(generalMethods, currency) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardSharedComponent";
            _this_1.showLoader = function() {
                var sellerDashboardPageLoader = document.querySelector(".bc_seller_dashboard_primary_loader_JS");
                if (sellerDashboardPageLoader) {
                    sellerDashboardPageLoader.classList.remove("st_hidden");
                }
            };
            _this_1.hideLoader = function() {
                var sellerDashboardPageLoader = document.querySelector(".bc_seller_dashboard_primary_loader_JS");
                if (sellerDashboardPageLoader) {
                    sellerDashboardPageLoader.classList.add("st_hidden");
                }
            };
            _this_1.showDashboardAsideContent = function() {
                var dashboardAsideContent = document.querySelector(".bc_seller_dashboard_main_right_JS");
                if (dashboardAsideContent) {
                    dashboardAsideContent.classList.remove("st_hidden");
                }
            };
            _this_1.hideDashboardAsideContent = function() {
                var dashboardAsideContent = document.querySelector(".bc_seller_dashboard_main_right_JS");
                if (dashboardAsideContent) {
                    dashboardAsideContent.classList.add("st_hidden");
                }
            };
            _this_1.showAppropriatePage = function(activeTab) {
                var pageWrappers = document.querySelectorAll(".bc_seller_dashboard_content--wrapper_JS");
                if (pageWrappers && pageWrappers.length > 0) {
                    pageWrappers.forEach(function(page) {
                        if (activeTab === page.getAttribute("data-tab-content")) {
                            page.classList.remove("st_hidden");
                        } else {
                            page.classList.add("st_hidden");
                        }
                    });
                }
            };
            _this_1.openCartDrawer = function() {
                var cartDrawerOverlay = document.querySelector(".bc_seller_dashboard_cart_drawer_overlay_JS");
                var cartDrawerPrimaryWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                if (cartDrawerOverlay && cartDrawerPrimaryWrapper) {
                    cartDrawerOverlay.classList.add("active");
                    cartDrawerPrimaryWrapper.classList.add("active");
                    document.body.style.overflow = "hidden";
                }
            };
            _this_1.closeCartDrawer = function() {
                var cartDrawerOverlay = document.querySelector(".bc_seller_dashboard_cart_drawer_overlay_JS");
                var cartDrawerPrimaryWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                if (cartDrawerOverlay && cartDrawerPrimaryWrapper) {
                    cartDrawerOverlay.classList.remove("active");
                    cartDrawerPrimaryWrapper.classList.remove("active");
                    document.body.style.overflow = "auto";
                }
            };
            _this_1.closeCartDrawerHandle = function() {
                var _this = _this_1;
                var cartDrawerOverlay = document.querySelector(".bc_seller_dashboard_cart_drawer_overlay_JS");
                if (cartDrawerOverlay) {
                    cartDrawerOverlay.addEventListener("click", function() {
                        _this.closeCartDrawer();
                    });
                }
            };
            _this_1.setActiveTab = function(button, anchorLink) {
                if (button) {
                    _this_1.activeTabNavigation(button);
                } else {
                    _this_1.activeTabAnchorNavigation(anchorLink);
                }
            };
            _this_1.activeTabNavigation = function(button) {
                var navigationWrapper = _this_1.generalMethods.getClosestByClass(button, "bc_seller_dashboard_primary--navigation_JS");
                var previousActiveButtons = navigationWrapper.querySelectorAll(".active");
                previousActiveButtons.forEach(function(prevButton) {
                    prevButton.classList.remove("active");
                });
                button.classList.add("active");
            };
            _this_1.activeTabAnchorNavigation = function(anchorLink) {
                var primaryWrapper = _this_1.generalMethods.getClosestByClass(anchorLink, "bc_seller_dashboard_primary--wrapper_JS");
                var navigationWrapper = primaryWrapper.querySelector(".bc_seller_dashboard_dropdown_navigation_desktop_JS");
                var previousActiveButtons = navigationWrapper.querySelectorAll(".active");
                previousActiveButtons.forEach(function(prevButton) {
                    prevButton.classList.remove("active");
                });
                var listOfButtons = navigationWrapper.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                listOfButtons.forEach(function(button) {
                    if (button.getAttribute("data-navigation-tab") === anchorLink.getAttribute("data-navigation-tab")) {
                        button.classList.add("active");
                    }
                });
            };
            _this_1.setQueryParams = function(activeTab) {
                var params = new URLSearchParams(window.location.search);
                params.set("activeTab", activeTab);
                var newUrl = "".concat(window.location.pathname, "?").concat(params.toString());
                history.replaceState(null, "", newUrl);
            };
            _this_1.setActivePage = function(activePage) {
                var dashboardPageWrapper = document.querySelector(".bc_seller_dashboard_content--wrapper_JS[data-tab-content=".concat(activePage, "]"));
                dashboardPageWrapper === null || dashboardPageWrapper === void 0 ? void 0 : dashboardPageWrapper.classList.add("bc_fetched_data");
            };
            _this_1.returnOrderDate = function(date) {
                var months = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
                var dateOnly = date.split("T")[0];
                var _a = dateOnly.split("-").map(Number), year = _a[0], month = _a[1], day = _a[2];
                return "".concat(day, " ").concat(months[month - 1], " ").concat(year);
            };
            _this_1.printChosenFilterText = function(value) {
                var chosenFilterEl = document.querySelectorAll(".bc_selected_date_filter_JS");
                if (chosenFilterEl && chosenFilterEl.length > 0) {
                    chosenFilterEl.forEach(function(el) {
                        el.innerHTML = value;
                    });
                }
            };
            _this_1.printSummaryChosenFilterText = function(value) {
                var chosenFilterEl = document.querySelectorAll(".bc_selected_date_summary_filter_JS");
                if (chosenFilterEl && chosenFilterEl.length > 0) {
                    chosenFilterEl.forEach(function(el) {
                        el.innerHTML = value;
                    });
                }
            };
            _this_1.printPayoutsChosenFilterText = function(value) {
                var chosenFilterEl = document.querySelectorAll(".bc_selected_date_payouts_filter_JS");
                if (chosenFilterEl && chosenFilterEl.length > 0) {
                    chosenFilterEl.forEach(function(el) {
                        el.innerHTML = value;
                    });
                }
            };
            _this_1.setAppropriateFilterAttribute = function(attribute) {
                var chosenFilterButtons = document.querySelectorAll(".bc_sales_filter_JS");
                if (chosenFilterButtons && chosenFilterButtons.length > 0) {
                    chosenFilterButtons.forEach(function(button) {
                        button.setAttribute("data-chosen-filter", attribute);
                    });
                }
            };
            _this_1.setSummaryAppropriateFilterAttribute = function(attribute) {
                var chosenFilterButtons = document.querySelectorAll(".bc_summary_filter_JS");
                if (chosenFilterButtons && chosenFilterButtons.length > 0) {
                    chosenFilterButtons.forEach(function(button) {
                        button.setAttribute("data-summary-chosen-filter", attribute);
                    });
                }
            };
            _this_1.setPayoutsAppropriateFilterAttribute = function(attribute) {
                var chosenFilterButtons = document.querySelectorAll(".bc_payouts_filter_JS");
                if (chosenFilterButtons && chosenFilterButtons.length > 0) {
                    chosenFilterButtons.forEach(function(button) {
                        button.setAttribute("data-payouts-chosen-filter", attribute);
                    });
                }
            };
            _this_1.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this_1.enableBodyScroll = function() {
                document.body.style.overflow = "auto";
            };
            _this_1.toggleAssetsDownloadAllLoader = function(isLoading) {
                var loader = document.querySelector(".bc_assets_download_all_loader");
                var button = document.querySelector(".bc_seller_dashboard_download_all_assets_JS");
                if (loader) {
                    loader.classList.toggle("st_hidden", !isLoading);
                }
                if (button) {
                    button.disabled = isLoading;
                    button.classList.toggle("bc_is_disabled", isLoading);
                }
            };
            _this_1.toggleAssetsSingleDownloadLoader = function(isLoading) {
                var button = document.querySelector(".bc_assets_download_single_button_JS");
                if (button) {
                    button.disabled = isLoading;
                    button.classList.toggle("bc_is_disabled", isLoading);
                    var windowTranslations = window.stTranslations;
                    var textSpan = button.querySelector("span");
                    if (textSpan) {
                        textSpan.textContent = isLoading ? windowTranslations.downloading : windowTranslations.download;
                    }
                }
            };
            _this_1.shiftDateByHours = function(date, hours) {
                date.setTime(date.getTime() + hours * 60 * 60 * 1e3);
            };
            _this_1.hasFirstSundayStartedOrPassed = function(date) {
                if (date === void 0) {
                    date = new Date();
                }
                var year = date.getFullYear();
                var month = date.getMonth();
                var firstOfMonth = new Date(year, month, 1);
                var firstSundayDate = firstOfMonth.getDate() + (6 - firstOfMonth.getDay()) % 7;
                return date.getDate() > firstSundayDate;
            };
            _this_1.isDaylightSavingsActiveForPST = function(date) {
                var month = date.getMonth() + 1;
                if (month === 3) {
                    return _this_1.hasFirstSundayStartedOrPassed(date);
                }
                if (month === 11) {
                    return !_this_1.hasFirstSundayStartedOrPassed(date);
                }
                return month > 3 && month < 11;
            };
            _this_1.adjustDateFromGapToPstTimezone = function(date) {
                var pstDate = new Date(date);
                var hoursToShift = _this_1.isDaylightSavingsActiveForPST(pstDate) ? -7 : -8;
                _this_1.shiftDateByHours(pstDate, hoursToShift);
                return pstDate;
            };
            _this_1.adjustIsoDateFromGapToPstTimezone = function(date) {
                var pstDate = new Date(date);
                var hoursToShift = _this_1.isDaylightSavingsActiveForPST(pstDate) ? -7 : -8;
                _this_1.shiftDateByHours(pstDate, hoursToShift);
                return pstDate.toISOString();
            };
            _this_1.generalMethods = generalMethods;
            _this_1.currency = currency;
            return _this_1;
        }
        StSellerDashboardSharedComponent.prototype.updateEarningsByClass = function(amount, className) {
            var earningsElement = document.querySelector(".".concat(className));
            if (earningsElement) {
                earningsElement.textContent = this.currency.applyFormat(amount, currency_1.ECurrencyFormatType.withCurrency);
            }
        };
        StSellerDashboardSharedComponent.prototype.updateOrderNumberByClass = function(amount, className) {
            var earningsElement = document.querySelector(".".concat(className));
            if (earningsElement) {
                earningsElement.textContent = "".concat(amount);
            } else {
                console.warn('[EarningsUpdater] Element with class "'.concat(className, '" not found.'));
            }
        };
        StSellerDashboardSharedComponent.prototype.updateOrderNumberAndAddTodayByClass = function(amount, className) {
            var earningsElement = document.querySelector(".".concat(className));
            if (earningsElement) {
                var today = window.stTranslations.today;
                earningsElement.innerHTML = '\n           <span class="bc_seller-summary-today-badge">'.concat(amount, " ").concat(today.toLowerCase(), "</span>\n            ");
            } else {
                console.warn('[EarningsUpdater] Element with class "'.concat(className, '" not found.'));
            }
        };
        StSellerDashboardSharedComponent.prototype.updateOrderNumberAmmountAndAddTodayByClass = function(amount, className) {
            var earningsElement = document.querySelector(".".concat(className));
            if (earningsElement) {
                var today = window.stTranslations.today;
                var formattedAmount = this.currency.applyFormat(amount, currency_1.ECurrencyFormatType.withCurrency);
                earningsElement.innerHTML = '\n           <span class="bc_seller-summary-today-badge">'.concat(formattedAmount, " ").concat(today.toLowerCase(), "</span>\n            ");
            } else {
                console.warn('[EarningsUpdater] Element with class "'.concat(className, '" not found.'));
            }
        };
        StSellerDashboardSharedComponent.prototype.updateInputByClass = function(textValue, className) {
            var inputElement = document.querySelector(".".concat(className));
            if (inputElement) {
                inputElement.value = textValue;
                inputElement.setAttribute("value", textValue);
            }
        };
        StSellerDashboardSharedComponent.prototype.showNotification = function(message) {
            console.log(message);
        };
        StSellerDashboardSharedComponent.prototype.formatDateToReadable = function(dateString) {
            var _a;
            var date = new Date(dateString);
            var options = {
                month: "long",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC"
            };
            var formatted = date.toLocaleString("en-US", options);
            var _b = formatted.split(", "), fullDatePart = _b[0], timePart = _b[1];
            var _c = fullDatePart.split(" "), month = _c[0], day = _c[1];
            var year = timePart.split(",")[0];
            timePart = (_a = timePart.split("at")[1]) === null || _a === void 0 ? void 0 : _a.trim();
            var finalDay = day.padStart(2, "0");
            var finalMonth = month.toUpperCase();
            var finalYear = date.getFullYear();
            return "".concat(finalDay, " ").concat(finalMonth, ", ").concat(finalYear, " AT ").concat(timePart.toUpperCase());
        };
        StSellerDashboardSharedComponent.prototype.updateTooltipTextAndTitle = function(className, value, defultValue, filterType, titleUpdate) {
            if (titleUpdate === void 0) {
                titleUpdate = true;
            }
            var earningsEl = document.querySelector(".".concat(className));
            if (!earningsEl) {
                console.warn('[Tooltip] Element with class "'.concat(className, '" not found'));
                return;
            }
            var cardWrapper = earningsEl.closest(".bc_seller_dashboard_summary_card");
            if (!cardWrapper) {
                console.warn('[Tooltip] Card wrapper for "'.concat(className, '" not found'));
                return;
            }
            var tooltipEl = cardWrapper.querySelector(".bc_tooltip");
            var template = tooltipEl === null || tooltipEl === void 0 ? void 0 : tooltipEl.getAttribute("data-tooltip-template");
            var today = window.stTranslations.today;
            var last_7_days = window.stTranslations.last_7_days;
            var last_30_days = window.stTranslations.last_30_days;
            var last_90_days = window.stTranslations.last_90_days;
            var last_12_months = window.stTranslations.last_12_months;
            var this_month = window.stTranslations.thisMonth;
            var days_30 = window.stTranslations.days_30;
            var last_month = window.stTranslations.last_month;
            var filterLabels = {
                today: this.capitalize(today),
                last_7_days: this.capitalize(last_7_days),
                last_30_days: this.capitalize(last_30_days),
                last_90_days: this.capitalize(last_90_days),
                last_12_months: this.capitalize(last_12_months),
                this_month: this.capitalize(this_month),
                last_month: this.capitalize(last_month),
                custom: filterType
            };
            var label = filterLabels[filterType];
            if (label === this.capitalize(this_month)) {
                label = days_30;
            }
            if (label === undefined) {
                label = filterType;
            }
            if (template && tooltipEl) {
                var replaced = template.replace(defultValue, label);
                tooltipEl.textContent = replaced;
                if (!titleUpdate) return;
                var title = cardWrapper.querySelector("span.bc_seller_dashboard_summary_label");
                if (!title) return;
                if (title && value !== defultValue) {
                    title.textContent = filterLabels[filterType];
                    if (filterLabels[filterType] === undefined) {
                        title.textContent = filterType;
                    }
                }
            } else {
                console.warn('[Tooltip] Missing template or textEl for "'.concat(className, '"'));
            }
        };
        StSellerDashboardSharedComponent.prototype.updateOnlyTooltipSmallBoxText = function(className, defultValue, filterType) {
            var earningsEl = document.querySelector(".".concat(className));
            if (!earningsEl) return;
            var card = earningsEl.closest(".bc_seller-summary-card");
            if (!card) return;
            var tooltipEl = card.querySelector(".bc_tooltip_small");
            var template = tooltipEl === null || tooltipEl === void 0 ? void 0 : tooltipEl.getAttribute("data-tooltip-template");
            var today = window.stTranslations.today;
            var last_7_days = window.stTranslations.last_7_days;
            var last_30_days = window.stTranslations.last_30_days;
            var last_90_days = window.stTranslations.last_90_days;
            var last_12_months = window.stTranslations.last_12_months;
            var this_month = window.stTranslations.thisMonth;
            var days_30 = window.stTranslations.days_30;
            var filterLabels = {
                today: this.capitalize(today),
                last_7_days: this.capitalize(last_7_days),
                last_30_days: this.capitalize(last_30_days),
                last_90_days: this.capitalize(last_90_days),
                last_12_months: this.capitalize(last_12_months),
                this_month: this.capitalize(this_month),
                custom: filterType
            };
            var label = filterLabels[filterType];
            if (label === this.capitalize(this_month)) {
                label = days_30;
            }
            if (label === undefined) {
                label = filterType;
            }
            if (template && tooltipEl) {
                var replaced = template.replace(defultValue, label);
                tooltipEl.textContent = replaced;
            } else {
                console.warn('[Tooltip] Missing template or textEl for "'.concat(className, '"'));
            }
        };
        StSellerDashboardSharedComponent.prototype.capitalize = function(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        };
        StSellerDashboardSharedComponent.prototype.getStartOfDay = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setUTCHours(0, 0, 0, 0);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getEndOfDay = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setUTCHours(23, 59, 59, 999);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getStartOfThisMonth = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setMonth(date.getMonth());
            date.setUTCDate(1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getEndOfThisMonth = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setMonth(date.getMonth() + 1);
            date.setUTCDate(0);
            date.setUTCHours(23, 59, 59, 999);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getStartOfLastMonth = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setMonth(date.getMonth() - 1);
            date.setUTCDate(1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getEndOfLastMonth = function(date) {
            if (date === void 0) {
                date = new Date();
            }
            date.setMonth(date.getMonth());
            date.setUTCDate(0);
            date.setUTCHours(23, 59, 59, 999);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getStartOfSelectedDay = function(dateInput) {
            var date = new Date(dateInput);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        };
        StSellerDashboardSharedComponent.prototype.getEndOfSelectedDay = function(dateInput) {
            var date = new Date(dateInput);
            date.setUTCHours(23, 59, 59, 999);
            return date;
        };
        return StSellerDashboardSharedComponent;
    }(st_module_14.StModule);
    exports.StSellerDashboardSharedComponent = StSellerDashboardSharedComponent;
});

define("extension/shopify-app/st-modules/seller-dashboard/summary/seller-dashboard-summary-filters", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardSummaryFilters = void 0;
    var StSellerDashboardSummaryFilters = function(_super) {
        __extends(StSellerDashboardSummaryFilters, _super);
        function StSellerDashboardSummaryFilters(sharedComponents, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardSummaryFilters";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleOpenFilterDrawer();
                    _this_1.handleCloseFilterDrawer();
                    _this_1.handleChooseDifferentFilter();
                    _this_1.handleApplyFilterClick();
                });
            };
            _this_1.handleOpenFilterDrawer = function() {
                var _this = _this_1;
                var thisMonth = window.stTranslations.thisMonth;
                var salesFilterButtons = document.querySelectorAll(".bc_summary_filter_JS");
                if (salesFilterButtons && salesFilterButtons.length > 0) {
                    salesFilterButtons.forEach(function(button) {
                        _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_30_days");
                        _this_1.sharedComponents.printSummaryChosenFilterText(thisMonth);
                        button.addEventListener("click", function() {
                            _this.openFilterDrawer();
                            _this.setActiveStateOnChosenFilter(this);
                            _this.sharedComponents.disableBodyScroll();
                        });
                    });
                }
            };
            _this_1.openFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_summary_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_summary_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.add("active");
                    salesFilterDrawerWrapper.classList.add("active");
                }
            };
            _this_1.handleCloseFilterDrawer = function() {
                var _this = _this_1;
                var closeFilterButtons = document.querySelectorAll(".bc_summary_close_filter_JS");
                if (closeFilterButtons && closeFilterButtons.length > 0) {
                    closeFilterButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeFilterDrawer();
                            _this.sharedComponents.enableBodyScroll();
                        });
                    });
                }
                var closeFilterOverlay = document.querySelector(".bc_summary_filters_overlay_JS");
                if (closeFilterOverlay) {
                    closeFilterOverlay.addEventListener("click", function() {
                        _this.closeFilterDrawer();
                        _this.sharedComponents.enableBodyScroll();
                    });
                }
            };
            _this_1.closeFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_summary_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_summary_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.remove("active");
                    salesFilterDrawerWrapper.classList.remove("active");
                }
            };
            _this_1.setActiveStateOnChosenFilter = function(button) {
                var chosenFilter = button.getAttribute("data-summary-chosen-filter");
                var filterWrapper = document.querySelector(".bc_summary_filter_wrapper_JS");
                if (filterWrapper) {
                    var filterOptions = filterWrapper.querySelectorAll(".bc_summary_filter_button_JS");
                    if (filterOptions && filterOptions.length > 0) {
                        filterOptions.forEach(function(filter) {
                            var filterType = filter.getAttribute("data-summary-date-filter");
                            chosenFilter === filterType ? filter.classList.add("active") : filter.classList.remove("active");
                        });
                    }
                }
            };
            _this_1.handleChooseDifferentFilter = function() {
                var _this = _this_1;
                var salesFilterWrapper = document.querySelector(".bc_summary_filter_wrapper_JS");
                if (salesFilterWrapper) {
                    var filterButtons = salesFilterWrapper.querySelectorAll(".bc_summary_filter_button_JS");
                    if (filterButtons && filterButtons.length > 0) {
                        filterButtons.forEach(function(button) {
                            button.addEventListener("click", function() {
                                _this.setActiveFilter(salesFilterWrapper, this);
                                if (this.getAttribute("data-summary-date-filter") === "custom") {
                                    _this.showCustomFilterRange();
                                } else {
                                    _this.hideCustomFilterRange();
                                }
                            });
                        });
                    }
                }
            };
            _this_1.setActiveFilter = function(filterWrapper, button) {
                if (button.classList.contains("active")) {
                    return;
                }
                _this_1.removeCustomRangeErrorMessage();
                var previousActiveFilter = filterWrapper.querySelector(".active");
                previousActiveFilter === null || previousActiveFilter === void 0 ? void 0 : previousActiveFilter.classList.remove("active");
                button.classList.add("active");
            };
            _this_1.removeCustomRangeErrorMessage = function() {
                var errorMessage = document.querySelector(".bc_summary_custom_range_error_message_JS");
                if (errorMessage) {
                    errorMessage.remove();
                }
            };
            _this_1.showCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_summary_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.add("active");
                }
            };
            _this_1.hideCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_summary_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.remove("active");
                }
            };
            _this_1.handleApplyFilterClick = function() {
                var _this = _this_1;
                var applyButton = document.querySelector(".bc_apply_summary_filters_JS");
                if (applyButton) {
                    applyButton.addEventListener("click", function() {
                        _this.applyChosenFilter();
                    });
                }
            };
            _this_1.applyChosenFilter = function() {
                var today = window.stTranslations.today;
                var last_7_days = window.stTranslations.last_7_days;
                var last_30_days = window.stTranslations.last_30_days;
                var this_month = window.stTranslations.thisMonth;
                var last_month = window.stTranslations.last_month;
                var last_90_days = window.stTranslations.last_90_days;
                var last_12_months = window.stTranslations.last_12_months;
                var filtersWrapper = document.querySelector(".bc_summary_filter_wrapper_JS");
                if (filtersWrapper) {
                    var filter = filtersWrapper.querySelector(".active");
                    if (!filter) {
                        return;
                    }
                    if (filter) {
                        var filterType = filter.getAttribute("data-summary-date-filter");
                        var todayDate = new Date();
                        var startOfDay = new Date(todayDate.getUTCFullYear(), todayDate.getUTCMonth(), todayDate.getUTCDate());
                        switch (filterType) {
                          case "today":
                            _this_1.applyFilterAndRenderResults(startOfDay, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(today);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("today");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_7_days":
                            var sevenDaysAgo = new Date(todayDate);
                            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                            _this_1.applyFilterAndRenderResults(sevenDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(last_7_days);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_7_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_30_days":
                            var thirtyDaysAgo = new Date(todayDate);
                            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                            _this_1.applyFilterAndRenderResults(thirtyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(last_30_days);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_30_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "this_month":
                            var thirtyDaysAgoMonth = new Date(todayDate);
                            thirtyDaysAgoMonth.setDate(thirtyDaysAgoMonth.getDate() - 30);
                            _this_1.applyFilterAndRenderResults(thirtyDaysAgoMonth, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(this_month);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("this_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_month":
                            var firstDayLastMonth = new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 1, 0, 0, 0);
                            var lastDayLastMonth = new Date(todayDate.getFullYear(), todayDate.getMonth(), 0, 23, 59, 59);
                            _this_1.applyFilterAndRenderResults(firstDayLastMonth, lastDayLastMonth, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(last_month);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_90_days":
                            var ninetyDaysAgo = new Date(todayDate);
                            ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
                            _this_1.applyFilterAndRenderResults(ninetyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(last_90_days);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_90_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_12_months":
                            var twelveMonthsAgo = new Date(todayDate);
                            twelveMonthsAgo.setFullYear(twelveMonthsAgo.getFullYear() - 1);
                            _this_1.applyFilterAndRenderResults(twelveMonthsAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printSummaryChosenFilterText(last_12_months);
                            _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("last_12_months");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "custom":
                            var customRangeFilterWrapper = document.querySelector(".bc_summary_filter_custom_range_wrapper_JS");
                            if (customRangeFilterWrapper) {
                                var startDateEl = customRangeFilterWrapper.querySelector(".bc_summary_range_input_start_date_JS");
                                var endDateEl = customRangeFilterWrapper.querySelector(".bc_summary_range_input_end_date_JS");
                                if (startDateEl && endDateEl) {
                                    console.log("filterValue", startDateEl.value, endDateEl.value);
                                    if (startDateEl.value !== "" && endDateEl.value !== "") {
                                        _this_1.applyFilterAndRenderResults(new Date(startDateEl.value), new Date(endDateEl.value), _this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                    } else {
                                        _this_1.removeCustomRangeErrorMessage();
                                        customRangeFilterWrapper.appendChild(_this_1.printCustomRangeErrorMessage());
                                        return;
                                    }
                                }
                                _this_1.closeFilterDrawer();
                                if (startDateEl && endDateEl) {
                                    _this_1.sharedComponents.printSummaryChosenFilterText(_this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                }
                                _this_1.sharedComponents.setSummaryAppropriateFilterAttribute("custom");
                                _this_1.sharedComponents.enableBodyScroll();
                            }
                            break;

                          default:
                            console.log("No filter provided.");
                        }
                    }
                }
            };
            _this_1.formatDateRange = function(startDate, endDate) {
                var fromDate = new Date(startDate);
                var toDate = new Date(endDate);
                var dayFrom = fromDate.getDate();
                var dayTo = toDate.getDate();
                var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
                var monthFrom = monthNames[fromDate.getMonth()];
                var monthTo = monthNames[toDate.getMonth()];
                var yearFrom = fromDate.getFullYear();
                var yearTo = toDate.getFullYear();
                if (yearFrom === yearTo && fromDate.getMonth() === toDate.getMonth()) {
                    return "".concat(dayFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else if (yearFrom === yearTo) {
                    return "".concat(dayFrom, " ").concat(monthFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else {
                    return "".concat(dayFrom, " ").concat(monthFrom, ", ").concat(yearFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                }
            };
            _this_1.printCustomRangeErrorMessage = function() {
                var errorText = window.stTranslations.customRangeFilterErrorMessage;
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_custom_range_error_message", "bc_summary_custom_range_error_message_JS");
                errorMessage.innerHTML = errorText ? errorText : "Test Message";
                return errorMessage;
            };
            _this_1.applyFilterAndRenderResults = function(startDate, endDate, filterType) {
                var _a;
                var payload = {
                    affiliateId: window.customerAffiliateId,
                    dateStart: startDate.toISOString(),
                    dateEnd: endDate.toISOString()
                };
                if (filterType === "this_month") {
                    payload = {
                        affiliateId: window.customerAffiliateId
                    };
                }
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getDashboardSummary"],
                        method: "POST",
                        contentType: "json",
                        data: payload,
                        callback: function(res) {
                            try {
                                var resp = JSON.parse(res.response);
                                if (resp.status === 200) {
                                    _this_1.summaryModule.updateProgressBar(Number(resp.data.salesProgress));
                                    _this_1.summaryModule.updateReferralProgressBar(Number(resp.data.activations));
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.earningsFiltered, _this_1.summaryModule.earningsThisMonth);
                                    _this_1.sharedComponents.updateTooltipTextAndTitle(_this_1.summaryModule.earningsThisMonth, resp.data.earningsFiltered, days_30, filterType);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.earningsAllTime, _this_1.summaryModule.earningsAllTime);
                                    _this_1.sharedComponents.updateOrderNumberByClass(resp.data.numberOfOrders, _this_1.summaryModule.summarySalesBox1);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.sales, _this_1.summaryModule.summarySalesBox2);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.commission, _this_1.summaryModule.summarySalesBox3);
                                    _this_1.sharedComponents.updateOnlyTooltipSmallBoxText(_this_1.summaryModule.summarySalesBox3, days_30, filterType);
                                    _this_1.sharedComponents.updateOrderNumberAndAddTodayByClass(resp.data.numberOfTodaysOrders, _this_1.summaryModule.summarySalesBox1Today);
                                    _this_1.sharedComponents.updateOrderNumberAmmountAndAddTodayByClass(resp.data.salesToday, _this_1.summaryModule.summarySalesBox2Today);
                                    _this_1.sharedComponents.updateOnlyTooltipSmallBoxText(_this_1.summaryModule.summarySalesBox2Today, days_30, filterType);
                                    _this_1.sharedComponents.updateOrderNumberByClass(resp.data.activations, _this_1.summaryModule.summaryReferralActivation);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.bonusEarned, _this_1.summaryModule.summaryReferralBonus);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.payoutsFiltered, _this_1.summaryModule.summaryPayoutsThisMonth);
                                    _this_1.sharedComponents.updateTooltipTextAndTitle(_this_1.summaryModule.summaryPayoutsThisMonth, resp.data.earningsFiltered, days_30, filterType);
                                    _this_1.sharedComponents.updateEarningsByClass(resp.data.allTimePayouts, _this_1.summaryModule.summaryPayoutsAllTime);
                                    var activationsNeedNumber = _this_1.summaryModule.calculateOffsetReferal(Number(resp.data.activations)) === 0 ? 10 : _this_1.summaryModule.calculateOffsetReferal(10 - Number(resp.data.activations));
                                    _this_1.summaryModule.updateNumberReferallsActivationsByClass(activationsNeedNumber, _this_1.summaryModule.referalNumberForBonus);
                                    _this_1.sharedComponents.showDashboardAsideContent();
                                    _this_1.sharedComponents.showAppropriatePage("summary");
                                } else if (resp.status === 400) {
                                    _this_1.sharedComponents.hideLoader();
                                } else {
                                    console.error(resp.message);
                                    _this_1.sharedComponents.hideLoader();
                                }
                            } catch (error) {
                                console.error("Response error ------\x3e", error);
                                _this_1.sharedComponents.hideLoader();
                            }
                        }
                    });
                } catch (err) {
                    console.log("StSellerDashboardSummary---\x3e Error: fetch summary API", err);
                }
            };
            _this_1.sharedComponents = sharedComponents;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StSellerDashboardSummaryFilters.prototype.setSalesModule = function(module) {
            this.summaryModule = module;
        };
        return StSellerDashboardSummaryFilters;
    }(st_module_15.StModule);
    exports.StSellerDashboardSummaryFilters = StSellerDashboardSummaryFilters;
});

define("extension/shopify-app/st-modules/seller-dashboard/summary/seller-dashboard-summary", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_16, currency_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardSummary = void 0;
    var StSellerDashboardSummary = function(_super) {
        __extends(StSellerDashboardSummary, _super);
        function StSellerDashboardSummary(objectFormatting, sharedComponents, currency, summaryFilters) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerDashboardSummary";
            _this.earningsAllTime = "bc_earnings_this_month_all_time";
            _this.earningsThisMonth = "bc_earnings_this_month";
            _this.summarySalesBox1 = "bc_orders_summary_sales_box1";
            _this.summarySalesBox2 = "bc_orders_summary_sales_box2";
            _this.summarySalesBox3 = "bc_orders_summary_sales_box3";
            _this.summarySalesBox1Today = "bc_orders_summary_sales_box1_today";
            _this.summarySalesBox2Today = "bc_orders_summary_sales_box2_today";
            _this.summaryReferralActivation = "bc_earnings_referals_activation";
            _this.summaryReferralBonus = "bc_earnings_referals_bonus";
            _this.summaryPayoutsThisMonth = "bc_earnings_payouts_this_month";
            _this.summaryPayoutsAllTime = "bc_earnings_payouts_all_time";
            _this.referalNumberForBonus = "bc_seller_dashboard_progress_value_JS";
            _this.payoutsCount = "bc_seller_dashboard_header_summary_count_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.handleLandingOnSummaryPage();
                });
            };
            _this.fetchSummaryPageContent = function(activePage) {
                var _a;
                _this.sharedComponents.showLoader();
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                var startThisMonth = _this.sharedComponents.getStartOfThisMonth();
                var endThismonth = _this.sharedComponents.getEndOfThisMonth();
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["getDashboardSummary"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId,
                            dateStart: startThisMonth,
                            dateEnd: endThismonth
                        },
                        callback: function(res) {
                            try {
                                var resp = JSON.parse(res.response);
                                if (resp.status === 200) {
                                    _this.updateProgressBar(Number(resp.data.salesProgress));
                                    _this.updateReferralProgressBar(Number(resp.data.activations));
                                    _this.sharedComponents.updateEarningsByClass(resp.data.earningsFiltered, _this.earningsThisMonth);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.earningsThisMonth, resp.data.earningsFiltered, days_30, "this_month");
                                    _this.sharedComponents.updateEarningsByClass(resp.data.earningsAllTime, _this.earningsAllTime);
                                    _this.sharedComponents.updateOrderNumberByClass(resp.data.numberOfOrders, _this.summarySalesBox1);
                                    _this.sharedComponents.updateEarningsByClass(resp.data.sales, _this.summarySalesBox2);
                                    _this.sharedComponents.updateEarningsByClass(resp.data.commission, _this.summarySalesBox3);
                                    _this.sharedComponents.updateOnlyTooltipSmallBoxText(_this.summarySalesBox3, days_30, "this_month");
                                    _this.sharedComponents.updateOrderNumberAndAddTodayByClass(resp.data.numberOfTodaysOrders, _this.summarySalesBox1Today);
                                    _this.sharedComponents.updateOrderNumberAmmountAndAddTodayByClass(resp.data.salesToday, _this.summarySalesBox2Today);
                                    _this.sharedComponents.updateOnlyTooltipSmallBoxText(_this.summarySalesBox2, days_30, "this_month");
                                    _this.sharedComponents.updateOrderNumberByClass(resp.data.activations, _this.summaryReferralActivation);
                                    _this.sharedComponents.updateEarningsByClass(resp.data.bonusEarned, _this.summaryReferralBonus);
                                    _this.sharedComponents.updateEarningsByClass(resp.data.payoutsFiltered, _this.summaryPayoutsThisMonth);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.summaryPayoutsThisMonth, resp.data.earningsFiltered, days_30, "this_month");
                                    _this.sharedComponents.updateEarningsByClass(resp.data.allTimePayouts, _this.summaryPayoutsAllTime);
                                    var activationsNeedNumber = _this.calculateOffsetReferal(Number(resp.data.activations)) === 0 ? 10 : _this.calculateOffsetReferal(10 - Number(resp.data.activations));
                                    _this.updateNumberReferallsActivationsByClass(activationsNeedNumber, _this.referalNumberForBonus);
                                    _this.sharedComponents.updateOrderNumberByClass(resp.data.payoutsCount ? resp.data.payoutsCount : "", _this.payoutsCount);
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                } else if (resp.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {
                                    console.error(resp.message);
                                    _this.sharedComponents.hideLoader();
                                }
                            } catch (error) {
                                console.error("Response error ------\x3e", error);
                                _this.sharedComponents.hideLoader();
                            }
                        }
                    });
                } catch (err) {
                    console.log("StSellerDashboardSummary---\x3e Error: fetch summary API", err);
                }
            };
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            _this.currency = currency;
            _this.summaryFilters = summaryFilters;
            _this.summaryFilters.setSalesModule(_this);
            return _this;
        }
        StSellerDashboardSummary.prototype.handleLandingOnSummaryPage = function() {
            var mediaQuery = window.matchMedia("(max-width: 1023px)");
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (!urlParams.activeTab) {
                this.fetchSummaryPageContent("summary");
                this.sharedComponents.setQueryParams("summary");
                this.sharedComponents.setActivePage("summary");
                if (mediaQuery.matches) {}
            }
            if (urlParams.activeTab && urlParams.activeTab === "summary") {
                this.fetchSummaryPageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("summary");
            }
        };
        StSellerDashboardSummary.prototype.updateProgressBar = function(updateSalesBar) {
            var _this = this;
            var progressPercent = 0;
            var salesAmount = updateSalesBar;
            var tier1Limit = 500;
            var tier2Limit = 1500;
            if (salesAmount <= tier1Limit) {
                progressPercent = salesAmount / tier1Limit * 50;
            } else if (salesAmount <= tier2Limit) {
                progressPercent = 50 + (salesAmount - tier1Limit) / (tier2Limit - tier1Limit) * 50;
            } else {
                progressPercent = 100;
            }
            var progressFills = document.querySelectorAll('[data-role="progress-fill-thismonth"]');
            progressFills.forEach(function(fill) {
                fill.style.width = "".concat(progressPercent, "%");
            });
            var checkIcon = '\n            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M7.33464 0.5L2.7513 5.08333L0.667969 3" stroke="#68133A" stroke-linecap="round" stroke-linejoin="round"/>\n            </svg>\n        ';
            var lockIcon = '\n            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33333 4.76562H8.66667C9.02029 4.76562 9.35943 4.90391 9.60948 5.15005C9.85952 5.39619 10 5.73003 10 6.07812V9.6875C10 10.0356 9.85952 10.3694 9.60948 10.6156C9.35943 10.8617 9.02029 11 8.66667 11H3.33333C2.97971 11 2.64057 10.8617 2.39052 10.6156C2.14048 10.3694 2 10.0356 2 9.6875V6.07812C2 5.73003 2.14048 5.39619 2.39052 5.15005C2.64057 4.90391 2.97971 4.76562 3.33333 4.76562H3.66667V2.79688C3.66667 2.18771 3.9125 1.60349 4.35008 1.17274C4.78767 0.741992 5.38116 0.5 6 0.5C6.61884 0.5 7.21233 0.741992 7.64992 1.17274C8.0875 1.60349 8.33333 2.18771 8.33333 2.79688V4.76562ZM4.82149 1.63678C4.50893 1.94445 4.33333 2.36175 4.33333 2.79688V4.76562H7.66667V2.79688C7.66667 2.36175 7.49107 1.94445 7.17851 1.63678C6.86595 1.3291 6.44203 1.15625 6 1.15625C5.55797 1.15625 5.13405 1.3291 4.82149 1.63678ZM6.5 6.5H5.5V9.5H6.5V6.5Z" fill="#68133A"/>\n            </svg>\n        ';
            var tierIcons = document.querySelectorAll('[data-role="tier-icon"]');
            tierIcons.forEach(function(iconEl) {
                var parent = iconEl.closest("[data-tier]");
                var tier = parent === null || parent === void 0 ? void 0 : parent.getAttribute("data-tier");
                var isUnlocked = false;
                if (tier === "start") {
                    isUnlocked = salesAmount > 0;
                } else if (tier === "tier1") {
                    isUnlocked = salesAmount >= tier1Limit;
                } else if (tier === "tier2") {
                    isUnlocked = salesAmount >= tier2Limit;
                }
                iconEl.innerHTML = isUnlocked ? checkIcon : lockIcon;
                iconEl.classList.toggle("unlocked", isUnlocked);
            });
            var sellMoreSpans = document.querySelectorAll(".bc_seller_dashboard_progress_bar_sell_more_JS");
            var sellBonusSpan = document.querySelectorAll(".bc_seller_dashboard_progress_bar_bonus_JS");
            var remaining = 0;
            var bonus = 0;
            if (salesAmount < tier1Limit) {
                remaining = tier1Limit - salesAmount;
                bonus = 5;
            } else if (salesAmount < tier2Limit) {
                remaining = tier2Limit - salesAmount;
                bonus = 10;
            }
            sellMoreSpans.forEach(function(span) {
                span.textContent = remaining > 0 ? _this.currency.applyFormat(remaining, currency_2.ECurrencyFormatType.withCurrency) : _this.currency.applyFormat(500, currency_2.ECurrencyFormatType.withoutCurrency);
            });
            sellBonusSpan.forEach(function(span) {
                span.textContent = "".concat(bonus, "%");
            });
            var titleEl = document.querySelector(".bc_seller_dashboard_title_text");
            var titleElFull = document.querySelector(".bc_seller_dashboard_title_text_full");
            if (salesAmount >= tier2Limit && titleEl) {
                titleEl.classList.add("bc_progress_title_hide");
                if (titleElFull) {
                    titleElFull.classList.remove("bc_progress_title_hide");
                }
            }
        };
        StSellerDashboardSummary.prototype.updateReferralProgressBar = function(activations) {
            var referalActivationsValue = this.calculateOffsetReferal(activations);
            var goal = 10;
            var progressPercent = Math.min(referalActivationsValue / goal * 100, 100);
            var progressFills = document.querySelectorAll('[data-role="referral-progress-fill"]');
            progressFills.forEach(function(fill) {
                fill.style.width = "".concat(progressPercent, "%");
            });
        };
        StSellerDashboardSummary.prototype.calculateOffsetReferal = function(value) {
            if (value >= 10) {
                var mod = value % 10;
                return mod === 0 ? 0 : 10 - mod;
            } else {
                return value;
            }
        };
        StSellerDashboardSummary.prototype.updateNumberReferallsActivationsByClass = function(num, className) {
            var earningsElement = document.querySelector(".".concat(className));
            if (earningsElement) {
                earningsElement.textContent = "".concat(num);
            } else {
                console.warn('[EarningsUpdater] Element with class "'.concat(className, '" not found.'));
            }
        };
        return StSellerDashboardSummary;
    }(st_module_16.StModule);
    exports.StSellerDashboardSummary = StSellerDashboardSummary;
});

define("extension/shopify-app/st-modules/seller-dashboard/sales/seller-dashboard-sales-filters", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardSalesFilters = void 0;
    var StSellerDashboardSalesFilters = function(_super) {
        __extends(StSellerDashboardSalesFilters, _super);
        function StSellerDashboardSalesFilters(sharedComponents, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardSalesFilters";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleOpenFilterDrawer();
                    _this_1.handleCloseFilterDrawer();
                    _this_1.handleChooseDifferentFilter();
                    _this_1.handleApplyFilterClick();
                });
            };
            _this_1.handleOpenFilterDrawer = function() {
                var _this = _this_1;
                var thisMonth = window.stTranslations.thisMonth;
                var salesFilterButtons = document.querySelectorAll(".bc_sales_filter_JS");
                if (salesFilterButtons && salesFilterButtons.length > 0) {
                    salesFilterButtons.forEach(function(button) {
                        _this_1.sharedComponents.setAppropriateFilterAttribute("last_30_days");
                        _this_1.sharedComponents.printChosenFilterText(thisMonth);
                        button.addEventListener("click", function() {
                            _this.openFilterDrawer();
                            _this.setActiveStateOnChosenFilter(this);
                            _this.sharedComponents.disableBodyScroll();
                        });
                    });
                }
            };
            _this_1.handleCloseFilterDrawer = function() {
                var _this = _this_1;
                var closeFilterButtons = document.querySelectorAll(".bc_close_sales_filter_JS");
                if (closeFilterButtons && closeFilterButtons.length > 0) {
                    closeFilterButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeFilterDrawer();
                            _this.sharedComponents.enableBodyScroll();
                        });
                    });
                }
                var closeFilterOverlay = document.querySelector(".bc_sales_filters_overlay_JS");
                if (closeFilterOverlay) {
                    closeFilterOverlay.addEventListener("click", function() {
                        _this.closeFilterDrawer();
                        _this.sharedComponents.enableBodyScroll();
                    });
                }
            };
            _this_1.openFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_sales_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_sales_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.add("active");
                    salesFilterDrawerWrapper.classList.add("active");
                }
            };
            _this_1.closeFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_sales_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_sales_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.remove("active");
                    salesFilterDrawerWrapper.classList.remove("active");
                }
            };
            _this_1.setActiveStateOnChosenFilter = function(button) {
                var chosenFilter = button.getAttribute("data-chosen-filter");
                var filterWrapper = document.querySelector(".bc_sales_filter_wrapper_JS");
                if (filterWrapper) {
                    var filterOptions = filterWrapper.querySelectorAll(".bc_sales_filter_button_JS");
                    if (filterOptions && filterOptions.length > 0) {
                        filterOptions.forEach(function(filter) {
                            var filterType = filter.getAttribute("data-date-filter");
                            chosenFilter === filterType ? filter.classList.add("active") : filter.classList.remove("active");
                        });
                    }
                }
            };
            _this_1.handleChooseDifferentFilter = function() {
                var _this = _this_1;
                var salesFilterWrapper = document.querySelector(".bc_sales_filter_wrapper_JS");
                if (salesFilterWrapper) {
                    var filterButtons = salesFilterWrapper.querySelectorAll(".bc_sales_filter_button_JS");
                    if (filterButtons && filterButtons.length > 0) {
                        filterButtons.forEach(function(button) {
                            button.addEventListener("click", function() {
                                _this.setActiveFilter(salesFilterWrapper, this);
                                if (this.getAttribute("data-date-filter") === "custom") {
                                    _this.showCustomFilterRange();
                                } else {
                                    _this.hideCustomFilterRange();
                                }
                            });
                        });
                    }
                }
            };
            _this_1.setActiveFilter = function(filterWrapper, button) {
                if (button.classList.contains("active")) {
                    return;
                }
                _this_1.removeCustomRangeErrorMessage();
                var previousActiveFilter = filterWrapper.querySelector(".active");
                previousActiveFilter === null || previousActiveFilter === void 0 ? void 0 : previousActiveFilter.classList.remove("active");
                button.classList.add("active");
            };
            _this_1.showCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.add("active");
                }
            };
            _this_1.hideCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.remove("active");
                }
            };
            _this_1.handleApplyFilterClick = function() {
                var _this = _this_1;
                var applyButton = document.querySelector(".bc_apply_sales_filters_JS");
                if (applyButton) {
                    applyButton.addEventListener("click", function() {
                        _this.applyChosenFilter();
                    });
                }
            };
            _this_1.applyChosenFilter = function() {
                var today = window.stTranslations.today;
                var last_7_days = window.stTranslations.last_7_days;
                var last_30_days = window.stTranslations.last_30_days;
                var last_90_days = window.stTranslations.last_90_days;
                var last_12_months = window.stTranslations.last_12_months;
                var this_month = window.stTranslations.thisMonth;
                var last_month = window.stTranslations.last_month;
                var filtersWrapper = document.querySelector(".bc_sales_filter_wrapper_JS");
                if (filtersWrapper) {
                    var filter = filtersWrapper.querySelector(".active");
                    if (!filter) {
                        return;
                    }
                    if (filter) {
                        var filterType = filter.getAttribute("data-date-filter");
                        var todayDate = _this_1.sharedComponents.getStartOfDay();
                        var progressBarEl = document.querySelector(".bc_seller_dashboard_multistep_tiers_sales_JS");
                        switch (filterType) {
                          case "today":
                            var endOfDay = _this_1.sharedComponents.getEndOfDay();
                            _this_1.applyFilterAndRenderResults(todayDate, endOfDay, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(today);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("today");
                            _this_1.sharedComponents.enableBodyScroll();
                            if (progressBarEl) {
                                progressBarEl.classList.add("st_hidden");
                            }
                            break;

                          case "last_7_days":
                            var sevenDaysAgo = new Date(todayDate);
                            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                            _this_1.applyFilterAndRenderResults(sevenDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(last_7_days);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("last_7_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_30_days":
                            var thirtyDaysAgo = new Date(todayDate);
                            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                            _this_1.applyFilterAndRenderResults(thirtyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(last_30_days);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("last_30_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "this_month":
                            var startThisMonth = _this_1.sharedComponents.getStartOfThisMonth();
                            var endThismonth = _this_1.sharedComponents.getEndOfThisMonth();
                            _this_1.applyFilterAndRenderResults(startThisMonth, endThismonth, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(this_month);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("this_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            if (progressBarEl) {
                                progressBarEl.classList.remove("st_hidden");
                            }
                            break;

                          case "last_month":
                            var firstDayLastMonth = _this_1.sharedComponents.getStartOfLastMonth();
                            var lastDayLastMonth = _this_1.sharedComponents.getEndOfLastMonth();
                            _this_1.applyFilterAndRenderResults(firstDayLastMonth, lastDayLastMonth, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(last_month);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("last_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            if (progressBarEl) {
                                progressBarEl.classList.remove("st_hidden");
                            }
                            break;

                          case "last_90_days":
                            var ninetyDaysAgo = new Date(todayDate);
                            ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
                            _this_1.applyFilterAndRenderResults(ninetyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(last_90_days);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("last_90_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_12_months":
                            var twelveMonthsAgo = new Date(todayDate);
                            twelveMonthsAgo.setFullYear(twelveMonthsAgo.getFullYear() - 1);
                            _this_1.applyFilterAndRenderResults(twelveMonthsAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printChosenFilterText(last_12_months);
                            _this_1.sharedComponents.setAppropriateFilterAttribute("last_12_months");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "custom":
                            var customRangeFilterWrapper = document.querySelector(".bc_filter_custom_range_wrapper_JS");
                            if (customRangeFilterWrapper) {
                                _this_1.attachCustomRangeValidationListeners();
                                var startDateEl = customRangeFilterWrapper.querySelector(".bc_range_input_start_date_JS");
                                var endDateEl = customRangeFilterWrapper.querySelector(".bc_range_input_end_date_JS");
                                if (startDateEl && endDateEl) {
                                    if (startDateEl.value !== "" && endDateEl.value !== "") {
                                        var startDay = _this_1.sharedComponents.getStartOfSelectedDay(startDateEl.value);
                                        var endDay = _this_1.sharedComponents.getEndOfSelectedDay(endDateEl.value);
                                        _this_1.applyFilterAndRenderResults(startDay, endDay, _this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                        var startDate = new Date(startDateEl.value);
                                        var endDate = new Date(endDateEl.value);
                                        if (endDate < startDate) {
                                            _this_1.removeCustomRangeErrorMessage();
                                            customRangeFilterWrapper.appendChild(_this_1.printCustomRangeErrorMessage());
                                            return;
                                        }
                                        var isFullCalendarMonth = startDate.getDate() === 1 && new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();
                                        if (isFullCalendarMonth && progressBarEl) {
                                            progressBarEl.classList.remove("st_hidden");
                                        }
                                        if (!isFullCalendarMonth) {
                                            progressBarEl.classList.add("st_hidden");
                                        }
                                    } else {
                                        _this_1.removeCustomRangeErrorMessage();
                                        customRangeFilterWrapper.appendChild(_this_1.printCustomRangeErrorMessage());
                                        return;
                                    }
                                }
                                _this_1.closeFilterDrawer();
                                if (startDateEl && endDateEl) {
                                    _this_1.sharedComponents.printChosenFilterText(_this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                }
                                _this_1.sharedComponents.setAppropriateFilterAttribute("custom");
                                _this_1.sharedComponents.enableBodyScroll();
                            }
                            break;

                          default:
                            console.log("No filter provided.");
                        }
                    }
                }
            };
            _this_1.formatDateRange = function(startDate, endDate) {
                var fromDate = new Date(startDate);
                var toDate = new Date(endDate);
                var dayFrom = fromDate.getDate();
                var dayTo = toDate.getDate();
                var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
                var monthFrom = monthNames[fromDate.getMonth()];
                var monthTo = monthNames[toDate.getMonth()];
                var yearFrom = fromDate.getFullYear();
                var yearTo = toDate.getFullYear();
                if (yearFrom === yearTo && fromDate.getMonth() === toDate.getMonth()) {
                    return "".concat(dayFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else if (yearFrom === yearTo) {
                    return "".concat(dayFrom, " ").concat(monthFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else {
                    return "".concat(dayFrom, " ").concat(monthFrom, ", ").concat(yearFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                }
            };
            _this_1.printCustomRangeErrorMessage = function() {
                var errorText = window.stTranslations.customErrorMsg;
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_custom_range_error_message", "bc_custom_range_error_message_JS");
                errorMessage.innerHTML = errorText ? errorText : "Test Message";
                return errorMessage;
            };
            _this_1.removeCustomRangeErrorMessage = function() {
                var errorMessage = document.querySelector(".bc_custom_range_error_message_JS");
                if (errorMessage) {
                    errorMessage.remove();
                }
            };
            _this_1.applyFilterAndRenderResults = function(startDate, endDate, filterType) {
                var _a;
                var payload = {
                    affiliateId: window.customerAffiliateId,
                    dateStart: startDate.toISOString(),
                    dateEnd: endDate.toISOString()
                };
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getDashboardSales"],
                    method: "post",
                    contentType: "json",
                    data: payload,
                    callback: function(res) {
                        try {
                            var parsedResponse = JSON.parse(res.response);
                            if (parsedResponse.status === 200) {
                                _this_1.sharedComponents.showDashboardAsideContent();
                                _this_1.sharedComponents.showAppropriatePage("sales");
                                _this_1.salesModule.updateProgressBar(Number(parsedResponse.data.salesProgress));
                                _this_1.salesModule.generateOrders(parsedResponse.data.orders, true);
                                _this_1.salesModule.sharedComponents.updateOrderNumberByClass(parsedResponse.data.numberOfOrders, _this_1.salesModule.tabOrders);
                                _this_1.salesModule.sharedComponents.updateTooltipTextAndTitle(_this_1.salesModule.tabOrders, parsedResponse.data.numberOfOrders, days_30, filterType, false);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.sales, _this_1.salesModule.tabSales);
                                _this_1.salesModule.sharedComponents.updateTooltipTextAndTitle(_this_1.salesModule.tabSales, parsedResponse.data.sales, days_30, filterType, false);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.repeatCustomerSales, _this_1.salesModule.tabCustomerRepeat);
                                _this_1.salesModule.sharedComponents.updateTooltipTextAndTitle(_this_1.salesModule.tabCustomerRepeat, parsedResponse.data.repeatCustomerSales, days_30, filterType, false);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.newCustomerSales, _this_1.salesModule.tabCustomerNew);
                                _this_1.salesModule.sharedComponents.updateTooltipTextAndTitle(_this_1.salesModule.tabCustomerNew, parsedResponse.data.newCustomerSales, days_30, filterType, false);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.baseCommissions, _this_1.salesModule.tabBase);
                                _this_1.salesModule.sharedComponents.updateOrderNumberByClass(parsedResponse.data.orders.length, _this_1.salesModule.tableTitle);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.newCustomerEarnings, _this_1.salesModule.tabCommisionNew);
                                _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.oldCustomerEarnings, _this_1.salesModule.tabCommisionRepeat);
                                if (parsedResponse.data.bonusCommissions === null) {
                                    var bonusEl = document.querySelector(".bc_earnings_sales_bonus_JS");
                                    if (bonusEl) {
                                        var wrapper = _this_1.generalMethods.getClosestByClass(bonusEl, "bc_seller_dashboard_summary_card");
                                        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add("st_hidden");
                                    }
                                } else {
                                    _this_1.salesModule.sharedComponents.updateEarningsByClass(parsedResponse.data.bonusCommissions, _this_1.salesModule.tabBonus);
                                }
                            } else {
                                _this_1.sharedComponents.hideLoader();
                            }
                        } catch (e) {
                            console.error("[applyFilterAndRenderResults] Error parsing response:", e);
                            _this_1.sharedComponents.hideLoader();
                        }
                    }
                });
            };
            _this_1.attachCustomRangeValidationListeners = function() {
                var wrapper = document.querySelector(".bc_filter_custom_range_wrapper_JS");
                var startInput = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".bc_range_input_start_date_JS");
                var endInput = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".bc_range_input_end_date_JS");
                if (!startInput || !endInput) return;
                var validate = function() {
                    return _this_1.validateCustomRange(startInput, endInput, wrapper);
                };
                startInput.addEventListener("change", validate);
                endInput.addEventListener("change", validate);
            };
            _this_1.validateCustomRange = function(startInput, endInput, wrapper) {
                _this_1.removeCustomRangeErrorMessage();
                var startVal = startInput.value;
                var endVal = endInput.value;
                if (!startVal || !endVal) return;
                var startDate = new Date(startVal);
                var endDate = new Date(endVal);
                if (endDate < startDate) {
                    wrapper.appendChild(_this_1.printCustomRangeErrorMessage());
                }
            };
            _this_1.sharedComponents = sharedComponents;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StSellerDashboardSalesFilters.prototype.setSalesModule = function(module) {
            this.salesModule = module;
        };
        return StSellerDashboardSalesFilters;
    }(st_module_17.StModule);
    exports.StSellerDashboardSalesFilters = StSellerDashboardSalesFilters;
});

define("extension/shopify-app/st-modules/seller-dashboard/sales/seller-dashboard-sales", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_18, currency_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDashboardSales = void 0;
    var StDashboardSales = function(_super) {
        __extends(StDashboardSales, _super);
        function StDashboardSales(objectFormatting, sharedComponents, currency, generalMethods, salesFilters) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "SalesProgress";
            _this_1.tabOrders = "bc_earnings_sales_orders_JS";
            _this_1.tabSales = "bc_earnings_sales_sales_JS";
            _this_1.tabBase = "bc_earnings_sales_base_JS";
            _this_1.tabBonus = "bc_earnings_sales_bonus_JS";
            _this_1.tabCustomerNew = "bc_earnings_sales_customer_new_JS";
            _this_1.tabCustomerRepeat = "bc_earnings_sales_customer_repeat_JS";
            _this_1.tabCommisionNew = "bc_earnings_sales_commision_new_JS";
            _this_1.tabCommisionRepeat = "bc_earnings_sales_commision_repeat_JS";
            _this_1.tableTitle = "bc_earnings_sales_table_title_JS";
            _this_1.currentPage = 1;
            _this_1.pageSize = 10;
            _this_1.currentModalIndex = 0;
            _this_1.fetchedOrders = 0;
            _this_1.orderArray = [];
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleLandingOnSalesPage();
                    _this_1.bindLoadMore();
                });
            };
            _this_1.fetchSalesPageContent = function(activePage) {
                var _a;
                var _this = _this_1;
                _this_1.sharedComponents.showLoader();
                var customerAffiliateId = window.customerAffiliateId;
                var startThisMonth = _this_1.sharedComponents.getStartOfThisMonth();
                var endThismonth = _this_1.sharedComponents.getEndOfThisMonth();
                var salesPageRequest = {
                    affiliateId: customerAffiliateId,
                    dateStart: startThisMonth,
                    dateEnd: endThismonth
                };
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getDashboardSales"],
                        method: "post",
                        contentType: "json",
                        data: salesPageRequest,
                        callback: function(response) {
                            try {
                                var getSalesDataResponse = JSON.parse(response.response);
                                if (getSalesDataResponse.status === 200) {
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                    _this.updateProgressBar(Number(getSalesDataResponse.data.salesProgress));
                                    _this.generateOrders(getSalesDataResponse.data.orders);
                                    _this.sharedComponents.updateOrderNumberByClass(getSalesDataResponse.data.numberOfOrders, _this.tabOrders);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.tabOrders, getSalesDataResponse.data.numberOfOrders, days_30, "this_month", false);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.sales, _this.tabSales);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.tabSales, getSalesDataResponse.data.sales, days_30, "this_month", false);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.repeatCustomerSales, _this.tabCustomerRepeat);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.tabCustomerRepeat, getSalesDataResponse.data.repeatCustomerSales, days_30, "this_month", false);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.newCustomerSales, _this.tabCustomerNew);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.tabCustomerNew, getSalesDataResponse.data.newCustomerSales, days_30, "this_month", false);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.baseCommissions, _this.tabBase);
                                    _this.sharedComponents.updateOrderNumberByClass(getSalesDataResponse.data.orders.length, _this.tableTitle);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.newCustomerEarnings, _this.tabCommisionNew);
                                    _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.oldCustomerEarnings, _this.tabCommisionRepeat);
                                    if (getSalesDataResponse.data.bonusCommissions === null) {
                                        var bonusCommissionEl = document.querySelector(".bc_earnings_sales_bonus_JS");
                                        if (bonusCommissionEl) {
                                            var wrapper = _this.generalMethods.getClosestByClass(bonusCommissionEl, "bc_seller_dashboard_summary_card");
                                            wrapper.classList.add("st_hidden");
                                        }
                                    } else {
                                        _this.sharedComponents.updateEarningsByClass(getSalesDataResponse.data.bonusCommissions, _this.tabBonus);
                                    }
                                } else if (getSalesDataResponse.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this_1.generateOrders = function(fetchedOrders, replaceExisting) {
                if (replaceExisting === void 0) {
                    replaceExisting = false;
                }
                var orderTable = document.querySelector(".bc_seller_dashboard_sales_list_JS");
                if (!orderTable) return;
                if (replaceExisting) {
                    var table_row_id = window.stTranslations.table_row_id;
                    var table_row_date = window.stTranslations.table_row_date;
                    var table_row_customer = window.stTranslations.table_row_customer;
                    var table_row_order_value = window.stTranslations.table_row_order_value;
                    var table_row_commission = window.stTranslations.table_row_commission;
                    orderTable.innerHTML = "";
                    orderTable.innerHTML = '\n            <div class="bc_seller_dashboard_table-row grid-5 bc_seller_dashboard_table--header">\n          <div class="bc_table_header_text">'.concat(table_row_id, '</div>\n          <div class="bc_table_header_text">').concat(table_row_date, '</div>\n          <div class="bc_table_header_text">').concat(table_row_customer, '</div>\n          <div class="bc_table_header_text">').concat(table_row_order_value, '</div>\n          <div class="bc_table_header_text">').concat(table_row_commission, "</div>\n        </div>");
                    _this_1.currentPage = 1;
                }
                var startIndex = (_this_1.currentPage - 1) * _this_1.pageSize;
                var endIndex = _this_1.currentPage * _this_1.pageSize;
                var pageData = fetchedOrders.slice(startIndex, endIndex);
                _this_1.fetchedOrders = fetchedOrders.length;
                _this_1.orderArray = fetchedOrders;
                pageData.forEach(function(order, index) {
                    var _a;
                    var row = document.createElement("button");
                    order.date = _this_1.sharedComponents.adjustIsoDateFromGapToPstTimezone(order.date);
                    row.setAttribute("type", "button");
                    row.setAttribute("toggle-modal", "sales-order-information");
                    row.setAttribute("data-order-index", index.toString());
                    row.classList.add("bc_seller_dashboard_table-row", "grid-5", "bc_sales_information_row_JS");
                    var formatDate = _this_1.sharedComponents.returnOrderDate(order.date);
                    var orderValue = _this_1.currency.applyFormat(parseFloat(order.commissionableTotal), currency_3.ECurrencyFormatType.withCurrency);
                    var commissions = _this_1.currency.applyFormat(parseFloat(order.commission), currency_3.ECurrencyFormatType.withCurrency);
                    row.setAttribute("data-order-date", order.date);
                    var customerFullName = (order === null || order === void 0 ? void 0 : order.customerName) || "";
                    var newLabel = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.span_new;
                    var isNewCustomer = order.customerType === "New";
                    var newCustomerHTML = isNewCustomer ? '<span class="bc_customer_new_label">'.concat(newLabel, "</span>") : "";
                    row.innerHTML = '\n                <span class="bc_order_4">'.concat(order.number, '</span>\n                <span class="bc_mobile_text_gray_out bc_order_1">').concat(formatDate, '</span>\n                <span class="bc_order_5">\n                    ').concat(customerFullName, " ").concat(newCustomerHTML, '\n                </span>\n                <span class="bc_empty_column bc_order_2"></span>\n                <span class="bc_order_6">').concat(orderValue, '</span>\n                <span class="bc_mobile_text_gray_out bc_order_3">').concat(commissions, "</span>\n            ");
                    row.addEventListener("click", function() {
                        _this_1.sharedComponents.openCartDrawer();
                        _this_1.currentModalIndex = index;
                        _this_1.generateSalesCartDrawer(index, order.number);
                    });
                    orderTable.appendChild(row);
                });
                var visibleTableRows = orderTable.querySelectorAll(".bc_sales_information_row_JS");
                var originalItemsLength = fetchedOrders.length;
                var loadMoreBtn = document.querySelector(".bc_seller_dashboard_sales_load_more_JS");
                if (!loadMoreBtn) return;
                if (originalItemsLength < _this_1.pageSize || originalItemsLength === _this_1.pageSize || originalItemsLength === visibleTableRows.length) {
                    loadMoreBtn.classList.add("st_hidden");
                } else {
                    loadMoreBtn.classList.remove("st_hidden");
                    var remainingItems = originalItemsLength - visibleTableRows.length;
                    if (remainingItems > _this_1.pageSize) {
                        loadMoreBtn.innerHTML = "Load ".concat(_this_1.pageSize.toString(), " More");
                    } else {
                        loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                    }
                }
            };
            _this_1.bindLoadMore = function() {
                var loadMoreBtn = document.querySelector(".bc_seller_dashboard_sales_load_more_JS");
                if (!loadMoreBtn) return;
                loadMoreBtn.addEventListener("click", function() {
                    _this_1.currentPage++;
                    _this_1.generateOrders(_this_1.orderArray);
                });
            };
            _this_1.generateSalesCartDrawer = function(index, orderNumber) {
                var _this = _this_1;
                var payload = {
                    orderNumber: orderNumber
                };
                try {
                    _this_1.showCartDrawerLoader();
                    _this_1.ajax.send({
                        endpoint: _this.endpoint["customer"]["getOrderDetails"],
                        method: "post",
                        contentType: "json",
                        data: payload,
                        callback: function(response) {
                            var _a, _b, _c, _d, _e, _f;
                            try {
                                var getOrderDetailsDataResponse = JSON.parse(response.response);
                                if (getOrderDetailsDataResponse.status === 200) {
                                    var cartDrawerPrimaryWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                                    if (cartDrawerPrimaryWrapper) {
                                        var order = getOrderDetailsDataResponse.data;
                                        if (!!(order === null || order === void 0 ? void 0 : order.date)) {
                                            order.date = _this.sharedComponents.adjustIsoDateFromGapToPstTimezone(order.date);
                                        }
                                        var totalPrice = _this.currency.applyFormat(parseFloat(order.total), currency_3.ECurrencyFormatType.withCurrency);
                                        var formatDate = _this.sharedComponents.formatDateToReadable(order === null || order === void 0 ? void 0 : order.date);
                                        var commission = _this.currency.applyFormat(order === null || order === void 0 ? void 0 : order.commission, currency_3.ECurrencyFormatType.withCurrency);
                                        var productCredit = _this.currency.applyFormat(order === null || order === void 0 ? void 0 : order.productCredit, currency_3.ECurrencyFormatType.withCurrency);
                                        var refundValue = _this.currency.applyFormat(order === null || order === void 0 ? void 0 : order.refundValue, currency_3.ECurrencyFormatType.withCurrency);
                                        var commissionableTotal = _this.currency.applyFormat(order === null || order === void 0 ? void 0 : order.commissionableTotal, currency_3.ECurrencyFormatType.withCurrency);
                                        var customerPhone = ((_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.phone) ? order.customer.phone : "";
                                        var customerEmail = ((_b = order === null || order === void 0 ? void 0 : order.customer) === null || _b === void 0 ? void 0 : _b.email) ? order.customer.email : "";
                                        var customerNameAndLastname = (order === null || order === void 0 ? void 0 : order.customer) ? "".concat((_c = order === null || order === void 0 ? void 0 : order.customer) === null || _c === void 0 ? void 0 : _c.first_name, " ").concat(((_d = order === null || order === void 0 ? void 0 : order.customer) === null || _d === void 0 ? void 0 : _d.last_name.length) > 1 ? (_e = order === null || order === void 0 ? void 0 : order.customer) === null || _e === void 0 ? void 0 : _e.last_name : "".concat((_f = order === null || order === void 0 ? void 0 : order.customer) === null || _f === void 0 ? void 0 : _f.last_name, ".")) : "";
                                        var language = document.documentElement.lang;
                                        var orderRefundMessage = language === "en" ? window.stTranslations.orderContainsRefund : "";
                                        var createdDateText = window.stTranslations.createdDate;
                                        var customerTypeText = window.stTranslations.customerType;
                                        var customerDetailsText = window.stTranslations.customerDetails;
                                        var customerProfileText = window.stTranslations.customerProfile;
                                        var productsTitle = window.stTranslations.productsTitle;
                                        var orderTotalText = window.stTranslations.orderTotal;
                                        var orderCreditText = window.stTranslations.orderCredit;
                                        var orderRefundText = window.stTranslations.orderRefund;
                                        var commissionableTotalText = window.stTranslations.commissionableTotal;
                                        var commissionText = window.stTranslations.commission;
                                        var modalInformation = window.stTranslations.modalMessage;
                                        var commissionPercentage = order.customerType === "Repeat" ? "20%" : "40%";
                                        cartDrawerPrimaryWrapper.innerHTML = '\n                <div class="bc_contact_information_header--wrapper">\n                    <div class="bc_text_uppercase">'.concat(order.number, '</div>\n\n\n                    <div class="bc_cart_drawer_header--navigation">\n                        <button class="bc_button bc_prev_button bc_prev_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg>\n                        </button>\n                        <button class="bc_button bc_next_button bc_next_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"/></svg>\n                        </button>\n                        <button class="bc_button bc_close_button bc_close_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>\n                        </button>\n                    </div>\n                </div>\n                <div class="bc_order_refund_banner bc_order_refund_JS">').concat(orderRefundMessage, '</div>\n                 \n                <div class="bc_order_modal_block">\n                  <div class="bc_order_modal_date">\n                    ').concat(createdDateText, '\n                    <span class="bc_modal_block_full_date_JS">').concat(formatDate, '</span>\n                  </div>\n                \n                  <div class="bc_order_modal_customer_grid">\n                    <div class="bc_order_modal_customer_details_JS">\n                      <div class="bc_order_modal_label">').concat(customerDetailsText, '</div>\n                      <div class="bc_order_modal_value">\n                        <span class="bc_modal_block_phone_JS">').concat(customerNameAndLastname, '</span>\n                        <span class="bc_modal_block_email_JS">').concat(customerEmail, '</span><br>\n                        <span class="bc_modal_block_phone_JS">').concat(customerPhone, '</span>\n                      </div>\n                    </div>\n                    <div>\n                      <div class="bc_order_modal_label">').concat(customerTypeText, '</div>\n                      <div class="bc_order_modal_value">\n                        <span class="bc_modal_block_type_JS">').concat(order.customerType, '</span>\n                      </div>\n                    </div>\n                  </div>\n                \n                  <button class="bc_order_modal_profile_btn st_hidden">\n                    <span>').concat(customerProfileText, '</span>\n                  </button>\n                </div>\n                \n                <div class="bc_order_products_section">\n                    <h3 class="bc_order_section_title">').concat(productsTitle, '</h3>\n                    <div class="bc_order_products_wrapper bc_order_products_wrapper_JS"></div>\n                </div>\n                       \n                <div class="bc_order_summary">\n                  <div class="bc_summary_line">\n                    <span>').concat(orderTotalText, '</span>\n                    <span class="bc_modal_total_order_JS">').concat(totalPrice, '</span>\n                  </div>\n                  <div class="bc_summary_line bc_product_credit_JS">\n                    <span class="bc_summary_credit">').concat(orderCreditText, '</span>\n                    <span class="bc_summary_credit bc_modal_credit_order_JS">-').concat(productCredit, '</span>\n                  </div>\n                  <div class="bc_summary_line bc_refund_credit_JS">\n                    <span class="bc_summary_credit">').concat(orderRefundText, '</span>\n                    <span class="bc_summary_credit bc_modal_refund_order_JS">-').concat(refundValue, '</span>\n                  </div>\n                  <div class="bc_summary_line bc_commission_total_JS">\n                    <span>').concat(commissionableTotalText, '</span>\n                    <span class="bc_modal_commision_order_total_JS">').concat(commissionableTotal, '</span>\n                  </div>\n                  <div class="bc_summary_line">\n                    <span>\n                       ').concat(commissionText, ' (<span\n                        class="bc_modal_commision_order_total_percentage_JS">').concat(commissionPercentage, '</span\n                      >)</span\n                    >\n                    <span class="bc_modal_commision_order_JS">').concat(commission, '</span>\n                  </div>\n                  <p class="bc_order_summary_note bc_referral_border">\n                    ').concat(modalInformation, "\n                  </p>\n                </div> \n            ");
                                        _this.handlePreviousButtonClick(cartDrawerPrimaryWrapper);
                                        _this.handleNextButtonClick(cartDrawerPrimaryWrapper);
                                        _this.handleCloseButtonClick(cartDrawerPrimaryWrapper);
                                        var lineItemWrapper_1 = cartDrawerPrimaryWrapper.querySelector(".bc_order_products_wrapper_JS");
                                        order.lineItems.forEach(function(item, index) {
                                            lineItemWrapper_1.appendChild(_this.generateLineItem(item, index));
                                        });
                                        _this.productCredits(cartDrawerPrimaryWrapper, order);
                                        _this.refundBanner(cartDrawerPrimaryWrapper, order);
                                        _this.refundValue(cartDrawerPrimaryWrapper, order);
                                        _this.hideCustomerProfile(cartDrawerPrimaryWrapper, order);
                                    }
                                } else if (getOrderDetailsDataResponse.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this_1.showCartDrawerLoader = function() {
                var cartDrawerWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                if (cartDrawerWrapper) {
                    cartDrawerWrapper.innerHTML = '\n                <div class="bc_cart_drawer_loader_wrapper">\n                    <div class="bc_loader_spinner"></div>\n                </div>\n            ';
                }
            };
            _this_1.handlePreviousButtonClick = function(cartDrawerPrimaryWrapper) {
                var _this = _this_1;
                var previousButton = cartDrawerPrimaryWrapper.querySelector(".bc_prev_button_JS");
                if (previousButton) {
                    previousButton.addEventListener("click", function() {
                        if (_this.currentModalIndex > 0) {
                            _this.currentModalIndex--;
                            _this.generateSalesCartDrawer(_this.currentModalIndex, _this.orderArray[_this.currentModalIndex].number);
                        }
                    });
                }
            };
            _this_1.handleNextButtonClick = function(cartDrawerPrimaryWrapper) {
                var _this = _this_1;
                var nextButton = cartDrawerPrimaryWrapper.querySelector(".bc_next_button_JS");
                if (nextButton) {
                    nextButton.addEventListener("click", function() {
                        if (_this.currentModalIndex < _this.fetchedOrders - 1) {
                            _this.currentModalIndex++;
                            _this.generateSalesCartDrawer(_this.currentModalIndex, _this.orderArray[_this.currentModalIndex].number);
                        }
                    });
                }
            };
            _this_1.handleCloseButtonClick = function(cartDrawerPrimaryWrapper) {
                var _this = _this_1;
                var closeButton = cartDrawerPrimaryWrapper.querySelector(".bc_close_button_JS");
                if (closeButton) {
                    closeButton.addEventListener("click", function() {
                        _this.sharedComponents.closeCartDrawer();
                    });
                }
            };
            _this_1.productCredits = function(cartDrawerPrimaryWrapper, order) {
                var productCreditEl = cartDrawerPrimaryWrapper.querySelector(".bc_modal_credit_order_JS");
                if (productCreditEl && order.productCredit === 0) {
                    var wrapper = _this_1.generalMethods.getClosestByClass(productCreditEl, "bc_product_credit_JS");
                    wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add("st_hidden");
                }
            };
            _this_1.refundValue = function(cartDrawerPrimaryWrapper, order) {
                var productCreditEl = cartDrawerPrimaryWrapper.querySelector(".bc_modal_refund_order_JS");
                if (order.refundValue === 0) {
                    var wrapper = _this_1.generalMethods.getClosestByClass(productCreditEl, "bc_refund_credit_JS");
                    wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.add("st_hidden");
                }
            };
            _this_1.refundBanner = function(cartDrawerPrimaryWrapper, order) {
                var refundBanner = cartDrawerPrimaryWrapper.querySelector(".bc_order_refund_JS");
                if (order.totalRefunded || order.partiallyRefunded) {
                    return;
                }
                if (refundBanner && (!order.refundValue || order.refundValue === 0)) {
                    refundBanner.classList.add("st_hidden");
                }
            };
            _this_1.generateLineItem = function(lineItem, index) {
                var wrapper = document.createElement("div");
                var variantPrice = _this_1.currency.applyFormat(parseFloat(lineItem.price), currency_3.ECurrencyFormatType.withCurrency);
                wrapper.innerHTML = '\n            <div class="bc_order_product_row">\n                <img\n                  src="'.concat(lineItem.imageSrc, '"\n                  alt="product"\n                  class="bc_order_product_img"\n                >\n                <div class="bc_order_product_details">\n                  <div class="bc_order_product_name">\n                    ').concat(lineItem.name, '<br>\n                    \x3c!--<span>[ COUNTERGLOW ]</span>--\x3e\n                  </div>\n                  <div class="bc_order_product_variant bc_order_product_variant_JS">').concat(lineItem.variantName, '</div>\n            \n                  <div class="bc_order_product_meta">\n                    <span class="bc_order_product_qty">QTY: ').concat(lineItem.quantity, '</span>\n                    <span class="bc_order_product_price">').concat(variantPrice, "</span>\n                  </div>\n                </div>\n            </div>\n        ");
                var variantName = wrapper.querySelector(".bc_order_product_variant_JS");
                if (variantName && lineItem.variantName === "") {
                    variantName.classList.add("st_hidden");
                }
                return wrapper;
            };
            _this_1.objectFormatting = objectFormatting;
            _this_1.sharedComponents = sharedComponents;
            _this_1.currency = currency;
            _this_1.generalMethods = generalMethods;
            _this_1.salesFilters = salesFilters;
            _this_1.salesFilters.setSalesModule(_this_1);
            return _this_1;
        }
        StDashboardSales.prototype.handleLandingOnSalesPage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "sales") {
                this.fetchSalesPageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("sales");
            }
        };
        StDashboardSales.prototype.updateProgressBar = function(updateSalesBar) {
            var _this_1 = this;
            var progressPercent = 0;
            var salesAmount = updateSalesBar;
            var tier1Limit = 500;
            var tier2Limit = 1500;
            if (salesAmount <= tier1Limit) {
                progressPercent = salesAmount / tier1Limit * 50;
            } else if (salesAmount <= tier2Limit) {
                progressPercent = 50 + (salesAmount - tier1Limit) / (tier2Limit - tier1Limit) * 50;
            } else {
                progressPercent = 100;
            }
            var progressFills = document.querySelectorAll('[data-role="progress-fill"]');
            progressFills.forEach(function(fill) {
                fill.style.width = "".concat(progressPercent, "%");
            });
            var checkIcon = '\n            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M7.33464 0.5L2.7513 5.08333L0.667969 3" stroke="#68133A" stroke-linecap="round" stroke-linejoin="round"/>\n            </svg>\n        ';
            var lockIcon = '\n             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.33333 4.76562H8.66667C9.02029 4.76562 9.35943 4.90391 9.60948 5.15005C9.85952 5.39619 10 5.73003 10 6.07812V9.6875C10 10.0356 9.85952 10.3694 9.60948 10.6156C9.35943 10.8617 9.02029 11 8.66667 11H3.33333C2.97971 11 2.64057 10.8617 2.39052 10.6156C2.14048 10.3694 2 10.0356 2 9.6875V6.07812C2 5.73003 2.14048 5.39619 2.39052 5.15005C2.64057 4.90391 2.97971 4.76562 3.33333 4.76562H3.66667V2.79688C3.66667 2.18771 3.9125 1.60349 4.35008 1.17274C4.78767 0.741992 5.38116 0.5 6 0.5C6.61884 0.5 7.21233 0.741992 7.64992 1.17274C8.0875 1.60349 8.33333 2.18771 8.33333 2.79688V4.76562ZM4.82149 1.63678C4.50893 1.94445 4.33333 2.36175 4.33333 2.79688V4.76562H7.66667V2.79688C7.66667 2.36175 7.49107 1.94445 7.17851 1.63678C6.86595 1.3291 6.44203 1.15625 6 1.15625C5.55797 1.15625 5.13405 1.3291 4.82149 1.63678ZM6.5 6.5H5.5V9.5H6.5V6.5Z" fill="#68133A"/>\n            </svg>\n        ';
            var tierIcons = document.querySelectorAll('[data-role="tier-icon"]');
            tierIcons.forEach(function(iconEl) {
                var parent = iconEl.closest("[data-tier]");
                var tier = parent === null || parent === void 0 ? void 0 : parent.getAttribute("data-tier");
                var isUnlocked = false;
                if (tier === "start") {
                    isUnlocked = salesAmount > 0;
                } else if (tier === "tier1") {
                    isUnlocked = salesAmount >= tier1Limit;
                } else if (tier === "tier2") {
                    isUnlocked = salesAmount >= tier2Limit;
                }
                iconEl.innerHTML = isUnlocked ? checkIcon : lockIcon;
                iconEl.classList.toggle("unlocked", isUnlocked);
            });
            var sellMoreSpans = document.querySelectorAll(".bc_seller_dashboard_progress_bar_sell_more_JS");
            var sellBonusSpan = document.querySelectorAll(".bc_seller_dashboard_progress_bar_bonus_JS");
            var remaining = 0;
            var bonus = 0;
            if (salesAmount < tier1Limit) {
                remaining = tier1Limit - salesAmount;
                bonus = 5;
            } else if (salesAmount < tier2Limit) {
                remaining = tier2Limit - salesAmount;
                bonus = 10;
            }
            sellMoreSpans.forEach(function(span) {
                span.textContent = remaining > 0 ? _this_1.currency.applyFormat(remaining, currency_3.ECurrencyFormatType.withCurrency) : _this_1.currency.applyFormat(500, currency_3.ECurrencyFormatType.withoutCurrency);
            });
            sellBonusSpan.forEach(function(span) {
                span.textContent = "".concat(bonus, "%");
            });
            var titleEl = document.querySelector(".bc_seller_dashboard_title_text");
            var titleElFull = document.querySelector(".bc_seller_dashboard_title_text_full");
            if (salesAmount >= tier2Limit && titleEl) {
                titleEl.classList.add("bc_progress_title_hide");
                titleElFull.classList.remove("bc_progress_title_hide");
            }
        };
        StDashboardSales.prototype.hideCustomerProfile = function(cartDrawerPrimaryWrapper, order) {
            var customerEl = cartDrawerPrimaryWrapper.querySelector(".bc_order_modal_customer_details_JS");
            if (!order.customer) {
                customerEl.classList.add("st_hidden");
            }
        };
        return StDashboardSales;
    }(st_module_18.StModule);
    exports.StDashboardSales = StDashboardSales;
});

define("extension/shopify-app/st-modules/seller-dashboard/assets/seller-dashboard-assets", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardAssets = void 0;
    var StSellerDashboardAssets = function(_super) {
        __extends(StSellerDashboardAssets, _super);
        function StSellerDashboardAssets(generalMethods, sharedComponents, objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardAssets";
            _this_1.assetsTree = [];
            _this_1.currentFolderId = null;
            _this_1.breadcrumbTrail = [ {
                label: "ALL",
                id: null
            } ];
            _this_1.imageList = [];
            _this_1.foldersList = [];
            _this_1.linksList = [];
            _this_1.featuredFolderId = null;
            _this_1.featuredAssets = [];
            _this_1.headerEl = null;
            _this_1.crumbsHost = null;
            _this_1.headerTitle = null;
            _this_1.layoutBtns = null;
            _this_1.linksSectionRow = null;
            _this_1.linksSection = null;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleDownloadAllAssets();
                    _this_1.chooseDifferentLayoutClick();
                    _this_1.handleLandingOnAssetsPage();
                    _this_1.handleCloseImageOverlayContentClick();
                    _this_1.handleDownloadSingleAsset();
                });
            };
            _this_1.getDomRefs = function() {
                _this_1.headerEl || (_this_1.headerEl = document.querySelector(".bc_seller_dashboard_assets_header_wrapper"));
                _this_1.crumbsHost || (_this_1.crumbsHost = document.querySelector(".bc_assets_breadcrumbs_JS"));
                _this_1.headerTitle || (_this_1.headerTitle = document.querySelector(".bc_assets_header_title_JS"));
                _this_1.layoutBtns || (_this_1.layoutBtns = document.querySelector(".bc_seller_dashboard_assets_layout_buttons_wrapper_JS"));
                _this_1.linksSection || (_this_1.linksSection = document.querySelector(".bc_assets_section--links_JS"));
                if (_this_1.linksSection && !_this_1.linksSectionRow) {
                    _this_1.linksSectionRow = _this_1.linksSection.querySelector(".bc_assets_section_row");
                }
            };
            _this_1.syncHeaderForLevel = function() {
                _this_1.getDomRefs();
                var inRoot = _this_1.currentFolderId == null;
                if (_this_1.crumbsHost) {
                    _this_1.crumbsHost.classList.toggle("st_hidden", inRoot);
                    if (inRoot) _this_1.crumbsHost.innerHTML = "";
                }
                if (_this_1.headerTitle) _this_1.headerTitle.classList.add("st_hidden");
                if (!_this_1.linksSectionRow) return;
                var hasLinks = Array.isArray(_this_1.linksList) && _this_1.linksList.length > 0;
                _this_1.linksSectionRow.classList.toggle("st_hidden", !hasLinks);
                if (inRoot && hasLinks) {
                    if (_this_1.headerEl && _this_1.layoutBtns && _this_1.linksSectionRow.parentElement !== _this_1.headerEl) {
                        _this_1.headerEl.insertBefore(_this_1.linksSectionRow, _this_1.layoutBtns);
                    }
                } else {
                    if (_this_1.linksSection && _this_1.linksSectionRow.parentElement !== _this_1.linksSection) {
                        _this_1.linksSection.insertBefore(_this_1.linksSectionRow, _this_1.linksSection.firstChild);
                    }
                }
            };
            _this_1.fetchAssetsPageContent = function(activePage, folderId) {
                if (folderId === void 0) {
                    folderId = null;
                }
                var _this = _this_1;
                _this_1.sharedComponents.showLoader();
                try {
                    _this_1.ajax.send({
                        endpoint: _this.endpoint["customer"]["getDashboardAssets"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var resp = JSON.parse(res.response);
                                console.warn(resp);
                                if (resp.status === 200 && Array.isArray(resp.data)) {
                                    _this.assetsTree = resp.data;
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                    _this.renderForFolder(folderId);
                                    _this.renderBreadcrumbs();
                                    _this.syncHeaderForLevel();
                                } else {
                                    _this.sharedComponents.hideLoader();
                                }
                            } catch (error) {
                                console.error(error);
                                _this.sharedComponents.hideLoader();
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                    _this_1.sharedComponents.hideLoader();
                }
            };
            _this_1.renderForFolder = function(folderId) {
                var node = _this_1.findFolderById(folderId);
                var children = node && Array.isArray(node.contents) ? node.contents : _this_1.assetsTree;
                _this_1.featuredFolderId = null;
                _this_1.featuredAssets = [];
                var inRoot = folderId == null;
                var featuredChildren = [];
                if (inRoot) {
                    var featuredNode = _this_1.findChildByName(_this_1.assetsTree, "Featured");
                    if (featuredNode && featuredNode.type === "folder") {
                        _this_1.featuredFolderId = featuredNode.id;
                        featuredChildren = Array.isArray(featuredNode.contents) ? featuredNode.contents : [];
                        _this_1.featuredAssets = featuredChildren.filter(function(a) {
                            return a.type !== "folder" && a.type !== "link";
                        }).map(function(asset) {
                            return _this_1.mapAssetToImage(asset);
                        });
                    }
                }
                _this_1.imageList = children.filter(function(a) {
                    return a.type !== "folder" && a.type !== "link";
                }).map(function(asset) {
                    return _this_1.mapAssetToImage(asset);
                });
                var baseFolders = children.filter(function(a) {
                    var _a;
                    return a.type === "folder" && (!inRoot || ((_a = a.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "featured") && Array.isArray(a.contents) && a.contents.length > 0;
                }).map(function(folder) {
                    return _this_1.mapFolder(folder);
                });
                var promotedFromFeatured = [];
                if (inRoot && featuredChildren.length) {
                    promotedFromFeatured = featuredChildren.filter(function(a) {
                        return a.type === "folder" && Array.isArray(a.contents) && a.contents.length > 0;
                    }).map(function(folder) {
                        return __assign(__assign({}, _this_1.mapFolder(folder)), {
                            __featuredTop: true
                        });
                    });
                }
                _this_1.foldersList = __spreadArray(__spreadArray([], promotedFromFeatured, true), baseFolders, true);
                _this_1.linksList = children.filter(function(a) {
                    return a.type === "link" && a.link;
                }).map(function(lnk) {
                    return {
                        id: lnk.id,
                        title: lnk.name,
                        url: lnk.link
                    };
                });
                _this_1.loadAssetsLinks();
                _this_1.loadAssetsFolders();
                _this_1.loadFeaturedFolderAssets(inRoot);
                _this_1.loadAssetsImages();
                _this_1.updateSectionCounts();
                _this_1.toggleEmptySections();
                _this_1.syncHeaderForLevel();
            };
            _this_1.mapAssetToImage = function(asset) {
                var _a, _b, _c, _d, _e, _f;
                return {
                    image_url: asset.thumbnail || asset.url,
                    asset_url: asset.url,
                    image_name: (_c = (_a = asset === null || asset === void 0 ? void 0 : asset.description) !== null && _a !== void 0 ? _a : (_b = asset.name) === null || _b === void 0 ? void 0 : _b.replace(/\.[^/.]+$/, "")) !== null && _c !== void 0 ? _c : "",
                    image_extension: ((_f = (_e = (_d = asset.name) === null || _d === void 0 ? void 0 : _d.match(/\.[^/.]+$/)) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.toUpperCase()) || ""
                };
            };
            _this_1.mapFolder = function(folder) {
                var count = Array.isArray(folder.contents) ? folder.contents.length : 0;
                return {
                    id: folder.id,
                    name: folder.name,
                    items_count: count
                };
            };
            _this_1.findFolderById = function(id) {
                if (id == null) return {
                    id: null,
                    name: "ALL",
                    type: "folder",
                    parent_id: null,
                    contents: _this_1.assetsTree
                };
                var stack = __spreadArray([], _this_1.assetsTree, true);
                while (stack.length) {
                    var node = stack.shift();
                    if ((node === null || node === void 0 ? void 0 : node.type) === "folder") {
                        if (node.id === id) return node;
                        if (Array.isArray(node.contents)) stack.push.apply(stack, node.contents);
                    }
                }
                return null;
            };
            _this_1.findChildByName = function(tree, name) {
                var lower = name.toLowerCase();
                var stack = __spreadArray([], tree, true);
                while (stack.length) {
                    var node = stack.shift();
                    if ((node === null || node === void 0 ? void 0 : node.type) === "folder" && typeof node.name === "string" && node.name.toLowerCase() === lower) {
                        return node;
                    }
                    if ((node === null || node === void 0 ? void 0 : node.type) === "folder" && Array.isArray(node.contents)) {
                        stack.push.apply(stack, node.contents);
                    }
                }
                return null;
            };
            _this_1.renderBreadcrumbs = function() {
                var host = document.querySelector(".bc_assets_breadcrumbs_JS");
                if (!host) return;
                if (_this_1.currentFolderId == null) {
                    host.innerHTML = "";
                    return;
                }
                var sep = ">>";
                var html = [ '<nav class="st-breadcrumbs" aria-label="Breadcrumb">', '<ol class="st-breadcrumbs__list" itemscope itemtype="https://schema.org/BreadcrumbList">' ].concat(_this_1.breadcrumbTrail.map(function(c, idx) {
                    var isLast = idx === _this_1.breadcrumbTrail.length - 1;
                    var pos = idx + 1;
                    if (!isLast) {
                        return '<li class="st-breadcrumbs__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">' + '<a class="st-breadcrumbs__link bc_assets_crumb_JS" data-crumb-index="'.concat(idx, '" itemprop="item" href="javascript:void(0)"><span itemprop="name">').concat(c.label, "</span></a>") + '<meta itemprop="position" content="'.concat(pos, '" />') + '<span class="st-breadcrumbs__sep" aria-hidden="true">'.concat(sep, "</span>") + "</li>";
                    }
                    return '<li class="st-breadcrumbs__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">' + '<span class="st-breadcrumbs__current" aria-current="page" itemprop="name">'.concat(c.label, "</span>") + '<meta itemprop="position" content="'.concat(pos, '" />') + "</li>";
                })).concat([ "</ol></nav>" ]).join("");
                host.innerHTML = html;
                host.querySelectorAll(".bc_assets_crumb_JS").forEach(function(a) {
                    a.addEventListener("click", function() {
                        var toIndex = Number(a.getAttribute("data-crumb-index"));
                        _this_1.navigateToBreadcrumb(toIndex);
                    });
                });
            };
            _this_1.navigateToBreadcrumb = function(index) {
                var target = _this_1.breadcrumbTrail[index];
                _this_1.breadcrumbTrail = _this_1.breadcrumbTrail.slice(0, index + 1);
                _this_1.currentFolderId = target.id;
                _this_1.renderBreadcrumbs();
                _this_1.renderForFolder(_this_1.currentFolderId);
                _this_1.syncHeaderForLevel();
                var url = new URL(window.location.href);
                if (_this_1.currentFolderId == null) url.searchParams.delete("folder"); else url.searchParams.set("folder", String(_this_1.currentFolderId));
                window.history.pushState({}, "", url.toString());
            };
            _this_1.openFolder = function(folder) {
                _this_1.currentFolderId = folder.id;
                _this_1.breadcrumbTrail.push({
                    label: folder.name,
                    id: folder.id
                });
                _this_1.renderBreadcrumbs();
                _this_1.renderForFolder(folder.id);
                _this_1.syncHeaderForLevel();
                var url = new URL(window.location.href);
                url.searchParams.set("activeTab", "assets");
                url.searchParams.set("folder", String(folder.id));
                window.history.pushState({}, "", url.toString());
            };
            _this_1.updateSectionCounts = function() {
                var linksCount = document.querySelector(".bc_assets_links_count_JS");
                var foldersCount = document.querySelector(".bc_assets_folders_count_JS");
                var featuredCount = document.querySelector(".bc_assets_featured_count_JS");
                var featuredFolderCount = document.querySelector(".bc_assets_featured_folder_count_JS");
                var assetsCount = document.querySelector(".bc_assets_assets_count_JS");
                if (linksCount) linksCount.textContent = "(".concat(_this_1.linksList.length, ")");
                if (foldersCount) {
                    foldersCount.textContent = "(".concat(_this_1.foldersList.length, ")");
                }
                if (featuredCount) featuredCount.textContent = "(".concat(_this_1.imageList.length, ")");
                if (featuredFolderCount) featuredFolderCount.textContent = "(".concat(_this_1.featuredAssets.length, ")");
                if (assetsCount) assetsCount.textContent = "(".concat(_this_1.imageList.length, ")");
            };
            _this_1.toggleEmptySections = function() {
                var linksSection = _this_1.linksSection;
                if (linksSection) {
                    var empty = !_this_1.linksList || _this_1.linksList.length === 0;
                    linksSection.classList.toggle("st_hidden", empty);
                    if (_this_1.linksSectionRow) _this_1.linksSectionRow.classList.toggle("st_hidden", empty);
                }
                var foldersWrapper = document.querySelector(".bc_seller_dashboard_assets_folders_JS");
                var foldersSection = foldersWrapper === null || foldersWrapper === void 0 ? void 0 : foldersWrapper.closest(".bc_assets_section");
                if (foldersSection) {
                    var empty = !_this_1.foldersList || _this_1.foldersList.length === 0;
                    foldersSection.classList.toggle("st_hidden", empty);
                }
                var featuredSection = document.querySelector(".bc_assets_featured_folder_section_JS");
                if (featuredSection) {
                    var show = _this_1.currentFolderId == null && _this_1.featuredAssets.length > 0;
                    featuredSection.classList.toggle("st_hidden", !show);
                }
                var assetsWrapper = document.querySelector(".bc_seller_dashboard_assets_image_layout_JS");
                var assetsSection = assetsWrapper === null || assetsWrapper === void 0 ? void 0 : assetsWrapper.closest(".bc_assets_section");
                if (assetsSection) {
                    var empty = !_this_1.imageList || _this_1.imageList.length === 0;
                    assetsSection.classList.toggle("st_hidden", empty);
                }
            };
            _this_1.loadAssetsLinks = function() {
                var linksWrapper = document.querySelector(".bc_seller_dashboard_assets_links_JS");
                if (!linksWrapper) return;
                linksWrapper.innerHTML = "";
                _this_1.linksList.forEach(function(link) {
                    var a = document.createElement("a");
                    a.setAttribute("href", link.url);
                    a.setAttribute("target", "_blank");
                    a.setAttribute("rel", "noopener");
                    a.classList.add("bc_seller_dashboard_assets_image--wrapper", "st-link_button_JS", "st-link_button");
                    a.innerHTML = '\n                <span class="bc_flex_column_wrapper">\n                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                    <g clip-path="url(#clip0_6106_1504)">\n                      <path d="M6.6668 8.66666C6.9531 9.04942 7.31837 9.36612 7.73783 9.59529C8.1573 9.82446 8.62114 9.96074 9.0979 9.99489C9.57466 10.029 10.0532 9.96024 10.501 9.79319C10.9489 9.62613 11.3555 9.36471 11.6935 9.02666L13.6935 7.02666C14.3007 6.39799 14.6366 5.55598 14.629 4.68199C14.6215 3.808 14.2709 2.97196 13.6529 2.35394C13.0348 1.73591 12.1988 1.38535 11.3248 1.37775C10.4508 1.37016 9.60881 1.70614 8.98013 2.31333L7.83347 3.45333M9.33347 7.33333C9.04716 6.95058 8.68189 6.63388 8.26243 6.4047C7.84297 6.17553 7.37913 6.03925 6.90237 6.00511C6.4256 5.97096 5.94708 6.03975 5.49924 6.20681C5.0514 6.37387 4.64472 6.63528 4.3068 6.97333L2.3068 8.97333C1.69961 9.602 1.36363 10.444 1.37122 11.318C1.37881 12.192 1.72938 13.028 2.3474 13.6461C2.96543 14.2641 3.80147 14.6147 4.67546 14.6222C5.54945 14.6298 6.39146 14.2939 7.02013 13.6867L8.16013 12.5467" stroke="#010001" stroke-linecap="round" stroke-linejoin="round"/>\n                    </g>\n                    <defs><clipPath id="clip0_6106_1504"><rect width="16" height="16" fill="white"/></clipPath></defs>\n                  </svg>\n                  <span class="bc_assets_text">'.concat(link.title, "</span>\n                </span>\n            ");
                    linksWrapper.appendChild(a);
                });
            };
            _this_1.loadAssetsFolders = function() {
                var foldersWrapper = document.querySelector(".bc_seller_dashboard_assets_folders_JS");
                if (!foldersWrapper) return;
                foldersWrapper.innerHTML = "";
                var folders = __spreadArray([], _this_1.foldersList, true).sort(function(a, b) {
                    return (b.__featuredTop ? 1 : 0) - (a.__featuredTop ? 1 : 0);
                });
                folders.forEach(function(item) {
                    var folderButton = document.createElement("button");
                    folderButton.setAttribute("type", "button");
                    folderButton.classList.add("bc_seller_dashboard_assets_image--wrapper", "st-folder_button_JS");
                    folderButton.setAttribute("data-folder-id", String(item.id));
                    folderButton.innerHTML = '\n                <span class="st-folder_body">\n                  <span class="st-folder_row">\n                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                      <path d="M14.6673 12.6667C14.6673 13.0203 14.5268 13.3594 14.2768 13.6095C14.0267 13.8595 13.6876 14 13.334 14H2.66732C2.3137 14 1.97456 13.8595 1.72451 13.6095C1.47446 13.3594 1.33398 13.0203 1.33398 12.6667V3.33333C1.33398 2.97971 1.47446 2.64057 1.72451 2.39052C1.97456 2.14048 2.3137 2 2.66732 2H6.00065L7.33398 4H13.334C13.6876 4 14.0267 4.14048 14.2768 4.39052C14.5268 4.64057 14.6673 4.97971 14.6673 5.33333V12.6667Z" stroke="#010001" stroke-linecap="round" stroke-linejoin="round"/>\n                    </svg>\n                    <span class="bc_assets_text">'.concat(item.name, '</span>\n                  </span>\n                  <span class="st-folder_count">').concat(item.items_count, " items</span>\n                </span>\n            ");
                    folderButton.addEventListener("click", function() {
                        _this_1.openFolder({
                            id: item.id,
                            name: item.name
                        });
                    });
                    foldersWrapper.appendChild(folderButton);
                });
            };
            _this_1.loadFeaturedFolderAssets = function(inRoot) {
                var _this = _this_1;
                var section = document.querySelector(".bc_assets_featured_folder_section_JS");
                var wrapper = document.querySelector(".bc_seller_dashboard_assets_featured_assets_JS");
                if (!section || !wrapper) return;
                if (!inRoot || _this_1.featuredAssets.length === 0) {
                    section.classList.add("st_hidden");
                    wrapper.innerHTML = "";
                    return;
                }
                section.classList.remove("st_hidden");
                wrapper.innerHTML = "";
                _this_1.featuredAssets.forEach(function(image) {
                    var imageButton = document.createElement("button");
                    imageButton.setAttribute("type", "button");
                    imageButton.classList.add("bc_seller_dashboard_assets_image--wrapper", "bc_seller_dashboard_assets_image_button_JS");
                    imageButton.setAttribute("data-image-url", image.image_url);
                    imageButton.setAttribute("data-image-name", image.image_name);
                    imageButton.setAttribute("data-asset-url", image.asset_url);
                    imageButton.setAttribute("data-image-extension", image.image_extension);
                    imageButton.innerHTML = '\n                <span class="bc_flex_column_wrapper">\n                    <img class="bc_seller_dashboard_assets_image" src="'.concat(image.image_url || "", '" alt="" data-asset-url="').concat(image.asset_url || "", '">\n                    <span class="bc_assets_text">').concat(image.image_name, '</span>\n                </span>\n                <span class="bc_flex_wrapper">\n                    <span class="bc_assets_text">').concat(image.image_extension, "</span>\n                </span>\n            ");
                    imageButton.addEventListener("click", function() {
                        if (this.classList.contains("active")) return;
                        _this.setImageActiveState(this);
                        _this.setImageContent(this);
                        var mq = window.matchMedia("(max-width: 1023px)");
                        if (mq.matches) {
                            _this.openImageOverlayContent();
                            _this.disableScroll();
                        }
                    });
                    wrapper.appendChild(imageButton);
                });
            };
            _this_1.loadAssetsImages = function() {
                var _this = _this_1;
                var imagesWrapper = document.querySelector(".bc_seller_dashboard_assets_image_layout_JS");
                if (imagesWrapper) {
                    imagesWrapper.innerHTML = "";
                    _this_1.imageList.forEach(function(image) {
                        var imageButton = document.createElement("button");
                        imageButton.setAttribute("type", "button");
                        imageButton.setAttribute("data-image-url", image.image_url);
                        imageButton.setAttribute("data-image-name", image.image_name);
                        imageButton.setAttribute("data-asset-url", image.asset_url);
                        imageButton.setAttribute("data-image-extension", image.image_extension);
                        imageButton.classList.add("bc_seller_dashboard_assets_image--wrapper", "bc_seller_dashboard_assets_image_button_JS");
                        imageButton.innerHTML = '\n                <span class="bc_flex_column_wrapper">\n                    <img class="bc_seller_dashboard_assets_image" src="'.concat(image.image_url, '" alt="" data-asset-url="').concat(image.asset_url, '">\n                    <span class="bc_assets_text">').concat(image.image_name, '</span>\n                </span>\n                <span class="bc_flex_wrapper">\n                    <span class="bc_assets_text">').concat(image.image_extension, "</span>\n                </span>\n            ");
                        imageButton.addEventListener("click", function() {
                            if (this.classList.contains("active")) return;
                            _this.setImageActiveState(this);
                            _this.setImageContent(this);
                            var mq = window.matchMedia("(max-width: 1023px)");
                            if (mq.matches) {
                                _this.openImageOverlayContent();
                                _this.disableScroll();
                            }
                        });
                        imagesWrapper.appendChild(imageButton);
                    });
                }
            };
            _this_1.chooseDifferentLayoutClick = function() {
                var _this = _this_1;
                var buttons = document.querySelectorAll(".bc_seller_dashboard_assets_layout_button_JS");
                if (buttons && buttons.length > 0) {
                    buttons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            if (this.classList.contains("active")) {
                                return;
                            }
                            _this.setActiveState(this);
                            var imageLayoutWrapper = document.querySelector(".bc_seller_dashboard_assets_image_layout_JS");
                            if (imageLayoutWrapper) {
                                _this.handleLayoutChange(this, imageLayoutWrapper);
                            }
                            var foldersWrapper = document.querySelector(".bc_seller_dashboard_assets_folders_JS");
                            if (foldersWrapper) _this.handleLayoutChange(this, foldersWrapper);
                            var linksWrapper = document.querySelector(".bc_seller_dashboard_assets_links_JS");
                            if (linksWrapper) _this.handleLayoutChange(this, linksWrapper);
                            var featuredAssetsWrapper = document.querySelector(".bc_seller_dashboard_assets_featured_assets_JS");
                            if (featuredAssetsWrapper) _this.handleLayoutChange(this, featuredAssetsWrapper);
                        });
                    });
                }
            };
            _this_1.setImageContent = function(button) {
                var imageWrapper = document.querySelector(".bc_seller_dashboard_assets_image_layout_JS");
                if (imageWrapper) {
                    var imageUrl = button.getAttribute("data-image-url");
                    var imageName = button.getAttribute("data-image-name");
                    var assetUrl = button.getAttribute("data-asset-url");
                    var imageExtension = button.getAttribute("data-image-extension");
                    _this_1.injectChosenImageContent(imageName, imageExtension, imageUrl, assetUrl);
                }
            };
            _this_1.injectChosenImageContent = function(imageName, imageExtension, imageUrl, assetUrl) {
                var _this = _this_1;
                var chosenImageWrapper = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                if (chosenImageWrapper) {
                    chosenImageWrapper.innerHTML = '\n                <div class="bc_seller_dashboard_chosen_image_name_wrapper">\n                    <div class="bc_text_uppercase">'.concat(imageName, '</div>\n                    <div class="bc_text_uppercase">').concat(imageExtension, '</div>\n                    <button class="bc_close_chosen_image_button bc_close_chosen_image_button_JS" type="button">\n                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>\n                    </button>\n                </div>\n                <div class="bc_chosen_image_wrapper">\n                    <img src="').concat(imageUrl, '" alt="asset_image" data-asset-url="').concat(assetUrl, '"/>\n                </div>\n                <button class="bc_assets_download_button bc_assets_download_single_button_JS" type="button">\n                    <span>').concat(window.stTranslations.download, "</span>\n                </button>\n            ");
                    var button = chosenImageWrapper.querySelector(".bc_close_chosen_image_button_JS");
                    if (button) {
                        button.addEventListener("click", function() {
                            _this.closeImageOverlayContent();
                            _this.removeActiveStateFromPreviousImage();
                            _this.enableScroll();
                        });
                    }
                }
            };
            _this_1.handleCloseImageOverlayContentClick = function() {
                var _this = _this_1;
                var overlayButton = document.querySelector(".bc_seller_dashboard_chosen_image_overlay_JS");
                if (overlayButton) {
                    overlayButton.addEventListener("click", function() {
                        _this.closeImageOverlayContent();
                        _this.removeActiveStateFromPreviousImage();
                        _this.enableScroll();
                    });
                }
            };
            _this_1.disableScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this_1.enableScroll = function() {
                document.body.style.overflow = "auto";
            };
            _this_1.openImageOverlayContent = function() {
                var chosenImageOverlay = document.querySelector(".bc_seller_dashboard_chosen_image_overlay_JS");
                var chosenImageContent = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                chosenImageOverlay === null || chosenImageOverlay === void 0 ? void 0 : chosenImageOverlay.classList.add("active");
                chosenImageContent === null || chosenImageContent === void 0 ? void 0 : chosenImageContent.classList.add("active");
            };
            _this_1.closeImageOverlayContent = function() {
                var chosenImageOverlay = document.querySelector(".bc_seller_dashboard_chosen_image_overlay_JS");
                var chosenImageContent = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                chosenImageOverlay === null || chosenImageOverlay === void 0 ? void 0 : chosenImageOverlay.classList.remove("active");
                chosenImageContent === null || chosenImageContent === void 0 ? void 0 : chosenImageContent.classList.remove("active");
            };
            _this_1.removeActiveStateFromPreviousImage = function() {
                var imageWrapper = document.querySelector(".bc_seller_dashboard_assets_image_layout_JS");
                if (imageWrapper) {
                    var images = imageWrapper.querySelectorAll(".bc_seller_dashboard_assets_image_button_JS");
                    images.forEach(function(image) {
                        image.classList.remove("active");
                    });
                }
                var featured = document.querySelector(".bc_seller_dashboard_assets_featured_assets_JS");
                featured === null || featured === void 0 ? void 0 : featured.querySelectorAll(".bc_seller_dashboard_assets_image_button_JS").forEach(function(el) {
                    return el.classList.remove("active");
                });
            };
            _this_1.setImageActiveState = function(button) {
                if (!button) return;
                var imagesWrapper = _this_1.generalMethods.getClosestByClass(button, "bc_seller_dashboard_assets_image_layout_JS") || _this_1.generalMethods.getClosestByClass(button, "bc_seller_dashboard_assets_featured_assets_JS");
                if (!imagesWrapper) return;
                var previousActiveEl = imagesWrapper.querySelector(".active");
                previousActiveEl === null || previousActiveEl === void 0 ? void 0 : previousActiveEl.classList.remove("active");
                button.classList.add("active");
            };
            _this_1.setActiveState = function(button) {
                var buttonWrapper = _this_1.generalMethods.getClosestByClass(button, "bc_seller_dashboard_assets_layout_buttons_wrapper_JS");
                var previousActiveEl = buttonWrapper.querySelector(".active");
                previousActiveEl === null || previousActiveEl === void 0 ? void 0 : previousActiveEl.classList.remove("active");
                button.classList.add("active");
            };
            _this_1.handleLayoutChange = function(button, imageLayoutWrapper) {
                var chosenLayout = button.getAttribute("data-image-layout");
                if (chosenLayout === "grid") {
                    imageLayoutWrapper.classList.add("bc_grid_layout");
                    imageLayoutWrapper.classList.remove("bc_list_layout");
                } else if (chosenLayout === "list") {
                    imageLayoutWrapper.classList.add("bc_list_layout");
                    imageLayoutWrapper.classList.remove("bc_grid_layout");
                } else {
                    console.error("Invalid layout selected");
                }
            };
            _this_1.handleDownloadAllAssets = function() {
                var downloadButton = document.querySelector(".bc_seller_dashboard_download_all_assets_JS");
                if (!downloadButton) return;
                downloadButton.addEventListener("click", function() {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var assetButtons, index, btn, img, nameSpan, fileUrl, nameText, extension, filename, proxyUrl, response, _a, _b, _c, blob, blobUrl, link, e_1;
                        var _d;
                        return __generator(this, function(_e) {
                            switch (_e.label) {
                              case 0:
                                _e.trys.push([ 0, , 10, 11 ]);
                                this.sharedComponents.toggleAssetsDownloadAllLoader(true);
                                assetButtons = document.querySelectorAll(".bc_seller_dashboard_assets_image_layout_JS .bc_seller_dashboard_assets_image--wrapper," + ".bc_seller_dashboard_assets_featured_assets_JS .bc_seller_dashboard_assets_image--wrapper");
                                index = 0;
                                _e.label = 1;

                              case 1:
                                if (!(index < assetButtons.length)) return [ 3, 9 ];
                                btn = assetButtons[index];
                                img = btn.querySelector(".bc_seller_dashboard_assets_image");
                                nameSpan = btn.querySelector(".bc_assets_text");
                                if (!img || !img.getAttribute("data-asset-url")) return [ 3, 8 ];
                                fileUrl = img.getAttribute("data-asset-url");
                                nameText = ((_d = nameSpan === null || nameSpan === void 0 ? void 0 : nameSpan.textContent) === null || _d === void 0 ? void 0 : _d.trim()) || "asset-".concat(index + 1);
                                extension = this.getFileExtension(fileUrl) || this.getFileExtensionFromText(nameText) || "file";
                                filename = "".concat(this.slugify(nameText), ".").concat(extension);
                                _e.label = 2;

                              case 2:
                                _e.trys.push([ 2, 7, , 8 ]);
                                proxyUrl = "".concat(this.endpoint["customer"]["proxyDownload"], "?url=").concat(encodeURIComponent(fileUrl));
                                return [ 4, fetch(proxyUrl) ];

                              case 3:
                                response = _e.sent();
                                if (!!response.ok) return [ 3, 5 ];
                                _b = (_a = console).error;
                                _c = [ "Proxy download failed:" ];
                                return [ 4, response.text() ];

                              case 4:
                                _b.apply(_a, _c.concat([ _e.sent() ]));
                                return [ 2 ];

                              case 5:
                                return [ 4, response.blob() ];

                              case 6:
                                blob = _e.sent();
                                blobUrl = URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.href = blobUrl;
                                link.download = filename;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(blobUrl);
                                return [ 3, 8 ];

                              case 7:
                                e_1 = _e.sent();
                                console.error("Failed to download single asset via proxy:", e_1);
                                return [ 3, 8 ];

                              case 8:
                                index++;
                                return [ 3, 1 ];

                              case 9:
                                return [ 3, 11 ];

                              case 10:
                                this.sharedComponents.toggleAssetsDownloadAllLoader(false);
                                return [ 7 ];

                              case 11:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this_1.getFileExtension = function(url) {
                try {
                    var pathname = new URL(url).pathname;
                    var match = pathname.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
                    return match ? match[1] : "";
                } catch (e) {
                    console.warn("Invalid URL:", url);
                    return "";
                }
            };
            _this_1.getFileExtensionFromText = function(text) {
                var match = text.match(/\.([a-zA-Z0-9]+)$/);
                return match ? match[1] : "";
            };
            _this_1.slugify = function(text) {
                return text.toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "");
            };
            _this_1.isDownloadingSingleAsset = false;
            _this_1.handleDownloadSingleAsset = function() {
                var parent = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                if (!parent) return;
                if (parent._download_listener_attached) return;
                parent._download_listener_attached = true;
                parent.addEventListener("click", function(event) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, wrapper, img, nameEls, imgSrc, baseName, extensionText, extension, filename, proxyUrl, response, _a, _b, _c, blob, blobUrl, link, e_2;
                        var _d, _e;
                        return __generator(this, function(_f) {
                            switch (_f.label) {
                              case 0:
                                target = event.target;
                                if (!target.closest(".bc_assets_download_single_button_JS")) return [ 2 ];
                                if (this.isDownloadingSingleAsset) return [ 2 ];
                                wrapper = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                                if (!wrapper) return [ 2 ];
                                this.isDownloadingSingleAsset = true;
                                this.sharedComponents.toggleAssetsSingleDownloadLoader(true);
                                _f.label = 1;

                              case 1:
                                _f.trys.push([ 1, 6, 7, 8 ]);
                                img = wrapper.querySelector("img");
                                nameEls = wrapper.querySelectorAll(".bc_text_uppercase");
                                if (!img || !img.getAttribute("data-asset-url") || nameEls.length < 2) return [ 2 ];
                                imgSrc = img.getAttribute("data-asset-url");
                                baseName = ((_d = nameEls[0].textContent) === null || _d === void 0 ? void 0 : _d.trim()) || "asset";
                                extensionText = ((_e = nameEls[1].textContent) === null || _e === void 0 ? void 0 : _e.trim()) || "";
                                extension = this.getFileExtension(imgSrc) || this.getFileExtensionFromText(extensionText) || "file";
                                filename = "".concat(this.slugify(baseName), ".").concat(extension);
                                proxyUrl = "".concat(this.endpoint["customer"]["proxyDownload"], "?url=").concat(encodeURIComponent(imgSrc));
                                return [ 4, fetch(proxyUrl) ];

                              case 2:
                                response = _f.sent();
                                if (!!response.ok) return [ 3, 4 ];
                                _b = (_a = console).error;
                                _c = [ "Proxy download failed:" ];
                                return [ 4, response.text() ];

                              case 3:
                                _b.apply(_a, _c.concat([ _f.sent() ]));
                                return [ 2 ];

                              case 4:
                                return [ 4, response.blob() ];

                              case 5:
                                blob = _f.sent();
                                blobUrl = URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.href = blobUrl;
                                link.download = filename;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                URL.revokeObjectURL(blobUrl);
                                return [ 3, 8 ];

                              case 6:
                                e_2 = _f.sent();
                                console.error("Failed to download single asset via proxy:", e_2);
                                return [ 3, 8 ];

                              case 7:
                                this.isDownloadingSingleAsset = false;
                                this.sharedComponents.toggleAssetsSingleDownloadLoader(false);
                                return [ 7 ];

                              case 8:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.sharedComponents = sharedComponents;
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        StSellerDashboardAssets.prototype.handleLandingOnAssetsPage = function() {
            var _a;
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "assets") {
                var initialFolderId = urlParams.folder ? Number(urlParams.folder) : null;
                this.currentFolderId = isNaN(initialFolderId) ? null : initialFolderId;
                if (this.currentFolderId) this.breadcrumbTrail = [ {
                    label: "ALL",
                    id: null
                } ];
                this.syncHeaderForLevel();
                this.fetchAssetsPageContent("assets", this.currentFolderId);
                this.sharedComponents.setActivePage("assets");
                (_a = document.querySelector(".bc_seller_dashboard_referral_links_JS")) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
            }
        };
        return StSellerDashboardAssets;
    }(st_module_19.StModule);
    exports.StSellerDashboardAssets = StSellerDashboardAssets;
});

define("extension/shopify-app/st-modules/seller-dashboard/referrals/seller-dashboard-referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_20, currency_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardReferral = void 0;
    var StSellerDashboardReferral = function(_super) {
        __extends(StSellerDashboardReferral, _super);
        function StSellerDashboardReferral(objectFormatting, sharedComponents, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerDashboardReferral";
            _this.referalsArray = [];
            _this.fetchedReferals = 0;
            _this.currentPage = 1;
            _this.pageSize = 10;
            _this.orderMaxProgress = 250;
            _this.tabReferral = "bc_earnings_referals_tab_referral";
            _this.tabActivations = "bc_earnings_referals_tab_activations";
            _this.tabBonus = "bc_earnings_referals_tab_bonus";
            _this.referalsNumber = "bc_seller_dashboard_referral_numbers_JS";
            _this.referalNumberForBonus = "bc_seller_dashboard_progress_value_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.handleLandingOnReferalsPage();
                    _this.bindLoadMore();
                });
            };
            _this.fetchReferalPageContent = function(activePage) {
                _this.sharedComponents.showLoader();
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["getDashboardReferrals"],
                        method: "post",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId
                        },
                        callback: function(res) {
                            try {
                                var referalData = JSON.parse(res.response);
                                if (referalData.status === 200) {
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                    _this.updateReferralProgressBar(Number(referalData.data.activations));
                                    _this.renderReferals(referalData.data.referrals);
                                    _this.sharedComponents.updateOrderNumberByClass(referalData.data.numberOfReferrals, _this.tabReferral);
                                    _this.sharedComponents.updateOrderNumberByClass(referalData.data.activations, _this.tabActivations);
                                    _this.sharedComponents.updateEarningsByClass(referalData.data.bonus, _this.tabBonus);
                                    _this.sharedComponents.updateOrderNumberByClass(referalData.data.referrals.length, _this.referalsNumber);
                                    var activationsNeedNumber = _this.calculateOffsetReferal(Number(referalData.data.activations)) === 0 ? 10 : _this.calculateOffsetReferal(10 - Number(referalData.data.activations));
                                    _this.updateNumberReferallsActivationsAllByClass(activationsNeedNumber, _this.referalNumberForBonus);
                                } else if (referalData.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this.bindLoadMore = function() {
                var loadMoreBtn = document.querySelector(".bc_seller_dashboard_referal_load_more_JS");
                if (!loadMoreBtn) return;
                loadMoreBtn.addEventListener("click", function() {
                    _this.currentPage++;
                    _this.renderReferals(_this.referalsArray);
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            _this.currency = currency;
            return _this;
        }
        StSellerDashboardReferral.prototype.handleLandingOnReferalsPage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "referrals") {
                this.fetchReferalPageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("referrals");
            }
        };
        StSellerDashboardReferral.prototype.updateNumberReferallsActivationsAllByClass = function(num, className) {
            var earningsElement = document.querySelectorAll(".".concat(className));
            earningsElement.forEach(function(span) {
                span.textContent = "".concat(num);
            });
        };
        StSellerDashboardReferral.prototype.updateReferralProgressBar = function(activations) {
            var referalActivationsValue = this.calculateOffsetReferal(activations);
            var goal = 10;
            var progressPercent = Math.min(referalActivationsValue / goal * 100, 100);
            var progressFills = document.querySelectorAll('[data-role="referral-progress-fill"]');
            progressFills.forEach(function(fill) {
                fill.style.width = "".concat(progressPercent, "%");
            });
        };
        StSellerDashboardReferral.prototype.calculateOffsetReferal = function(value) {
            if (value >= 10) {
                var mod = value % 10;
                return mod === 0 ? 0 : 10 - mod;
            } else {
                return value;
            }
        };
        StSellerDashboardReferral.prototype.renderReferals = function(referalsApiArray) {
            var _this = this;
            var ordersBody = document.querySelector(".bc_seller_dashboard_referral_list_page_JS");
            if (!ordersBody) return;
            var startIndex = (this.currentPage - 1) * this.pageSize;
            var endIndex = this.currentPage * this.pageSize;
            var pageData = referalsApiArray.slice(startIndex, endIndex);
            this.fetchedReferals = referalsApiArray.length;
            this.referalsArray = referalsApiArray;
            pageData.forEach(function(order) {
                var row = document.createElement("button");
                row.setAttribute("type", "button");
                row.classList.add("bc_seller_dashboard_table-row", "grid-4", "bc_seller_dashboard_referral_table_wrapper");
                var formatDate = _this.sharedComponents.returnOrderDate(order.created_at);
                row.innerHTML = '\n                <span class="bc_order_3">'.concat(order.name, '</span>\n                <span class="bc_order_1">').concat(order.email, '</span>\n                <span class="bc_order_2">').concat(formatDate, '</span>\n                <span class="bc_order_4 bc_progress_bar_outer_wrapper">\n                    <div class="bc_progress-wrapper">\n                        <div class="bc_circular-progress"\n                            data-amount="').concat(order.total_revenue, '"\n                            data-goal="').concat(_this.orderMaxProgress, '">\n                        <svg viewBox="0 0 36 36">\n                            <path class="bc_circle-bg"\n                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />\n                            <path class="bc_circle"\n                            stroke-dasharray="0, 100"\n                            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />\n                        </svg>\n                        </div>\n                        <div class="bc_progress-label"></div>\n                    </div>\n                </span>\n            ');
                ordersBody.appendChild(row);
            });
            document.querySelectorAll(".bc_circular-progress").forEach(function(el) {
                var _a;
                var amount = parseFloat(el.getAttribute("data-amount") || "0");
                var goal = parseFloat(el.getAttribute("data-goal") || "250");
                var percent = Math.min(amount / goal * 100, 100).toFixed(2);
                var circle = el.querySelector(".bc_circle");
                var label = (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".bc_progress-label");
                if (circle) {
                    circle.setAttribute("stroke-dasharray", "".concat(percent, ", 100"));
                }
                if (label) {
                    var progresFormated = _this.currency.applyFormat(parseFloat(amount.toString()), currency_4.ECurrencyFormatType.withCurrency);
                    label.textContent = amount >= goal ? "Complete" : progresFormated + " / 250";
                }
            });
            var visibleTableRows = ordersBody.querySelectorAll(".bc_shared_cart_information_row_JS");
            var loadMoreBtn = document.querySelector(".bc_seller_dashboard_referal_load_more_JS");
            if (!loadMoreBtn) return;
            var originalItemsLength = referalsApiArray.length;
            if (originalItemsLength < this.pageSize || originalItemsLength === this.pageSize || originalItemsLength === visibleTableRows.length) {
                loadMoreBtn.classList.add("st_hidden");
            } else {
                loadMoreBtn.classList.remove("st_hidden");
                var remainingItems = originalItemsLength - visibleTableRows.length;
                if (remainingItems > this.pageSize) {
                    loadMoreBtn.innerHTML = "Load ".concat(this.pageSize.toString(), " More");
                } else {
                    loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                }
            }
        };
        return StSellerDashboardReferral;
    }(st_module_20.StModule);
    exports.StSellerDashboardReferral = StSellerDashboardReferral;
});

define("extension/shopify-app/st-modules/seller-dashboard/contacts/seller-dashboard-contacts", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_21, currency_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardContacts = void 0;
    var StSellerDashboardContacts = function(_super) {
        __extends(StSellerDashboardContacts, _super);
        function StSellerDashboardContacts(objectFormatting, sharedComponents, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerDashboardContacts";
            _this.numberOfContacts = "bc_seller_dashboard_total_contacts_JS";
            _this.contactsArray = [];
            _this.contactCurrentPage = 1;
            _this.contactPageSize = 10;
            _this.currentModalIndex = 0;
            _this.fetchedOrders = 0;
            _this.orderCurrentPage = 1;
            _this.orderPageSize = 10;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.bindLoadMoreForContacts();
                    _this.handleLandingOnContactsPage();
                    _this.handleDownloadContactList();
                    _this.setupDrawerNavigationHandlers();
                    _this.bindSortDropdown();
                });
            };
            _this.fetchContactsPageContent = function(activePage) {
                _this.sharedComponents.showLoader();
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["getContacts"],
                        method: "post",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId
                        },
                        callback: function(res) {
                            try {
                                var contactData = JSON.parse(res.response);
                                if (contactData.status === 200) {
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                    _this.sharedComponents.updateOrderNumberByClass(contactData.data.length, _this.numberOfContacts);
                                    _this.renderContacts(contactData.data);
                                } else if (contactData.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this.generateContactCartDrawer = function(index) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                var cartDrawerPrimaryWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                if (!cartDrawerPrimaryWrapper) return;
                var contact = _this.contactsArray[index];
                var customerSince = window.stTranslations.customerSince;
                var summaryLabel = window.stTranslations.summaryLabel;
                var tooltipTextSummary = window.stTranslations.tooltipTextSummary;
                var aovLabel = window.stTranslations.aovLabel;
                var tooltipTextAov = window.stTranslations.tooltipTextAov;
                var totalSpent = window.stTranslations.totalSpent;
                var tooltipTotalSpent = window.stTranslations.tooltipTotalSpent;
                var commisions = window.stTranslations.commisions;
                var tooltipCommisions = window.stTranslations.tooltipCommisions;
                var contactDetailsText = window.stTranslations.contactDetailsText;
                var shippingAddressText = window.stTranslations.shippingAddressText;
                var billingAddressText = window.stTranslations.billingAddressText;
                var orderNumber = window.stTranslations.orderNumber;
                var orderDate = window.stTranslations.orderDate;
                var orderValue = window.stTranslations.orderValue;
                var formatedDateRead = "";
                if (contact.customerSince) {
                    formatedDateRead = _this.sharedComponents.formatDateToReadable(contact.customerSince);
                }
                var aovFormated = _this.currency.applyFormat(parseFloat("0"), currency_5.ECurrencyFormatType.withCurrency);
                if (contact.aov) {
                    aovFormated = _this.currency.applyFormat(parseFloat(contact.aov.toString()), currency_5.ECurrencyFormatType.withCurrency);
                }
                var totalSpentFormated = _this.currency.applyFormat(parseFloat("0"), currency_5.ECurrencyFormatType.withCurrency);
                if (contact.totalSpent) {
                    totalSpentFormated = _this.currency.applyFormat(parseFloat(contact.totalSpent.toString()), currency_5.ECurrencyFormatType.withCurrency);
                }
                var commissionFormated = _this.currency.applyFormat(parseFloat("0"), currency_5.ECurrencyFormatType.withCurrency);
                if (contact.commission) {
                    commissionFormated = _this.currency.applyFormat(parseFloat(contact.commission.toString()), currency_5.ECurrencyFormatType.withCurrency);
                }
                cartDrawerPrimaryWrapper.innerHTML = '\n            <div class="bc_contact_information_header--wrapper">\n                    <div class="bc_text_uppercase">'.concat(contact.firstName, " ").concat(contact.lastName, '</div>\n\n\n                    <div class="bc_cart_drawer_header--navigation">\n                        <button class="bc_button bc_prev_button bc_prev_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg>\n                        </button>\n                        <button class="bc_button bc_next_button bc_next_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"/></svg>\n                        </button>\n                        <button class="bc_button bc_close_button bc_close_button_JS">\n                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>\n                        </button>\n                    </div>\n            </div>\n\n            <div class="bc_cart_drawer_inner_wrapper bc_cart_drawer_inner_wrapper_JS">\n\n                <div class="bc_contact_information_content_wrapper bc_contact_information_content_wrapper_JS">\n\n                    <div class="bc_contact_information_customer_info_wrapper">\n                        <span>').concat(customerSince, "</span>\n                        <span>").concat(formatedDateRead, '</span>\n                    </div>\n\n                    <div class="bc_grid_layout_wrapper">\n\n                        <div class="bc_seller_dashboard_summary_card">\n                            <div class="bc_seller_dashboard_summary_card_top">\n                                <span class="bc_seller_dashboard_summary_label">\n                                ').concat(summaryLabel, '\n                                </span>\n                                <div class="bc_seller_dashboard_info_icon">\n\n                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                    <path d="M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6826 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6826 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z" stroke="#645A5C" stroke-linecap="round" stroke-linejoin="round"/>\n                                    </svg>\n\n                                    <div class="bc_tooltip">\n                                ').concat(tooltipTextSummary, '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="bc_seller_dashboard_summary_card_value">').concat(contact.orders.length, '</div>\n                        </div>\n\n                        <div class="bc_seller_dashboard_summary_card">\n                            <div class="bc_seller_dashboard_summary_card_top">\n                                <span class="bc_seller_dashboard_summary_label">\n                                ').concat(aovLabel, '\n                                </span>\n                                <div class="bc_seller_dashboard_info_icon">\n\n                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                    <path d="M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6826 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6826 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z" stroke="#645A5C" stroke-linecap="round" stroke-linejoin="round"/>\n                                    </svg>\n\n                                    <div class="bc_tooltip">\n                                ').concat(tooltipTextAov, '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="bc_seller_dashboard_summary_card_value">').concat(aovFormated, '</div>\n                        </div>\n\n                        <div class="bc_seller_dashboard_summary_card">\n                            <div class="bc_seller_dashboard_summary_card_top">\n                                <span class="bc_seller_dashboard_summary_label">\n                                ').concat(totalSpent, '\n                                </span>\n                                <div class="bc_seller_dashboard_info_icon">\n\n                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                    <path d="M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6826 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6826 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z" stroke="#645A5C" stroke-linecap="round" stroke-linejoin="round"/>\n                                    </svg>\n\n                                    <div class="bc_tooltip">\n                                ').concat(tooltipTotalSpent, '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="bc_seller_dashboard_summary_card_value">').concat(totalSpentFormated, '</div>\n                        </div>\n\n                        <div class="bc_seller_dashboard_summary_card">\n                            <div class="bc_seller_dashboard_summary_card_top">\n                                <span class="bc_seller_dashboard_summary_label">\n                                ').concat(commisions, '\n                                </span>\n                                <div class="bc_seller_dashboard_info_icon">\n\n                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                    <path d="M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6826 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6826 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z" stroke="#645A5C" stroke-linecap="round" stroke-linejoin="round"/>\n                                    </svg>\n\n                                    <div class="bc_tooltip">\n                                ').concat(tooltipCommisions, '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="bc_seller_dashboard_summary_card_value">').concat(commissionFormated, '</div>\n                        </div>\n\n                    </div>\n\n                    <div class="bc_order_details_wrapper">\n                        <div class="bc_order_details_top">\n                            <div class="bc_order_details_title bc_text_uppercase">').concat(contactDetailsText, '</div>\n                \n                            <div class="bc_order_details_email">').concat(contact.email, '</div>\n                \n            \n                            <div class="bc_order_details_phone">').concat(contact.phone ? contact.phone : "", '</div>\n             \n                    </div>\n\n                    <div class="bc_addresses_wrapper">\n                        <div class="bc_shipping_address">\n                            <div class="bc_address_title bc_text_uppercase">').concat((contact === null || contact === void 0 ? void 0 : contact.billingAddress) ? billingAddressText : "", '</div>\n                            <div class="bc_text">').concat(((_a = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _a === void 0 ? void 0 : _a.firstName) ? contact.billingAddress.firstName : "", " ").concat(((_b = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _b === void 0 ? void 0 : _b.lastName) ? contact.billingAddress.lastName : "", '</div>\n                       \n                            <div class="bc_text">').concat(((_c = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _c === void 0 ? void 0 : _c.address1) ? contact.billingAddress.address1 : "", "</div>\n                       \n                            <div>").concat(((_d = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _d === void 0 ? void 0 : _d.city) ? contact.billingAddress.city : "", " ").concat(((_e = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _e === void 0 ? void 0 : _e.province) ? contact.billingAddress.province : "", " ").concat(((_f = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _f === void 0 ? void 0 : _f.zip) ? contact.billingAddress.zip : "", "</div>\n                            <div>").concat(((_g = contact === null || contact === void 0 ? void 0 : contact.billingAddress) === null || _g === void 0 ? void 0 : _g.country) ? contact.billingAddress.country : "", '</div>\n                            \n                        </div>\n\n                        <div class="bc_shipping_address">\n                            <div class="bc_address_title bc_text_uppercase">').concat((contact === null || contact === void 0 ? void 0 : contact.shippingAddress) ? shippingAddressText : "", '</div>\n                            <div class="bc_text">').concat(((_h = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _h === void 0 ? void 0 : _h.firstName) ? contact.shippingAddress.firstName : "", " ").concat(((_j = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _j === void 0 ? void 0 : _j.lastName) ? contact.shippingAddress.lastName : "", '</div>\n                       \n                            <div class="bc_text">').concat(((_k = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _k === void 0 ? void 0 : _k.address1) ? contact.shippingAddress.address1 : "", "</div>\n                       \n                            <div>").concat(((_l = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _l === void 0 ? void 0 : _l.city) ? contact.shippingAddress.city : "", " ").concat(((_m = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _m === void 0 ? void 0 : _m.province) ? contact.shippingAddress.province : "", " ").concat(((_o = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _o === void 0 ? void 0 : _o.zip) ? contact.shippingAddress.zip : "", "</div>\n                            <div>").concat(((_p = contact === null || contact === void 0 ? void 0 : contact.shippingAddress) === null || _p === void 0 ? void 0 : _p.country) ? contact.shippingAddress.country : "", '</div>\n                            \n                        </div>\n        \n                    </div>\n\n                    <div class="bc_contact_information_orders_table_wrapper bc_contact_information_orders_table_wrapper_JS">\n                        <div class="bc_title_wrapper">\n                            <span class="bc_text_uppercase">').concat(summaryLabel, '</span>\n                            <span class="bc_number_of_contact_orders_JS">(').concat(((_q = contact === null || contact === void 0 ? void 0 : contact.orders) === null || _q === void 0 ? void 0 : _q.length) ? contact.orders.length : 0, ')</span>\n                        </div>\n\n                        <div class="bc_contact_information_row bc_contact_information_table_header">\n                            <span>').concat(orderNumber, "</span>\n                            <span>").concat(orderDate, '</span>\n                            <span class="bc_last_column">').concat(orderValue, '</span>\n                        </div>\n\n\n                        <div class="bc_orders_table_rows_JS"></div>\n\n                    </div>\n\n                </div>\n\n            </div>\n        ');
                var ordersList = contact.orders ? contact.orders : [];
                _this.createOrdersTable(ordersList);
            };
            _this.setupDrawerNavigationHandlers = function() {
                var drawerWrapper = document.querySelector(".bc_seller_dashboard_cart_drawer_primary_wrapper_JS");
                if (!drawerWrapper) return;
                drawerWrapper.addEventListener("click", function(event) {
                    event.stopPropagation();
                    var target = event.target;
                    if (target.closest(".bc_prev_button_JS")) {
                        if (_this.currentModalIndex > 0) {
                            _this.currentModalIndex--;
                            _this.generateContactCartDrawer(_this.currentModalIndex);
                        } else {
                            console.warn("Already at first contact!");
                        }
                    }
                    if (target.closest(".bc_next_button_JS")) {
                        if (_this.currentModalIndex < _this.contactsArray.length - 1) {
                            _this.currentModalIndex++;
                            _this.generateContactCartDrawer(_this.currentModalIndex);
                        } else {
                            console.warn("Already at last contact!");
                        }
                    }
                    if (target.closest(".bc_close_button_JS")) {
                        _this.sharedComponents.closeCartDrawer();
                    }
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            _this.currency = currency;
            return _this;
        }
        StSellerDashboardContacts.prototype.handleLandingOnContactsPage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "contacts") {
                this.fetchContactsPageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("contacts");
            }
        };
        StSellerDashboardContacts.prototype.renderContacts = function(contactsApiArray) {
            var _this = this;
            var contactsBody = document.querySelector(".bc_seller_dashboard_contacts_body_JS");
            if (!contactsBody) return;
            var startIndex = (this.contactCurrentPage - 1) * this.contactPageSize;
            var endIndex = this.contactCurrentPage * this.contactPageSize;
            var pageData = contactsApiArray.slice(startIndex, endIndex);
            this.contactsArray = contactsApiArray;
            pageData.forEach(function(contact, index) {
                var dateFormated = "";
                if (contact.latestSale) {
                    dateFormated = _this.sharedComponents.returnOrderDate(contact.latestSale);
                }
                var totalSpentFormated = "";
                if (contact.totalSpent) {
                    totalSpentFormated = _this.currency.applyFormat(parseFloat(contact.totalSpent), currency_5.ECurrencyFormatType.withCurrency);
                }
                var row = document.createElement("button");
                row.setAttribute("type", "button");
                row.setAttribute("toggle-modal", "contact-information");
                row.classList.add("bc_seller_dashboard_table-row", "grid-4", "bc_contact_information_row_JS");
                row.innerHTML = "\n                <span>".concat(contact.firstName, " ").concat(contact.lastName, "</span>\n                <span>").concat(contact.email, "</span>\n                <span>").concat(dateFormated, "</span>\n                <span>").concat(totalSpentFormated, "</span>\n            ");
                row.addEventListener("click", function() {
                    _this.sharedComponents.openCartDrawer();
                    _this.currentModalIndex = index;
                    _this.generateContactCartDrawer(index);
                });
                contactsBody.appendChild(row);
            });
            var visibleTableRows = contactsBody.querySelectorAll(".bc_contact_information_row_JS");
            var loadMoreBtn = document.querySelector(".bc_load_more_contacts_JS");
            if (!loadMoreBtn) return;
            var originalItemsLength = this.contactsArray.length;
            if (originalItemsLength < this.contactPageSize || originalItemsLength === this.contactPageSize || originalItemsLength === visibleTableRows.length) {
                loadMoreBtn.classList.add("st_hidden");
            } else {
                loadMoreBtn.classList.remove("st_hidden");
                var remainingItems = originalItemsLength - visibleTableRows.length;
                if (remainingItems > this.contactPageSize) {
                    loadMoreBtn.innerHTML = "Load ".concat(this.contactPageSize.toString(), " More");
                } else {
                    loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                }
            }
        };
        StSellerDashboardContacts.prototype.bindLoadMoreForContacts = function() {
            var _this = this;
            var loadMoreBtn = document.querySelector(".bc_load_more_contacts_JS");
            if (!loadMoreBtn) return;
            loadMoreBtn.addEventListener("click", function() {
                _this.contactCurrentPage++;
                _this.renderContacts(_this.contactsArray);
            });
        };
        StSellerDashboardContacts.prototype.createOrdersTable = function(ordersList) {
            var _this = this;
            var orderTable = document.querySelector(".bc_orders_table_rows_JS");
            if (!orderTable) return;
            orderTable.innerHTML = "";
            ordersList.forEach(function(order) {
                var row = document.createElement("button");
                row.setAttribute("type", "button");
                row.setAttribute("toggle-modal", "contact-information");
                row.classList.add("bc_seller_dashboard_table-row", "grid-3", "bc_order_information_row_JS");
                var formattedDate = _this.sharedComponents.returnOrderDate(order.created);
                var formattedTotal = _this.currency.applyFormat(parseFloat(order.subtotal), currency_5.ECurrencyFormatType.withCurrency);
                row.innerHTML = "\n                <span>".concat(order.number, "</span>\n                <span>").concat(formattedDate, '</span>\n                <span style="text-align: end;">').concat(formattedTotal, "</span>\n            ");
                orderTable.appendChild(row);
            });
        };
        StSellerDashboardContacts.prototype.handleDownloadContactList = function() {
            var downloadBtn = document.querySelector(".bc_download_list_JS");
            if (!downloadBtn) return;
            var csvDownloadName = window.stTranslations.csvDownloadName;
            var csvDownloadEmail = window.stTranslations.csvDownloadEmail;
            var csvDownloadDate = window.stTranslations.csvDownloadDate;
            var csvDownloadSpend = window.stTranslations.csvDownloadSpend;
            downloadBtn.addEventListener("click", function() {
                var rows = document.querySelectorAll(".bc_contact_information_row_JS");
                if (!rows.length) return;
                var csvRows = [];
                csvRows.push("".concat(csvDownloadName, ",").concat(csvDownloadEmail, ",").concat(csvDownloadDate, ", ").concat(csvDownloadSpend));
                rows.forEach(function(row) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    var cells = row.querySelectorAll("span");
                    var name = ((_b = (_a = cells[0]) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || "";
                    var email = ((_d = (_c = cells[1]) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.trim()) || "";
                    var date = ((_f = (_e = cells[2]) === null || _e === void 0 ? void 0 : _e.textContent) === null || _f === void 0 ? void 0 : _f.trim()) || "";
                    var spend = ((_h = (_g = cells[2]) === null || _g === void 0 ? void 0 : _g.textContent) === null || _h === void 0 ? void 0 : _h.trim()) || "";
                    var csvLine = '"'.concat(name, '","').concat(email, '","').concat(date, '", "').concat(spend, '"');
                    csvRows.push(csvLine);
                });
                var csvContent = csvRows.join("\n");
                var blob = new Blob([ csvContent ], {
                    type: "text/csv;charset=utf-8;"
                });
                var url = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.href = url;
                a.download = "contacts-list.csv";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            });
        };
        StSellerDashboardContacts.prototype.bindSortDropdown = function() {
            var _this = this;
            var sortDropdown = document.getElementById("sortContactsSelect");
            if (!sortDropdown) return;
            sortDropdown.addEventListener("change", function() {
                var sortValue = sortDropdown.value;
                switch (sortValue) {
                  case "name_":
                    _this.contactsArray.sort(function(a, b) {
                        return a.firstName.localeCompare(b.firstName);
                    });
                    break;

                  case "email":
                    _this.contactsArray.sort(function(a, b) {
                        return a.email.localeCompare(b.email);
                    });
                    break;

                  case "sales":
                    _this.contactsArray.sort(function(a, b) {
                        return _this.parseDate(b.latestSale) - _this.parseDate(a.latestSale);
                    });
                    break;

                  case "spend":
                    _this.contactsArray.sort(function(a, b) {
                        return _this.parseSpend(b.totalSpent) - _this.parseSpend(a.totalSpent);
                    });
                    break;
                }
                _this.contactCurrentPage = 1;
                _this.renderSortedContacts();
            });
        };
        StSellerDashboardContacts.prototype.parseDate = function(dateStr) {
            var parsed = Date.parse(dateStr);
            return isNaN(parsed) ? 0 : parsed;
        };
        StSellerDashboardContacts.prototype.parseSpend = function(value) {
            if (value === null || value === undefined) return 0;
            if (typeof value === "number") return value;
            var cleaned = value.trim().replace(/[^\d.-]/g, "");
            return cleaned ? parseFloat(cleaned) : 0;
        };
        StSellerDashboardContacts.prototype.renderSortedContacts = function() {
            var orderTable = document.querySelector(".bc_list_of_contacts_wrapper_JS");
            if (!orderTable) return;
            orderTable.querySelectorAll(".bc_contact_information_row_JS").forEach(function(el) {
                return el.remove();
            });
            this.renderContacts(this.contactsArray);
        };
        return StSellerDashboardContacts;
    }(st_module_21.StModule);
    exports.StSellerDashboardContacts = StSellerDashboardContacts;
});

define("extension/shopify-app/st-modules/seller-dashboard/payouts/seller-dashboard-payouts-filters", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardPayoutsFilters = void 0;
    var StSellerDashboardPayoutsFilters = function(_super) {
        __extends(StSellerDashboardPayoutsFilters, _super);
        function StSellerDashboardPayoutsFilters(sharedComponents, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardPayoutsFilters";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleOpenFilterDrawer();
                    _this_1.handleCloseFilterDrawer();
                    _this_1.handleChooseDifferentFilter();
                    _this_1.handleApplyFilterClick();
                });
            };
            _this_1.handleOpenFilterDrawer = function() {
                var _this = _this_1;
                var thisMonth = window.stTranslations.thisMonth;
                var salesFilterButtons = document.querySelectorAll(".bc_payouts_filter_JS");
                if (salesFilterButtons && salesFilterButtons.length > 0) {
                    salesFilterButtons.forEach(function(button) {
                        _this_1.sharedComponents.setAppropriateFilterAttribute("last_30_days");
                        _this_1.sharedComponents.printChosenFilterText(thisMonth);
                        button.addEventListener("click", function() {
                            _this.openFilterDrawer();
                            _this.setActiveStateOnChosenFilter(this);
                            _this.sharedComponents.disableBodyScroll();
                        });
                    });
                }
            };
            _this_1.handleCloseFilterDrawer = function() {
                var _this = _this_1;
                var closeFilterButtons = document.querySelectorAll(".bc_payouts_close_filter_JS");
                if (closeFilterButtons && closeFilterButtons.length > 0) {
                    closeFilterButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeFilterDrawer();
                            _this.sharedComponents.enableBodyScroll();
                        });
                    });
                }
                var closeFilterOverlay = document.querySelector(".bc_payouts_filters_overlay_JS");
                if (closeFilterOverlay) {
                    closeFilterOverlay.addEventListener("click", function() {
                        _this.closeFilterDrawer();
                        _this.sharedComponents.enableBodyScroll();
                    });
                }
            };
            _this_1.openFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_payouts_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_payouts_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.add("active");
                    salesFilterDrawerWrapper.classList.add("active");
                }
            };
            _this_1.closeFilterDrawer = function() {
                var salesFilterOverlay = document.querySelector(".bc_payouts_filters_overlay_JS");
                var salesFilterDrawerWrapper = document.querySelector(".bc_payouts_filters_drawer_wrapper_JS");
                if (salesFilterOverlay && salesFilterDrawerWrapper) {
                    salesFilterOverlay.classList.remove("active");
                    salesFilterDrawerWrapper.classList.remove("active");
                }
            };
            _this_1.setActiveStateOnChosenFilter = function(button) {
                var chosenFilter = button.getAttribute("data-payouts-chosen-filter");
                var filterWrapper = document.querySelector(".bc_payouts_filter_wrapper_JS");
                if (filterWrapper) {
                    var filterOptions = filterWrapper.querySelectorAll(".bc_payouts_filter_button_JS");
                    if (filterOptions && filterOptions.length > 0) {
                        filterOptions.forEach(function(filter) {
                            var filterType = filter.getAttribute("data-payouts-date-filter");
                            chosenFilter === filterType ? filter.classList.add("active") : filter.classList.remove("active");
                        });
                    }
                }
            };
            _this_1.handleChooseDifferentFilter = function() {
                var _this = _this_1;
                var salesFilterWrapper = document.querySelector(".bc_payouts_filter_wrapper_JS");
                if (salesFilterWrapper) {
                    var filterButtons = salesFilterWrapper.querySelectorAll(".bc_payouts_filter_button_JS");
                    if (filterButtons && filterButtons.length > 0) {
                        filterButtons.forEach(function(button) {
                            button.addEventListener("click", function() {
                                _this.setActiveFilter(salesFilterWrapper, this);
                                if (this.getAttribute("data-payouts-date-filter") === "custom") {
                                    _this.showCustomFilterRange();
                                } else {
                                    _this.hideCustomFilterRange();
                                }
                            });
                        });
                    }
                }
            };
            _this_1.setActiveFilter = function(filterWrapper, button) {
                if (button.classList.contains("active")) {
                    return;
                }
                _this_1.removeCustomRangeErrorMessage();
                var previousActiveFilter = filterWrapper.querySelector(".active");
                previousActiveFilter === null || previousActiveFilter === void 0 ? void 0 : previousActiveFilter.classList.remove("active");
                button.classList.add("active");
            };
            _this_1.removeCustomRangeErrorMessage = function() {
                var errorMessage = document.querySelector(".bc_payouts_custom_range_error_message_JS");
                if (errorMessage) {
                    errorMessage.remove();
                }
            };
            _this_1.showCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_payouts_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.add("active");
                }
            };
            _this_1.hideCustomFilterRange = function() {
                var customFilterRange = document.querySelector(".bc_payouts_filter_custom_range_wrapper_JS");
                if (customFilterRange) {
                    customFilterRange.classList.remove("active");
                }
            };
            _this_1.handleApplyFilterClick = function() {
                var _this = _this_1;
                var applyButton = document.querySelector(".bc_apply_payouts_filters_JS");
                if (applyButton) {
                    applyButton.addEventListener("click", function() {
                        _this.applyChosenFilter();
                    });
                }
            };
            _this_1.applyChosenFilter = function() {
                var today = window.stTranslations.today;
                var last_7_days = window.stTranslations.last_7_days;
                var last_30_days = window.stTranslations.last_30_days;
                var this_month = window.stTranslations.thisMonth;
                var last_month = window.stTranslations.last_month;
                var last_90_days = window.stTranslations.last_90_days;
                var last_12_months = window.stTranslations.last_12_months;
                var filtersWrapper = document.querySelector(".bc_payouts_filter_wrapper_JS");
                if (filtersWrapper) {
                    var filter = filtersWrapper.querySelector(".active");
                    if (!filter) {
                        return;
                    }
                    if (filter) {
                        var filterType = filter.getAttribute("data-payouts-date-filter");
                        var todayDate = _this_1.sharedComponents.getStartOfDay();
                        switch (filterType) {
                          case "today":
                            var endOfDay = _this_1.sharedComponents.getEndOfDay();
                            _this_1.applyFilterAndRenderResults(todayDate, endOfDay, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(today);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("today");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_7_days":
                            var sevenDaysAgo = new Date(todayDate);
                            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
                            _this_1.applyFilterAndRenderResults(sevenDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(last_7_days);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("last_7_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_30_days":
                            var thirtyDaysAgo = new Date(todayDate);
                            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                            _this_1.applyFilterAndRenderResults(thirtyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(last_30_days);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("last_30_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "this_month":
                            var startThisMonth = _this_1.sharedComponents.getStartOfThisMonth();
                            var endThismonth = _this_1.sharedComponents.getEndOfThisMonth();
                            _this_1.applyFilterAndRenderResults(startThisMonth, endThismonth, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(this_month);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("this_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_month":
                            var firstDayLastMonth = _this_1.sharedComponents.getStartOfLastMonth();
                            var lastDayLastMonth = _this_1.sharedComponents.getEndOfLastMonth();
                            _this_1.applyFilterAndRenderResults(firstDayLastMonth, lastDayLastMonth, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(last_month);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("last_month");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_90_days":
                            var ninetyDaysAgo = new Date(todayDate);
                            ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
                            _this_1.applyFilterAndRenderResults(ninetyDaysAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(last_90_days);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("last_90_days");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "last_12_months":
                            var twelveMonthsAgo = new Date(todayDate);
                            twelveMonthsAgo.setFullYear(twelveMonthsAgo.getFullYear() - 1);
                            _this_1.applyFilterAndRenderResults(twelveMonthsAgo, todayDate, filterType);
                            _this_1.closeFilterDrawer();
                            _this_1.sharedComponents.printPayoutsChosenFilterText(last_12_months);
                            _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("last_12_months");
                            _this_1.sharedComponents.enableBodyScroll();
                            break;

                          case "custom":
                            var customRangeFilterWrapper = document.querySelector(".bc_payouts_filter_custom_range_wrapper_JS");
                            if (customRangeFilterWrapper) {
                                var startDateEl = customRangeFilterWrapper.querySelector(".bc_payouts_range_input_start_date_JS");
                                var endDateEl = customRangeFilterWrapper.querySelector(".bc_payouts_range_input_end_date_JS");
                                if (startDateEl && endDateEl) {
                                    if (startDateEl.value !== "" && endDateEl.value !== "") {
                                        var startDay = _this_1.sharedComponents.getStartOfSelectedDay(startDateEl.value);
                                        var endDay = _this_1.sharedComponents.getEndOfSelectedDay(endDateEl.value);
                                        _this_1.applyFilterAndRenderResults(startDay, endDay, _this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                    } else {
                                        _this_1.removeCustomRangeErrorMessage();
                                        customRangeFilterWrapper.appendChild(_this_1.printCustomRangeErrorMessage());
                                        return;
                                    }
                                }
                                _this_1.closeFilterDrawer();
                                if (startDateEl && endDateEl) {
                                    _this_1.sharedComponents.printPayoutsChosenFilterText(_this_1.formatDateRange(startDateEl.value, endDateEl.value));
                                }
                                _this_1.sharedComponents.setPayoutsAppropriateFilterAttribute("custom");
                                _this_1.sharedComponents.enableBodyScroll();
                            }
                            break;

                          default:
                            console.log("No filter provided.");
                        }
                    }
                }
            };
            _this_1.formatDateRange = function(startDate, endDate) {
                var fromDate = new Date(startDate);
                var toDate = new Date(endDate);
                var dayFrom = fromDate.getDate();
                var dayTo = toDate.getDate();
                var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
                var monthFrom = monthNames[fromDate.getMonth()];
                var monthTo = monthNames[toDate.getMonth()];
                var yearFrom = fromDate.getFullYear();
                var yearTo = toDate.getFullYear();
                if (yearFrom === yearTo && fromDate.getMonth() === toDate.getMonth()) {
                    return "".concat(dayFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else if (yearFrom === yearTo) {
                    return "".concat(dayFrom, " ").concat(monthFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                } else {
                    return "".concat(dayFrom, " ").concat(monthFrom, ", ").concat(yearFrom, " - ").concat(dayTo, " ").concat(monthTo, ", ").concat(yearTo);
                }
            };
            _this_1.printCustomRangeErrorMessage = function() {
                var errorText = window.stTranslations.customRangeFilterErrorMessage;
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("bc_custom_range_error_message", "bc_payouts_custom_range_error_message_JS");
                errorMessage.innerHTML = errorText ? errorText : "Test Message";
                return errorMessage;
            };
            _this_1.applyFilterAndRenderResults = function(startDate, endDate, filterType) {
                var _a;
                var payload = {
                    affiliateId: window.customerAffiliateId,
                    dateStart: startDate.toISOString(),
                    dateEnd: endDate.toISOString()
                };
                if (filterType === "this_month") {
                    payload = {
                        affiliateId: window.customerAffiliateId
                    };
                }
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getDashboardPayouts"],
                        method: "POST",
                        contentType: "json",
                        data: payload,
                        callback: function(res) {
                            try {
                                var referalData = JSON.parse(res.response);
                                if (referalData.status === 200) {
                                    var payoutsSum = _this_1.payoutsModule.getTotalPayouts(referalData.data.payments);
                                    _this_1.sharedComponents.updateEarningsByClass(payoutsSum.totalAmount, _this_1.payoutsModule.tabMonth);
                                    _this_1.sharedComponents.updateTooltipTextAndTitle(_this_1.payoutsModule.tabMonth, payoutsSum.totalAmount, days_30, filterType);
                                    _this_1.sharedComponents.updateEarningsByClass(referalData.data.paidAmount, _this_1.payoutsModule.tabAllTime);
                                    _this_1.sharedComponents.updateOrderNumberByClass(referalData.data.count, _this_1.payoutsModule.payoutsNumber);
                                    _this_1.payoutsModule.renderOrders(referalData.data.payments);
                                    _this_1.sharedComponents.showDashboardAsideContent();
                                    _this_1.sharedComponents.showAppropriatePage("payouts");
                                } else if (referalData.status === 400) {
                                    _this_1.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error("Response error ------\x3e", error);
                                _this_1.sharedComponents.hideLoader();
                            }
                        }
                    });
                } catch (err) {
                    console.log("StSellerDashboardPayouts---\x3e Error: fetch payouts API", err);
                }
            };
            _this_1.sharedComponents = sharedComponents;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StSellerDashboardPayoutsFilters.prototype.setPayoutsModule = function(module) {
            this.payoutsModule = module;
        };
        return StSellerDashboardPayoutsFilters;
    }(st_module_22.StModule);
    exports.StSellerDashboardPayoutsFilters = StSellerDashboardPayoutsFilters;
});

define("extension/shopify-app/st-modules/seller-dashboard/payouts/seller-dashboard-payouts", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_23, currency_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardPayouts = void 0;
    var StSellerDashboardPayouts = function(_super) {
        __extends(StSellerDashboardPayouts, _super);
        function StSellerDashboardPayouts(objectFormatting, sharedComponents, currency, payoutsFilters) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerDashboardPayouts";
            _this.payoutsArray = [];
            _this.currentPage = 1;
            _this.pageSize = 10;
            _this.tabMonth = "bc_earnings_payouts_tab_month";
            _this.tabAllTime = "bc_earnings_payouts_tab_all_time";
            _this.payoutsNumber = "bc_seller_dashboard_payouts_numbers_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.bindLoadMore();
                    _this.handleLandingOnPayoutsPage();
                });
            };
            _this.fetchPayoutsPageContent = function(activePage) {
                var _a;
                _this.sharedComponents.showLoader();
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                var days_30 = (_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a.days_30;
                var startThisMonth = _this.sharedComponents.getStartOfThisMonth();
                var endThismonth = _this.sharedComponents.getEndOfThisMonth();
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["getDashboardPayouts"],
                        method: "post",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId,
                            dateStart: startThisMonth,
                            dateEnd: endThismonth
                        },
                        callback: function(res) {
                            try {
                                var referalData = JSON.parse(res.response);
                                if (referalData.status === 200) {
                                    _this.sharedComponents.hideLoader();
                                    _this.sharedComponents.showDashboardAsideContent();
                                    _this.sharedComponents.showAppropriatePage(activePage);
                                    var payoutsSum = _this.getTotalPayouts(referalData.data.payments);
                                    _this.sharedComponents.updateEarningsByClass(payoutsSum.totalAmount, _this.tabMonth);
                                    _this.sharedComponents.updateTooltipTextAndTitle(_this.tabMonth, payoutsSum.totalAmount, days_30, "this_month");
                                    _this.sharedComponents.updateEarningsByClass(referalData.data.paidAmount, _this.tabAllTime);
                                    _this.sharedComponents.updateOrderNumberByClass(referalData.data.count, _this.payoutsNumber);
                                    _this.renderOrders(referalData.data.payments);
                                } else if (referalData.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this.bindLoadMore = function() {
                var loadMoreBtn = document.querySelector(".bc_seller_dashboard_payouts_load_more_JS");
                if (!loadMoreBtn) return;
                loadMoreBtn.addEventListener("click", function() {
                    _this.currentPage++;
                    _this.renderOrders(_this.payoutsArray);
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            _this.currency = currency;
            _this.payoutsFilters = payoutsFilters;
            _this.payoutsFilters.setPayoutsModule(_this);
            return _this;
        }
        StSellerDashboardPayouts.prototype.handleLandingOnPayoutsPage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "payouts") {
                this.fetchPayoutsPageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("payouts");
            }
        };
        StSellerDashboardPayouts.prototype.renderOrders = function(payoutsApiArray) {
            var _this = this;
            var ordersBody = document.getElementById("payoutBody_JS");
            if (!ordersBody) return;
            var startIndex = (this.currentPage - 1) * this.pageSize;
            var endIndex = this.currentPage * this.pageSize;
            var pageData = payoutsApiArray.slice(startIndex, endIndex);
            this.payoutsArray = payoutsApiArray;
            var arrowDownSvg = '<svg class="bc_arrow_icon" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <path d="M1 0.5L6 5.5L11 0.5" stroke="#010001" stroke-linecap="round" stroke-linejoin="round"/>\n                            </svg>';
            var arrowUpSvg = '<svg class="bc_arrow_icon" width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <path d="M11 5.5L6 0.5L1 5.5" stroke="#010001" stroke-linecap="round" stroke-linejoin="round"/>\n                            </svg>';
            pageData.forEach(function(order) {
                var dateFormated = _this.sharedComponents.returnOrderDate(order.created_at);
                var amountFormated = _this.currency.applyFormat(parseFloat(order.amount), currency_6.ECurrencyFormatType.withCurrency);
                var row = document.createElement("div");
                row.classList.add("bc_seller_dashboard_payout_table-row");
                row.innerHTML = '\n                <div class="bc_table_cell">'.concat(dateFormated, '</div>\n                    <div class="bc_table_cell">').concat(order.details.title, '</div>\n                    <div class="bc_table_cell">\n                        <div class="bc_amount_cell">\n                        ').concat(amountFormated, '\n                        <span class="bc_order_toggle-details_JS" data-id="').concat(order.id, '">\n                        ').concat(arrowDownSvg, "\n                        </span>\n                    </div>\n                </div>\n                ");
                ordersBody.appendChild(row);
            });
            var newCustomerEarningsText = window.stTranslations.newCustomerEarningsText;
            var repeatCustomerEarningsText = window.stTranslations.repeatCustomerEarningsText;
            var referalEarningsText = window.stTranslations.referalEarningsText;
            var otherEarningsText = window.stTranslations.otherEarningsText;
            document.querySelectorAll(".bc_order_toggle-details_JS").forEach(function(el) {
                el.addEventListener("click", function(event) {
                    var _a, _b, _c, _d;
                    var target = event.currentTarget;
                    var orderId = target.getAttribute("data-id");
                    var arrowWrapper = target;
                    var existingDetails = (_b = (_a = target.closest(".bc_table_cell")) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.nextElementSibling;
                    if (existingDetails && existingDetails.classList.contains("bc_order-details-row")) {
                        existingDetails.remove();
                        arrowWrapper.innerHTML = arrowDownSvg;
                        return;
                    }
                    document.querySelectorAll(".bc_order-details-row").forEach(function(el) {
                        return el.remove();
                    });
                    document.querySelectorAll(".bc_order_toggle-details_JS").forEach(function(el) {
                        el.innerHTML = arrowDownSvg;
                    });
                    var payout = _this.payoutsArray.find(function(p) {
                        return p.id === Number(orderId);
                    });
                    if (!payout || !payout.details) return;
                    var details = payout.details;
                    var detailsRow = document.createElement("div");
                    detailsRow.className = "bc_order-details-row";
                    detailsRow.innerHTML = '\n                    <div class="bc_order-details-wrapper">\n                        <div class="bc_order-details-line"><span>'.concat(newCustomerEarningsText, "</span><span>").concat(_this.currency.applyFormat(Number(details.new_customer_earnings), currency_6.ECurrencyFormatType.withCurrency), '</span></div>\n                        <div class="bc_order-details-line"><span>').concat(repeatCustomerEarningsText, "</span><span>").concat(_this.currency.applyFormat(Number(details.old_customer_earnings), currency_6.ECurrencyFormatType.withCurrency), '</span></div>\n                        <div class="bc_order-details-line"><span>').concat(referalEarningsText, "</span><span>").concat(_this.currency.applyFormat(Number(details.other_earnings), currency_6.ECurrencyFormatType.withCurrency), '</span></div>\n                        <div class="bc_order-details-line"><span>').concat(otherEarningsText, "</span><span>").concat(_this.currency.applyFormat(Number(details.referral_earnings), currency_6.ECurrencyFormatType.withCurrency), "</span></div>\n                    </div>\n                ");
                    (_d = (_c = target.closest(".bc_table_cell")) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.after(detailsRow);
                    arrowWrapper.innerHTML = arrowUpSvg;
                });
            });
            var visibleTableRows = ordersBody.querySelectorAll(".bc_seller_dashboard_payout_table-row");
            var loadMoreBtn = document.querySelector(".bc_seller_dashboard_payouts_load_more_JS");
            if (!loadMoreBtn) return;
            var originalItemsLength = this.payoutsArray.length;
            if (originalItemsLength < this.pageSize || originalItemsLength === this.pageSize || originalItemsLength === visibleTableRows.length) {
                loadMoreBtn.classList.add("st_hidden");
            } else {
                loadMoreBtn.classList.remove("st_hidden");
                var remainingItems = originalItemsLength - visibleTableRows.length;
                if (remainingItems > this.pageSize) {
                    loadMoreBtn.innerHTML = "Load ".concat(this.pageSize.toString(), " More");
                } else {
                    loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                }
            }
        };
        StSellerDashboardPayouts.prototype.getPayoutsForCurrentMonth = function(payouts) {
            var now = new Date();
            var currentMonth = now.getMonth();
            var currentYear = now.getFullYear();
            var currentMonthPayouts = payouts.filter(function(payout) {
                var payoutDate = new Date(payout.created_at);
                return payoutDate.getMonth() === currentMonth && payoutDate.getFullYear() === currentYear;
            });
            var totalAmount = currentMonthPayouts.reduce(function(sum, payout) {
                return sum + parseFloat(payout.amount || "0");
            }, 0);
            return {
                payouts: currentMonthPayouts,
                totalAmount: totalAmount
            };
        };
        StSellerDashboardPayouts.prototype.getTotalPayouts = function(payouts) {
            var totalAmount = payouts.reduce(function(sum, payout) {
                return sum + parseFloat(payout.amount || "0");
            }, 0);
            return {
                payouts: payouts,
                totalAmount: totalAmount
            };
        };
        return StSellerDashboardPayouts;
    }(st_module_23.StModule);
    exports.StSellerDashboardPayouts = StSellerDashboardPayouts;
});

define("extension/shopify-app/st-modules/seller-dashboard/profile/seller-dashboard-profile", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardProfile = void 0;
    var StSellerDashboardProfile = function(_super) {
        __extends(StSellerDashboardProfile, _super);
        function StSellerDashboardProfile(sellerEnrollmentApprovedContent, objectFormatting, sharedComponents, buttonActions, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardProfile";
            _this_1.customerFirstName = "bc_seller_enrollment_profile_first_name_JS";
            _this_1.customerLastName = "bc_seller_enrollment_profile_last_name_JS";
            _this_1.customerEmail = "bc_seller_enrollment_profile_email_JS";
            _this_1.customerPhone = "bc_seller_enrollment_profile_phone_JS";
            _this_1.customerInstagram = "bc_seller_enrollment_profile_instagram_JS";
            _this_1.customerYoutube = "bc_seller_enrollment_profile_youtube_JS";
            _this_1.customerTikTok = "bc_seller_enrollment_profile_tikTok_JS";
            _this_1.customerX = "bc_seller_enrollment_profile_twitter_JS";
            _this_1.customerUpdateButton = ".bc_seller_dashboard_button_update_customer_JS";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleChangePaymentDetailsClick();
                    _this_1.handleLandingOnProfilePage();
                    _this_1.handleUpdateCustomerClick();
                });
            };
            _this_1.handleChangePaymentDetailsClick = function() {
                var _this = _this_1;
                var changePaymentDetails = document.querySelector(".bc_seller_dashboard_change_payment_details_JS");
                if (changePaymentDetails) {
                    changePaymentDetails.addEventListener("click", function() {
                        _this.sellerEnrollmentApprovedContent.openPaymentInfoPopup();
                        _this.sellerEnrollmentApprovedContent.resetPaymentInfoFields();
                        document.body.style.overflow = "hidden";
                    });
                }
            };
            _this_1.fetchProfilePageContent = function(activePage) {
                _this_1.sharedComponents.showLoader();
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getAffiliateInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId
                        },
                        callback: function(res) {
                            try {
                                var profileData = JSON.parse(res.response);
                                if (profileData.status === 200) {
                                    _this_1.sharedComponents.hideLoader();
                                    _this_1.sharedComponents.showDashboardAsideContent();
                                    _this_1.sharedComponents.showAppropriatePage(activePage);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.firstName, _this_1.customerFirstName);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.lastName, _this_1.customerLastName);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.email, _this_1.customerEmail);
                                    if (profileData.data.phone === null || !profileData.data.phone) {
                                        var phoneInput = document.querySelector("." + _this_1.customerPhone);
                                        if (phoneInput) {
                                            phoneInput.readOnly = false;
                                            phoneInput.removeAttribute("disabled");
                                        }
                                    } else {
                                        _this_1.sharedComponents.updateInputByClass(profileData.data.phone, _this_1.customerPhone);
                                    }
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.instagram, _this_1.customerInstagram);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.youtube, _this_1.customerYoutube);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.tiktok, _this_1.customerTikTok);
                                    _this_1.sharedComponents.updateInputByClass(profileData.data.x, _this_1.customerX);
                                } else if (profileData.status === 400) {
                                    _this_1.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this_1.handleUpdateCustomerClick = function() {
                var updateBtn = document.querySelector(_this_1.customerUpdateButton);
                if (updateBtn) {
                    updateBtn.addEventListener("click", function() {
                        var _a;
                        var email = ((_a = document.querySelector(".".concat(_this_1.customerEmail))) === null || _a === void 0 ? void 0 : _a.value) || "";
                        var instagram = document.querySelector(".".concat(_this_1.customerInstagram)) || "";
                        var youtube = document.querySelector(".".concat(_this_1.customerYoutube)) || "";
                        var tiktok = document.querySelector(".".concat(_this_1.customerTikTok)) || "";
                        var twitter = document.querySelector(".".concat(_this_1.customerX)) || "";
                        var phone = document.querySelector(".".concat(_this_1.customerPhone)) || "";
                        var payload = {
                            email: email,
                            instagram: instagram ? instagram.value : "",
                            youtube: youtube ? youtube.value : "",
                            tiktok: tiktok ? tiktok.value : "",
                            twitter: twitter ? twitter.value : "",
                            phone: phone ? phone.value : ""
                        };
                        if (instagram) instagram.setAttribute("disabled", "disabled");
                        if (youtube) youtube.setAttribute("disabled", "disabled");
                        if (tiktok) tiktok.setAttribute("disabled", "disabled");
                        if (twitter) twitter.setAttribute("disabled", "disabled");
                        if (phone) phone.setAttribute("disabled", "disabled");
                        _this_1.buttonActions.prevent(updateBtn);
                        var txt = updateBtn.querySelector("span");
                        txt === null || txt === void 0 ? void 0 : txt.classList.add("st_hidden");
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["updateAffiliate"],
                            method: "post",
                            contentType: "json",
                            data: payload,
                            callback: function(res) {
                                try {
                                    var response = JSON.parse(res.response);
                                    if (response.status === 200) {
                                        if (instagram) instagram.removeAttribute("disabled");
                                        if (youtube) youtube.removeAttribute("disabled");
                                        if (tiktok) tiktok.removeAttribute("disabled");
                                        if (twitter) twitter.removeAttribute("disabled");
                                        if (phone) phone.removeAttribute("disabled");
                                        _this_1.buttonActions.allow(updateBtn);
                                        txt === null || txt === void 0 ? void 0 : txt.classList.remove("st_hidden");
                                        _this_1.sharedComponents.showNotification("Your profile has been updated.");
                                    } else {
                                        _this_1.sharedComponents.showNotification("Failed to update profile.");
                                    }
                                } catch (err) {
                                    console.error("Response parsing error", err);
                                    _this_1.sharedComponents.showNotification("Unexpected error occurred.");
                                }
                            }
                        });
                    });
                }
            };
            _this_1.sellerEnrollmentApprovedContent = sellerEnrollmentApprovedContent;
            _this_1.objectFormatting = objectFormatting;
            _this_1.sharedComponents = sharedComponents;
            _this_1.buttonActions = buttonActions;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StSellerDashboardProfile.prototype.handleLandingOnProfilePage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "profile") {
                this.fetchProfilePageContent(urlParams.activeTab);
                this.sharedComponents.setActivePage("profile");
            }
        };
        return StSellerDashboardProfile;
    }(st_module_24.StModule);
    exports.StSellerDashboardProfile = StSellerDashboardProfile;
});

define("extension/shopify-app/st-modules/seller-dashboard/share-cart/seller-dashboard-share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_25) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardShareCart = void 0;
    var StSellerDashboardShareCart = function(_super) {
        __extends(StSellerDashboardShareCart, _super);
        function StSellerDashboardShareCart(generalMethods, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardShareCart";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.fetchDashboardSharedCartData();
                    _this_1.copyToClipboard();
                    _this_1.setWalletDownloadLink();
                });
            };
            _this_1.fetchDashboardSharedCartData = function() {
                var affiliateId = window === null || window === void 0 ? void 0 : window.customerAffiliateId;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getSellerLinksCode"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            affiliateId: affiliateId
                        },
                        callback: function(res) {
                            try {
                                var resp = JSON.parse(res.response);
                                if (resp.status === 200) {
                                    var refCode = resp.data;
                                    var shopInput = document.querySelector("#shopUrl");
                                    var sellerInput = document.querySelector("#sellerURL");
                                    var currentDomain = window.location.hostname;
                                    var shopLink = "https://".concat(currentDomain, "/?aff=").concat(refCode);
                                    var sellerLink = "https://".concat(currentDomain, "/pages/become-a-brand-partner?aff=").concat(refCode);
                                    if (shopInput) {
                                        shopInput.value = shopLink;
                                    }
                                    if (sellerInput) {
                                        sellerInput.value = sellerLink;
                                    }
                                    _this_1.sharedComponents.showDashboardAsideContent();
                                } else if (resp.status === 400) {} else {
                                    console.error(resp.message);
                                }
                            } catch (error) {
                                console.error("Response error ------\x3e", error);
                                _this_1.sharedComponents.hideLoader();
                            }
                        }
                    });
                } catch (err) {
                    console.log("StSellerDashboardSummary---\x3e Error: fetch summary API", err);
                }
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyButtons = document.querySelectorAll(".bc_seller_dashboard_copy_button_JS");
                if (copyButtons && copyButtons.length > 0) {
                    copyButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            return __awaiter(this, void 0, void 0, function() {
                                var closestWrapper, inputEl, buttonText, error_1;
                                var _this_1 = this;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        this.setAttribute("disabled", "disabled");
                                        closestWrapper = _this.generalMethods.getClosestByClass(this, "bc_share_cart_copy_button_wrapper_JS");
                                        inputEl = closestWrapper.querySelector(".bc_share_cart_copy_input_JS");
                                        buttonText = button.querySelector("span");
                                        _a.label = 1;

                                      case 1:
                                        _a.trys.push([ 1, 3, , 4 ]);
                                        return [ 4, navigator.clipboard.writeText(inputEl.value) ];

                                      case 2:
                                        _a.sent();
                                        buttonText.innerHTML = "COPIED";
                                        setTimeout(function() {
                                            buttonText.innerHTML = "COPY";
                                            _this_1.removeAttribute("disabled");
                                        }, 1e3);
                                        return [ 3, 4 ];

                                      case 3:
                                        error_1 = _a.sent();
                                        buttonText.innerHTML = "UNABLE TO COPY";
                                        setTimeout(function() {
                                            buttonText.innerHTML = "COPY";
                                            _this_1.removeAttribute("disabled");
                                        }, 1e3);
                                        console.error("Failed to copy:", error_1);
                                        return [ 3, 4 ];

                                      case 4:
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                    });
                }
            };
            _this_1.setWalletDownloadLink = function() {
                var walletUrl = window === null || window === void 0 ? void 0 : window.walletDownloadUrl;
                if (!walletUrl || walletUrl === "") {
                    var walletWrapper = document.querySelector(".bc_seller_dashboard_wallet_wrapper");
                    walletWrapper.classList.add("st_hidden");
                }
                var appleWalletBtn = document.querySelector(".bc_wallet_button_apple_JS");
                var googleWalletBtn = document.querySelector(".bc_wallet_button_google_JS");
                if (walletUrl && appleWalletBtn) {
                    appleWalletBtn.setAttribute("href", walletUrl);
                } else {
                    console.warn("Wallet download URL or Apple Wallet button not found.");
                }
                if (walletUrl && googleWalletBtn) {
                    googleWalletBtn.setAttribute("href", walletUrl);
                } else {
                    console.warn("Wallet download URL or Google Wallet button not found.");
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        return StSellerDashboardShareCart;
    }(st_module_25.StModule);
    exports.StSellerDashboardShareCart = StSellerDashboardShareCart;
});

define("extension/shopify-app/st-modules/seller-dashboard/shared-cart-page/shared-cart-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSharedCartPage = void 0;
    var StSharedCartPage = function(_super) {
        __extends(StSharedCartPage, _super);
        function StSharedCartPage(objectFormatting, sharedComponents) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSharedCartPage";
            _this.contactOrderData = [ {
                cart_name: "#CTRO182hd90172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO1829gdf0172",
                date_created: "12 Feb 2025",
                number_of_products: 20,
                number_of_orders: 10,
                order_value: "$120.00"
            }, {
                cart_name: "#CTRO182hddhdf90172",
                date_created: "12 Feb 2025",
                number_of_products: 1230,
                number_of_orders: 2,
                order_value: "$105340.00"
            }, {
                cart_name: "#CTRO18294234230172",
                date_created: "12 Feb 2025",
                number_of_products: 443,
                number_of_orders: 1,
                order_value: "$1040.00"
            }, {
                cart_name: "#CTRO18290he172",
                date_created: "43 Dec 2025",
                number_of_products: 4,
                number_of_orders: 88,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO18290teer172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$10f0.00"
            }, {
                cart_name: "#CTRO1829r0172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 99,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO1829dhf0172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO18290172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 53,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO182hd90172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO18290172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO1829hdf0172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 10,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO18hd290172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO1829hhdfddh0172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 5,
                order_value: "$100.00"
            }, {
                cart_name: "#CTRO18290172",
                date_created: "12 Feb 2025",
                number_of_products: 4,
                number_of_orders: 23,
                order_value: "$100.00"
            } ];
            _this.currentPage = 1;
            _this.pageSize = 10;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.handleLandingOnContactsPage();
                });
            };
            _this.generateSharedCarts = function() {
                var orderTable = document.querySelector(".bc_seller_dashboard_shared_cart_list_JS");
                if (orderTable) {
                    var startIndex = (_this.currentPage - 1) * _this.pageSize;
                    var endIndex = _this.currentPage * _this.pageSize;
                    var pageData = _this.contactOrderData.slice(startIndex, endIndex);
                    pageData.forEach(function(order) {
                        var row = document.createElement("button");
                        row.setAttribute("type", "button");
                        row.setAttribute("toggle-modal", "shared-cart-information");
                        row.classList.add("bc_seller_dashboard_table-row", "bc_uneven-table-row", "grid-5", "bc_shared_cart_information_row_JS");
                        row.innerHTML = "\n                <span>".concat(order.cart_name, '</span>\n                <span class="bc_mobile_order">').concat(order.date_created, "</span>\n                <span>").concat(order.number_of_products, ' items</span>\n                <span class="bc_mobile_order bc_shared_cart_mobile_placeholder st_hidden">Cart</span>\n                <span class="bc_table_flex_row">\n                    <span>').concat(order.number_of_orders, '</span>\n                    <span>orders</span>\n                </span>\n                <span class="bc_mobile_order bc_align_end">').concat(order.order_value, "</span>\n            ");
                        orderTable.appendChild(row);
                    });
                    var visibleTableRows = orderTable.querySelectorAll(".bc_shared_cart_information_row_JS");
                    var originalItemsLength = _this.contactOrderData.length;
                    var loadMoreBtn = document.querySelector(".bc_seller_dashboard_shared_carts_JS");
                    if (originalItemsLength < _this.pageSize || originalItemsLength === _this.pageSize || originalItemsLength === visibleTableRows.length) {
                        loadMoreBtn.classList.add("st_hidden");
                    } else {
                        loadMoreBtn.classList.remove("st_hidden");
                        var remainingItems = originalItemsLength - visibleTableRows.length;
                        if (remainingItems > _this.pageSize) {
                            loadMoreBtn.innerHTML = "Load ".concat(_this.pageSize.toString(), " More");
                        } else {
                            loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                        }
                    }
                }
            };
            _this.bindLoadMore = function() {
                var loadMoreBtn = document.querySelector(".bc_seller_dashboard_shared_carts_JS");
                if (!loadMoreBtn) return;
                loadMoreBtn.addEventListener("click", function() {
                    _this.currentPage++;
                    _this.generateSharedCarts();
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            return _this;
        }
        StSharedCartPage.prototype.handleLandingOnContactsPage = function() {
            var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            if (urlParams.activeTab && urlParams.activeTab === "shared_carts") {
                this.sharedComponents.setActivePage("shared_carts");
                this.sharedComponents.showAppropriatePage("shared_carts");
            }
        };
        return StSharedCartPage;
    }(st_module_26.StModule);
    exports.StSharedCartPage = StSharedCartPage;
});

define("extension/shopify-app/st-modules/seller-dashboard/navigation/seller-dashboard-primary-navigation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboardPrimaryNavigation = void 0;
    var StSellerDashboardPrimaryNavigation = function(_super) {
        __extends(StSellerDashboardPrimaryNavigation, _super);
        function StSellerDashboardPrimaryNavigation(classConfig, generalMethods, objectFormatting, summaryPage, salesPage, assetsPage, sharedComponents, referalsPage, contactPage, payoutsPage, profilePage, sharedCartPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StSellerDashboardPrimaryNavigation";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleNavigationButtonClick();
                    _this_1.showAppropriateNavigation();
                    _this_1.handleAnchorLinksClick();
                    _this_1.sharedComponents.closeCartDrawerHandle();
                });
            };
            _this_1.handleAnchorLinksClick = function() {
                var _this = _this_1;
                var anchorButtons = document.querySelectorAll(".bc_seller_dashboard_anchor_links_JS");
                if (anchorButtons && anchorButtons.length > 0) {
                    anchorButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.sharedComponents.setActiveTab(undefined, this);
                            _this.setActiveTabContent(undefined, undefined, this);
                            _this.sharedComponents.setQueryParams(this.getAttribute("data-navigation-tab"));
                            var mediaQuery = window.matchMedia("(max-width: 1023px)");
                            if (mediaQuery.matches) {
                                _this.closeNavigationDropdown(undefined, this);
                            }
                        });
                    });
                }
            };
            _this_1.handleNavigationButtonClick = function() {
                var _this = _this_1;
                var navigationButtons = document.querySelectorAll(_this_1.classConfig.selectorPrimaryNavigationButton);
                if (navigationButtons && navigationButtons.length > 0) {
                    navigationButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            if (this.classList.contains("active")) {
                                return;
                            }
                            _this.sharedComponents.setActiveTab(this);
                            _this.setActiveTabContent(this);
                            _this.sharedComponents.setQueryParams(this.getAttribute("data-navigation-tab"));
                            var mediaQuery = window.matchMedia("(max-width: 1023px)");
                            if (mediaQuery.matches) {
                                _this.closeNavigationDropdown(this);
                            }
                            var referralLinks = document.querySelector(".bc_seller_dashboard_referral_links_JS");
                            if (referralLinks) {
                                if (this.getAttribute("data-navigation-tab") === "assets") {
                                    referralLinks.classList.add("st_hidden");
                                    _this.showChosenImageOnAssetsPage();
                                } else {
                                    referralLinks.classList.remove("st_hidden");
                                    _this.hideChosenImageOnAssetsPage();
                                }
                            }
                        });
                    });
                }
            };
            _this_1.closeNavigationDropdown = function(button, anchorLinks) {
                var dropdownWrapper = document.querySelector(".bc_seller_dashboard_dropdown_navigation_content_JS");
                dropdownWrapper === null || dropdownWrapper === void 0 ? void 0 : dropdownWrapper.classList.remove("open");
                var chosenTabButton = document.querySelector(".bc_seller_dashboard_chosen_button_JS");
                chosenTabButton === null || chosenTabButton === void 0 ? void 0 : chosenTabButton.classList.remove("open");
                var text = chosenTabButton === null || chosenTabButton === void 0 ? void 0 : chosenTabButton.querySelector(".bc_chosen_button_text_JS");
                text.innerHTML = button ? button.innerHTML : anchorLinks.getAttribute("data-navigation-tab").toUpperCase();
                if (anchorLinks) {
                    _this_1.setActiveToMobileNavigation(anchorLinks);
                }
            };
            _this_1.setActiveToMobileNavigation = function(anchorLinks) {
                var mobileNavigationWrapper = document.querySelector(".bc_seller_dashboard_dropdown_navigation_mobile_JS");
                if (mobileNavigationWrapper) {
                    var listOfTabs = mobileNavigationWrapper.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                    if (listOfTabs && listOfTabs.length > 0) {
                        listOfTabs.forEach(function(el) {
                            el.classList.remove("active");
                            if (el.getAttribute("data-navigation-tab") === anchorLinks.getAttribute("data-navigation-tab")) {
                                el.classList.add("active");
                            }
                        });
                    }
                }
            };
            _this_1.setActiveTabContent = function(button, previousActiveTab, anchorLink) {
                var primaryWrapper = document.querySelector(_this_1.classConfig.selectorSellerDashboardPrimaryWrapper);
                if (primaryWrapper) {
                    if (anchorLink) {
                        var activeTab = anchorLink.getAttribute("data-navigation-tab");
                        _this_1.activeTabContent(primaryWrapper, activeTab);
                        _this_1.generalMethods.scrollTo(primaryWrapper, 500);
                    } else {
                        var activeTab = button ? button.getAttribute("data-navigation-tab") : previousActiveTab;
                        _this_1.activeTabContent(primaryWrapper, activeTab);
                    }
                }
            };
            _this_1.activeTabContent = function(primaryWrapper, activeTab) {
                var contentWrappers = primaryWrapper.querySelectorAll(_this_1.classConfig.selectorSellerDashboardContentWrapper);
                contentWrappers.forEach(function(wrapper) {
                    var activeContent = wrapper.getAttribute("data-tab-content");
                    if (activeTab === activeContent) {
                        switch (activeTab) {
                          case "summary":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("summary");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.summaryPage.fetchSummaryPageContent("summary");
                            }
                            break;

                          case "sales":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("sales");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.salesPage.fetchSalesPageContent("sales");
                            }
                            break;

                          case "assets":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("assets");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.assetsPage.fetchAssetsPageContent("assets");
                            }
                            break;

                          case "referrals":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("referrals");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.referalsPage.fetchReferalPageContent("referrals");
                            }
                            break;

                          case "contacts":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("contacts");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.contactPage.fetchContactsPageContent("contacts");
                            }
                            break;

                          case "payouts":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("payouts");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.payoutsPage.fetchPayoutsPageContent("payouts");
                            }
                            break;

                          case "profile":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("profile");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                _this_1.profilePage.fetchProfilePageContent("profile");
                            }
                            break;

                          case "shared_carts":
                            if (wrapper.classList.contains("bc_fetched_data")) {
                                _this_1.sharedComponents.showAppropriatePage("shared_carts");
                            } else {
                                wrapper.classList.add("bc_fetched_data");
                                wrapper.classList.remove("st_hidden");
                            }
                            break;

                          default:
                            console.log("Active tab is not provided.");
                        }
                    } else {
                        wrapper.classList.add("st_hidden");
                    }
                });
            };
            _this_1.showAppropriateNavigation = function() {
                var mediaQuery = window.matchMedia("(max-width: 1023px)");
                _this_1.showNavigation(mediaQuery);
                mediaQuery.addEventListener("change", _this_1.showNavigation);
            };
            _this_1.showNavigation = function(event) {
                var chosenNavigationButton = document.querySelector(".bc_chosen_button_text_JS");
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var desktopNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_desktop_JS");
                var mobileNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_mobile_JS");
                if (event.matches) {
                    if (queryParams.activeTab) {
                        chosenNavigationButton.innerHTML = queryParams.activeTab;
                        var listOfButtons = mobileNavigation.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                        listOfButtons.forEach(function(button) {
                            if (button.getAttribute("data-navigation-tab") === queryParams.activeTab) {
                                button.classList.add("active");
                            }
                        });
                    } else {
                        _this_1.setActiveTabOnFirstLandOnPage(desktopNavigation, chosenNavigationButton, mobileNavigation);
                    }
                    _this_1.showMobileNavigation();
                    _this_1.hideDesktopNavigation();
                } else {
                    _this_1.showDesktopNavigation();
                    _this_1.hideMobileNavigation();
                    var navigationButtonList_1 = desktopNavigation === null || desktopNavigation === void 0 ? void 0 : desktopNavigation.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                    if (navigationButtonList_1 && navigationButtonList_1.length > 0) {
                        navigationButtonList_1.forEach(function(button) {
                            var tabEl = button.getAttribute("data-navigation-tab");
                            if (queryParams.activeTab && queryParams.activeTab === tabEl) {
                                button.classList.add("active");
                                return;
                            }
                            if (!queryParams.activeTab) {
                                navigationButtonList_1[0].classList.add("active");
                                chosenNavigationButton.innerHTML = navigationButtonList_1[0].getAttribute("data-navigation-tab");
                                var listOfButtons = mobileNavigation === null || mobileNavigation === void 0 ? void 0 : mobileNavigation.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                                listOfButtons[0].classList.add("active");
                            }
                        });
                    }
                }
            };
            _this_1.setActiveTabOnFirstLandOnPage = function(desktopNavigation, chosenNavigationButton, mobileNavigation) {
                var navigationButtonList = desktopNavigation === null || desktopNavigation === void 0 ? void 0 : desktopNavigation.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                if (navigationButtonList && navigationButtonList.length > 0) {
                    chosenNavigationButton.innerHTML = navigationButtonList[0].getAttribute("data-navigation-tab");
                    var listOfButtons = mobileNavigation.querySelectorAll(".bc_seller_dashboard_navigation--button_JS");
                    listOfButtons[0].classList.add("active");
                }
            };
            _this_1.hideChosenImageOnAssetsPage = function() {
                var chosenImageSection = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                chosenImageSection === null || chosenImageSection === void 0 ? void 0 : chosenImageSection.classList.add("st_hidden");
            };
            _this_1.showChosenImageOnAssetsPage = function() {
                var chosenImageSection = document.querySelector(".bc_seller_dashboard_chosen_image_wrapper_JS");
                chosenImageSection === null || chosenImageSection === void 0 ? void 0 : chosenImageSection.classList.remove("st_hidden");
            };
            _this_1.showMobileNavigation = function() {
                var mobileNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_mobile_JS");
                mobileNavigation === null || mobileNavigation === void 0 ? void 0 : mobileNavigation.classList.remove("st_hidden");
            };
            _this_1.hideMobileNavigation = function() {
                var mobileNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_mobile_JS");
                mobileNavigation === null || mobileNavigation === void 0 ? void 0 : mobileNavigation.classList.add("st_hidden");
            };
            _this_1.showDesktopNavigation = function() {
                var desktopNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_desktop_JS");
                desktopNavigation === null || desktopNavigation === void 0 ? void 0 : desktopNavigation.classList.remove("st_hidden");
            };
            _this_1.hideDesktopNavigation = function() {
                var desktopNavigation = document.querySelector(".bc_seller_dashboard_dropdown_navigation_desktop_JS");
                desktopNavigation === null || desktopNavigation === void 0 ? void 0 : desktopNavigation.classList.add("st_hidden");
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.summaryPage = summaryPage;
            _this_1.salesPage = salesPage;
            _this_1.assetsPage = assetsPage;
            _this_1.sharedComponents = sharedComponents;
            _this_1.referalsPage = referalsPage;
            _this_1.contactPage = contactPage;
            _this_1.payoutsPage = payoutsPage;
            _this_1.profilePage = profilePage;
            _this_1.sharedCartPage = sharedCartPage;
            return _this_1;
        }
        return StSellerDashboardPrimaryNavigation;
    }(st_module_27.StModule);
    exports.StSellerDashboardPrimaryNavigation = StSellerDashboardPrimaryNavigation;
});

define("extension/shopify-app/st-modules/seller-dashboard/seller-dashboard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSellerDashboard = void 0;
    var StSellerDashboard = function(_super) {
        __extends(StSellerDashboard, _super);
        function StSellerDashboard(navigation, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSellerDashboard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.mediaChangeShareCartHandle();
                    _this.shareCartDropdownHandle();
                    _this.handleNavigationDropdownClick();
                });
            };
            _this.handleNavigationDropdownClick = function() {
                var navigationButton = document.querySelector(".bc_seller_dashboard_chosen_button_JS");
                if (navigationButton) {
                    navigationButton.addEventListener("click", function() {
                        this.classList.contains("open") ? this.classList.remove("open") : this.classList.add("open");
                        var dropdownContent = document.querySelector(".bc_seller_dashboard_dropdown_navigation_content_JS");
                        dropdownContent.classList.contains("open") ? dropdownContent.classList.remove("open") : dropdownContent.classList.add("open");
                    });
                }
            };
            _this.shareCartDropdownHandle = function() {
                var shareCartDropDownButton = document.querySelector(".bc_seller_dashboard_share_cart_dropdown_button_JS");
                if (shareCartDropDownButton) {
                    shareCartDropDownButton.addEventListener("click", function() {
                        var mediaQuery = window.matchMedia("(max-width: 1023px)");
                        if (mediaQuery.matches) {
                            this.classList.contains("active") ? this.classList.remove("active") : this.classList.add("active");
                            var shareCartDropdownContent = document.querySelector(".bc_seller_dashboard_share_cart_content_JS");
                            if (shareCartDropdownContent) {
                                shareCartDropdownContent.classList.contains("active") ? shareCartDropdownContent.classList.remove("active") : shareCartDropdownContent.classList.add("active");
                            }
                        }
                    });
                }
            };
            _this.mediaChangeShareCartHandle = function() {
                var mediaQuery = window.matchMedia("(max-width: 1023px)");
                _this.shareCartChange(mediaQuery);
                mediaQuery.addEventListener("change", _this.shareCartChange);
            };
            _this.shareCartChange = function(event) {
                if (event.matches) {
                    _this.showMobileTitle();
                    _this.hideDesktopTitle();
                } else {
                    _this.hideMobileTitle();
                    _this.showDesktopTitle();
                }
            };
            _this.showDesktopTitle = function() {
                var desktopTitle = document.querySelector(".bc_seller_dashboard_desktop_dropdown_title_JS");
                desktopTitle === null || desktopTitle === void 0 ? void 0 : desktopTitle.classList.remove("st_hidden");
            };
            _this.hideDesktopTitle = function() {
                var desktopTitle = document.querySelector(".bc_seller_dashboard_desktop_dropdown_title_JS");
                desktopTitle === null || desktopTitle === void 0 ? void 0 : desktopTitle.classList.add("st_hidden");
            };
            _this.showMobileTitle = function() {
                var mobileTitle = document.querySelector(".bc_seller_dashboard_share_cart_dropdown_button");
                mobileTitle === null || mobileTitle === void 0 ? void 0 : mobileTitle.classList.remove("st_hidden");
            };
            _this.hideMobileTitle = function() {
                var mobileTitle = document.querySelector(".bc_seller_dashboard_share_cart_dropdown_button");
                mobileTitle === null || mobileTitle === void 0 ? void 0 : mobileTitle.classList.add("st_hidden");
            };
            _this.navigation = navigation;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StSellerDashboard;
    }(st_module_28.StModule);
    exports.StSellerDashboard = StSellerDashboard;
});

define("extension/shopify-app/st-modules/main/main", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StMain = void 0;
    var StMain = function(_super) {
        __extends(StMain, _super);
        function StMain() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.call(this, args) || this;
            _this.className = "StMain";
            _this.init = function() {
                _this.subscribeDOMLoaded(_this.handleDOMLoaded);
            };
            _this.handleDOMLoaded = function() {
                _this.exposeGetEnrollmentFormResponseToWindow();
                _this.hideDashboardLinkIfNoBpCompletedTag();
            };
            _this.updateRefCodeMetafield = function() {
                var refFromCookie = _this.getCookie("ref");
                var refFromWindow = window.customerRefCode;
                var email = window.customerEmail;
                var refFromURL = new URLSearchParams(window.location.search).get("aff");
                var refCodeToSubmit = refFromURL || refFromCookie;
                var shouldSubmitToBackend = !!email && (refFromURL !== null || refFromWindow !== refFromCookie);
                if (!refCodeToSubmit) {
                    console.warn("No ref code found in URL or cookie, aborting.");
                    return;
                }
                if (shouldSubmitToBackend) {
                    console.info("Submitting refCode to backend:", refCodeToSubmit);
                    _this.ajax.send({
                        endpoint: _this.endpoint.customer.updateCustomerRefCode,
                        method: "post",
                        contentType: "json",
                        data: {
                            email: email,
                            refCode: refCodeToSubmit
                        },
                        callback: _this.handleAjaxResponse(refCodeToSubmit)
                    });
                }
                _this.updateCartAttributeRefCode(refCodeToSubmit);
            };
            _this.handleAjaxResponse = function(refCode) {
                return function(res) {
                    try {
                        var result = JSON.parse(res.response);
                        if (result.status === 200) {
                            console.info(result.message);
                            window.customerRefCode = refCode;
                        } else {
                            console.error(result.message);
                        }
                    } catch (error) {
                        console.error("Failed to parse response:", error);
                    }
                };
            };
            _this.updateCartAttributeRefCode = function(refCode) {
                fetch("/cart.js").then(function(res) {
                    return res.ok ? res.json() : Promise.reject("Failed to load cart");
                }).then(function(cart) {
                    var existingAttributes = cart.attributes || {};
                    var currentRef = existingAttributes === null || existingAttributes === void 0 ? void 0 : existingAttributes.currentRefCode;
                    if (currentRef === refCode) {
                        console.info('Cart attribute "ref" already set, skipping update.');
                        return;
                    }
                    console.info('Updating cart attribute "ref" to:', refCode);
                    var updatedAttributes = __assign(__assign({}, existingAttributes), {
                        currentRefCode: refCode
                    });
                    return fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            attributes: updatedAttributes
                        })
                    });
                }).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.ok) {
                        console.info('Cart attribute "ref" updated successfully.');
                    }
                }).catch(function(err) {
                    console.error('Error updating cart attribute "ref":', err);
                });
            };
            _this.getCookie = function(name) {
                var _a, _b;
                return (_b = (_a = document.cookie.split("; ").map(function(cookie) {
                    return cookie.split("=");
                }).find(function(_a) {
                    var key = _a[0];
                    return key === name;
                })) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null;
            };
            _this.hideDashboardLinkIfNoBpCompletedTag = function() {
                var tags = window.customerTags || [];
                var hasBpCompleted = tags.includes("bp_completed");
                if (!hasBpCompleted) {
                    var dashboardLink = document.querySelector('a[href="/pages/account-seller-dashboard"]');
                    if (dashboardLink) {
                        var navItem = dashboardLink.closest("li");
                        if (navItem) {
                            navItem.classList.add("hide-nav-item");
                        }
                    }
                } else {
                    var dashboardLink = document.querySelector('a[href="/pages/account-seller-enrollment"]');
                    if (dashboardLink) {
                        var navItem = dashboardLink.closest("li");
                        if (navItem) {
                            navItem.classList.add("hide-nav-item");
                        }
                    }
                }
            };
            return _this;
        }
        StMain.prototype.exposeGetEnrollmentFormResponseToWindow = function() {
            window.getEnrollmentFormResponse = this.endpoint.enrollment.getFormResponse;
        };
        return StMain;
    }(st_module_29.StModule);
    exports.StMain = StMain;
});

define("extension/shopify-app/st-modules/connected-sellers/connected-sellers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StConnectedSellers = void 0;
    var StConnectedSellers = function(_super) {
        __extends(StConnectedSellers, _super);
        function StConnectedSellers(sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StConnectedSellers";
            _this_1.sellersArray = [];
            _this_1.currentPage = 1;
            _this_1.pageSize = 10;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.bindLoadMore();
                    _this_1.fetchConnectedSellerPageContent();
                });
            };
            _this_1.fetchConnectedSellerPageContent = function() {
                var _this = _this_1;
                _this_1.sharedComponents.showLoader();
                var email = window.customerEmail;
                var l = [ {
                    firstName: "Milan",
                    lastName: "Stankovic",
                    email: "milan.stankovic@codemancy.tech",
                    ref_code: "MILANSTANKOVIC",
                    optIn: false
                }, {
                    firstName: "Marko",
                    lastName: "Spasic",
                    email: "marko.spasic@codemancy.tech",
                    ref_code: "MARKOSPASIC",
                    optIn: false
                }, {
                    firstName: "Max",
                    lastName: "Sta",
                    email: "sta@codemancy.tech",
                    ref_code: "MILANSTANKOVIC",
                    optIn: true
                }, {
                    firstName: "Ma",
                    lastName: "S",
                    email: "s@codemancy.tech",
                    ref_code: "MARKOSPASIC",
                    optIn: false
                }, {
                    firstName: "Yul",
                    lastName: "Yil",
                    email: "yil@codemancy.tech",
                    ref_code: "MILANSTANKOVIC",
                    optIn: true
                }, {
                    firstName: "M",
                    lastName: "cs",
                    email: "cs@codemancy.tech",
                    ref_code: "MARKOSPASIC",
                    optIn: true
                }, {
                    firstName: "Max",
                    lastName: "Sta",
                    email: "sta@codemancy.tech",
                    ref_code: "MILANSTANKOVIC",
                    optIn: true
                }, {
                    firstName: "Ma",
                    lastName: "S",
                    email: "s@codemancy.tech",
                    ref_code: "MARKOSPASIC",
                    optIn: false
                }, {
                    firstName: "Liam",
                    lastName: "Turner",
                    email: "liam.turner@example.com",
                    ref_code: "LIAMT",
                    optIn: false
                }, {
                    firstName: "Sophia",
                    lastName: "Martinez",
                    email: "sophia.martinez@example.com",
                    ref_code: "SOPHIAM",
                    optIn: false
                }, {
                    firstName: "Noah",
                    lastName: "West",
                    email: "noah.west@example.com",
                    ref_code: "LIAMT",
                    optIn: true
                }, {
                    firstName: "Olivia",
                    lastName: "Gray",
                    email: "olivia.gray@example.com",
                    ref_code: "SOPHIAM",
                    optIn: false
                }, {
                    firstName: "Ethan",
                    lastName: "Wright",
                    email: "ethan.wright@example.com",
                    ref_code: "LIAMT",
                    optIn: true
                }, {
                    firstName: "Isabella",
                    lastName: "Foster",
                    email: "isabella.foster@example.com",
                    ref_code: "SOPHIAM",
                    optIn: true
                }, {
                    firstName: "Lucas",
                    lastName: "Grant",
                    email: "lucas.grant@example.com",
                    ref_code: "LIAMT",
                    optIn: true
                }, {
                    firstName: "Mia",
                    lastName: "Stone",
                    email: "mia.stone@example.com",
                    ref_code: "SOPHIAM",
                    optIn: false
                } ];
                var payload = {
                    email: email
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["getConnectedSellers"],
                        method: "post",
                        contentType: "json",
                        data: payload,
                        callback: function(response) {
                            try {
                                var connectedSellerDataResponse = JSON.parse(response.response);
                                if (connectedSellerDataResponse.status === 200) {
                                    _this.sharedComponents.hideLoader();
                                    _this.renderSellers(connectedSellerDataResponse.data);
                                } else if (connectedSellerDataResponse.status === 400) {
                                    _this.sharedComponents.hideLoader();
                                } else {}
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                }
            };
            _this_1.bindLoadMore = function() {
                var loadMoreBtn = document.querySelector(".bc_connected_sellers_load_more_JS");
                if (!loadMoreBtn) return;
                loadMoreBtn.addEventListener("click", function() {
                    _this_1.currentPage++;
                    _this_1.renderSellers(_this_1.sellersArray);
                });
            };
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        StConnectedSellers.prototype.renderSellers = function(sellersApiArray) {
            var sellersBody = document.querySelector(".bc_connected_sellers_table_wrapper_body_JS");
            if (!sellersBody) return;
            var startIndex = (this.currentPage - 1) * this.pageSize;
            var endIndex = this.currentPage * this.pageSize;
            var pageData = sellersApiArray.slice(startIndex, endIndex);
            this.sellersArray = sellersApiArray;
            var shopAgainText = window.stTranslations.shopAgainText;
            var optInText = window.stTranslations.optInText;
            var optOutText = window.stTranslations.optOutText;
            var currentDomain = window.location.hostname;
            pageData.forEach(function(seller) {
                var row = document.createElement("div");
                row.classList.add("bc_table_row", "bc_connected_sellers_table_row");
                var shopLink = "https://".concat(currentDomain, "/?aff=").concat(seller.ref_code);
                row.innerHTML = '\n            <span class="bc_span_2">'.concat(seller.firstName, " ").concat(seller.lastName, '</span>\n            <span class="bc_span_2">').concat(seller.email, '</span>\n            <a class="bc_table_button bc_connected_seller_table_link" href="').concat(shopLink, '">').concat(shopAgainText, '</a>\n            <button \n                class="bc_table_button bc_connected_seller_table_button" \n                type="button"\n                data-name="').concat(seller.firstName, '"\n                data-ref="').concat(seller.ref_code, '"\n                data-optin="').concat(seller.optIn, '" \n            >\n                <span>').concat(seller.optIn === false ? optInText : optOutText, "</span>\n            </button>\n            ");
                sellersBody.append(row);
            });
            this.attachOptOutListeners();
            var removeAllText = window.stTranslations.removeAllText;
            var existingRemoveAll = document.querySelector(".bc_connected_sellers_remove_all_row");
            if (existingRemoveAll) {
                existingRemoveAll.remove();
            }
            var removeAllRow = document.createElement("div");
            removeAllRow.classList.add("bc_table_row", "bc_connected_sellers_remove_all_row");
            removeAllRow.innerHTML = '\n            <span class="bc_span_2"></span>\n            <span class="bc_span_2"></span>\n            <span></span>\n            <button class="bc_table_button bc_connected_seller_table_button bc_connected_sellers_remove_all_button_JS" type="button">\n                '.concat(removeAllText, "\n            </button>\n        ");
            sellersBody.append(removeAllRow);
            this.attachRemoveAllListener();
            var visibleTableRows = sellersBody.querySelectorAll(".bc_connected_sellers_table_row");
            var loadMoreBtn = document.querySelector(".bc_connected_sellers_load_more_JS");
            if (!loadMoreBtn) return;
            var originalItemsLength = this.sellersArray.length;
            if (originalItemsLength < this.pageSize || originalItemsLength === this.pageSize || originalItemsLength === visibleTableRows.length) {
                loadMoreBtn.classList.add("st_hidden");
            } else {
                loadMoreBtn.classList.remove("st_hidden");
                var remainingItems = originalItemsLength - visibleTableRows.length;
                if (remainingItems > this.pageSize) {
                    loadMoreBtn.innerHTML = "Load ".concat(this.pageSize.toString(), " More");
                } else {
                    loadMoreBtn.innerHTML = "Load ".concat(remainingItems.toString(), " More");
                }
            }
        };
        StConnectedSellers.prototype.attachOptOutListeners = function() {
            var _this_1 = this;
            var modal = document.querySelector(".bc_connected_sellers_modal_JS");
            var modalName = modal.querySelector(".bc_modal_seller_name_JS");
            var backdrop = modal.querySelector(".bc_connected_sellers_modal_backdrop_JS");
            var cancelBtn = modal.querySelector(".bc_modal_cancel_JS");
            var confirmBtn = modal.querySelector(".bc_modal_confirm_JS");
            var optOutButtons = document.querySelectorAll(".bc_connected_seller_table_button");
            optOutButtons.forEach(function(btn) {
                btn.addEventListener("click", function() {
                    var button = btn;
                    var name = button.dataset.name || "SELLER";
                    var refCode = button.dataset.ref || "";
                    var optIn = button.dataset.optin === "true";
                    if (!optIn) {
                        _this_1.callOptApi(refCode, true, button);
                        return;
                    }
                    modalName.textContent = name.toUpperCase();
                    modal.classList.remove("st_hidden");
                    confirmBtn === null || confirmBtn === void 0 ? void 0 : confirmBtn.replaceWith(confirmBtn.cloneNode(true));
                    var newConfirmBtn = document.querySelector(".bc_modal_confirm_JS");
                    newConfirmBtn === null || newConfirmBtn === void 0 ? void 0 : newConfirmBtn.addEventListener("click", function() {
                        modal.classList.add("st_hidden");
                        _this_1.callOptApi(refCode, false, button);
                    });
                });
            });
            backdrop === null || backdrop === void 0 ? void 0 : backdrop.addEventListener("click", function() {
                modal.classList.add("st_hidden");
            });
            cancelBtn === null || cancelBtn === void 0 ? void 0 : cancelBtn.addEventListener("click", function() {
                modal.classList.add("st_hidden");
            });
        };
        StConnectedSellers.prototype.callOptApi = function(refCode, isOptOut, buttonEl) {
            this.disableAllOptButtons(true);
            var email = window.customerEmail;
            var originalHTML = buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.innerHTML;
            if (buttonEl) {
                buttonEl.innerHTML = '<span class="bc_update_opt_status_loader"></span>';
                buttonEl.setAttribute("disabled", "true");
            }
            var payload = {
                email: email,
                referralAffiliateAlias: refCode,
                optedIn: isOptOut
            };
            try {
                this.ajax.send({
                    endpoint: this.endpoint["customer"]["updateOptInStatus"],
                    method: "post",
                    contentType: "json",
                    data: payload,
                    callback: function(response) {
                        try {
                            var upateOptInDataResponse = JSON.parse(response.response);
                            if (upateOptInDataResponse.status === 200) {
                                location.reload();
                            } else if (upateOptInDataResponse.status === 400) {
                                console.error("API error", upateOptInDataResponse);
                                if (buttonEl && originalHTML) {
                                    buttonEl.innerHTML = originalHTML;
                                    buttonEl.removeAttribute("disabled");
                                }
                            } else {
                                if (buttonEl && originalHTML) {
                                    buttonEl.innerHTML = originalHTML;
                                    buttonEl.removeAttribute("disabled");
                                }
                                this.disableAllOptButtons(false);
                            }
                        } catch (error) {
                            console.error(error);
                            if (buttonEl && originalHTML) {
                                buttonEl.innerHTML = originalHTML;
                                buttonEl.removeAttribute("disabled");
                            }
                            this.disableAllOptButtons(false);
                        }
                    }
                });
            } catch (error) {
                console.error("Request error -----\x3e", error);
            }
        };
        StConnectedSellers.prototype.attachRemoveAllListener = function() {
            var _this_1 = this;
            var removeAllBtn = document.querySelector(".bc_connected_sellers_remove_all_button_JS");
            if (!removeAllBtn) return;
            removeAllBtn.addEventListener("click", function() {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var buttons, _i, _a, btn, button, optIn, refCode, originalHTML, restoreHTML;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            buttons = document.querySelectorAll(".bc_connected_seller_table_button");
                            this.disableAllOptButtons(true);
                            _i = 0, _a = Array.from(buttons);
                            _b.label = 1;

                          case 1:
                            if (!(_i < _a.length)) return [ 3, 4 ];
                            btn = _a[_i];
                            button = btn;
                            optIn = button.dataset.optin === "true";
                            refCode = button.dataset.ref || "";
                            if (!(optIn && refCode)) return [ 3, 3 ];
                            originalHTML = button.innerHTML;
                            button.innerHTML = '<span class="bc_update_opt_status_loader"></span>';
                            button.setAttribute("data-original-html", originalHTML);
                            return [ 4, this.callOptApiPromise(refCode, false, button) ];

                          case 2:
                            _b.sent();
                            restoreHTML = button.getAttribute("data-original-html");
                            if (restoreHTML) {
                                button.innerHTML = restoreHTML;
                                button.removeAttribute("data-original-html");
                            }
                            _b.label = 3;

                          case 3:
                            _i++;
                            return [ 3, 1 ];

                          case 4:
                            location.reload();
                            return [ 2 ];
                        }
                    });
                });
            });
        };
        StConnectedSellers.prototype.callOptApiPromise = function(refCode, isOptOut, buttonEl) {
            var _this_1 = this;
            return new Promise(function(resolve) {
                var email = window.customerEmail;
                var payload = {
                    email: email,
                    referralAffiliateAlias: refCode,
                    optedIn: isOptOut
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["updateOptInStatus"],
                        method: "post",
                        contentType: "json",
                        data: payload,
                        callback: function(response) {
                            try {
                                var parsed = JSON.parse(response.response);
                                console.log("Ref ".concat(refCode, " opt updated:"), parsed.status);
                            } catch (e) {
                                console.error(e);
                            }
                            resolve();
                        }
                    });
                } catch (error) {
                    console.error("Request error -----\x3e", error);
                    resolve();
                }
            });
        };
        StConnectedSellers.prototype.disableAllOptButtons = function(disabled) {
            var allButtons = document.querySelectorAll(".bc_connected_seller_table_button");
            allButtons.forEach(function(btn) {
                btn.disabled = disabled;
            });
        };
        return StConnectedSellers;
    }(st_module_30.StModule);
    exports.StConnectedSellers = StConnectedSellers;
});

define("extension/shopify-app/st-modules/seller-enrollment/search-dropdown", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchDropdown = void 0;
    var StSearchDropdown = function(_super) {
        __extends(StSearchDropdown, _super);
        function StSearchDropdown(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSearchDropdown";
            _this.bankList = [];
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.loadBankList();
                    _this.handleFormSubmitValidation();
                });
            };
            _this.formatBankLabel = function(bank) {
                return "".concat(bank.name, " [").concat(bank.number, "]");
            };
            _this.loadBankList = function() {
                fetch("https://app.goaffpro.com/ca-financial-institutions.json").then(function(res) {
                    return res.json();
                }).then(function(data) {
                    _this.bankList = Array.isArray(data) ? data.map(function(item) {
                        return {
                            name: item.name || "",
                            number: item.number || ""
                        };
                    }) : [];
                    _this.setupDropdownLogic();
                }).catch(function(err) {
                    console.error("Failed to load bank list:", err);
                    _this.setupDropdownLogic();
                });
            };
            _this.setupDropdownLogic = function() {
                var displayField = document.querySelector(".st_bank_display_field_JS");
                var selectedText = document.querySelector(".st_bank_selected_text_JS");
                var hiddenInput = document.querySelector(".st_bank_hidden_input_JS");
                var dropdown = document.querySelector(".st_bank_dropdown_content_JS");
                var searchInput = document.querySelector(".st_bank_search_input_JS");
                var optionsList = document.querySelector(".st_bank_options_list_JS");
                var noResultsBox = document.querySelector(".st_bank_no_results_JS");
                var arrowIcon = document.querySelector(".st_bank_arrow_JS");
                var clearSelectionIcon = document.querySelector(".st_bank_clear_selected_icon_JS");
                if (!displayField || !selectedText || !hiddenInput || !dropdown || !searchInput || !optionsList || !noResultsBox || !clearSelectionIcon) return;
                _this.handleDropdownToggle(displayField, dropdown, searchInput, arrowIcon);
                _this.renderOptions(_this.bankList, optionsList, noResultsBox, selectedText, hiddenInput, dropdown, arrowIcon, clearSelectionIcon);
                _this.handleSearchInput(searchInput, optionsList, noResultsBox, selectedText, hiddenInput, dropdown, arrowIcon, clearSelectionIcon);
                _this.handleClearSelection(clearSelectionIcon, selectedText, hiddenInput);
                _this.handleClickOutside(dropdown, arrowIcon);
                _this.showClearIconIfValueExists(hiddenInput, clearSelectionIcon);
            };
            _this.handleDropdownToggle = function(displayField, dropdown, searchInput, arrowIcon) {
                displayField.addEventListener("click", function() {
                    var isNowHidden = dropdown.classList.toggle("st_hidden");
                    searchInput.focus();
                    arrowIcon === null || arrowIcon === void 0 ? void 0 : arrowIcon.classList.toggle("st_arrow_rotated", !isNowHidden);
                });
            };
            _this.handleSearchInput = function(searchInput, optionsList, noResultsBox, selectedText, hiddenInput, dropdown, arrowIcon, clearSelectionIcon) {
                searchInput.addEventListener("input", function(e) {
                    clearTimeout(_this.requestTimeout);
                    var value = e.target.value.trim().toLowerCase();
                    _this.requestTimeout = setTimeout(function() {
                        var filtered = _this.bankList.filter(function(bank) {
                            var byName = bank.name.toLowerCase().includes(value);
                            var byNumber = bank.number.toLowerCase().includes(value);
                            return byName || byNumber;
                        });
                        _this.renderOptions(filtered, optionsList, noResultsBox, selectedText, hiddenInput, dropdown, arrowIcon, clearSelectionIcon);
                    }, 250);
                });
            };
            _this.handleClearSelection = function(clearSelectionIcon, selectedText, hiddenInput) {
                clearSelectionIcon.addEventListener("click", function() {
                    selectedText.textContent = "Select a bank";
                    hiddenInput.value = "";
                    clearSelectionIcon.classList.add("st_hidden");
                });
            };
            _this.handleClickOutside = function(dropdown, arrowIcon) {
                document.addEventListener("click", function(e) {
                    var wrapper = document.querySelector(".st_bank_dropdown_wrapper_JS");
                    if (!(wrapper === null || wrapper === void 0 ? void 0 : wrapper.contains(e.target))) {
                        dropdown.classList.add("st_hidden");
                        arrowIcon === null || arrowIcon === void 0 ? void 0 : arrowIcon.classList.remove("st_arrow_rotated");
                    }
                });
            };
            _this.showClearIconIfValueExists = function(hiddenInput, clearSelectionIcon) {
                if (hiddenInput.value) {
                    clearSelectionIcon.classList.remove("st_hidden");
                }
            };
            _this.renderOptions = function(banks, container, noResultsBox, selectedText, hiddenInput, dropdown, arrowIcon, clearSelectionIcon) {
                container.innerHTML = "";
                noResultsBox.classList.toggle("st_hidden", banks.length > 0);
                banks.forEach(function(bank) {
                    var label = _this.formatBankLabel(bank);
                    var option = document.createElement("div");
                    option.className = "st_bank_option st_bank_option_JS";
                    option.setAttribute("data-value", bank.number);
                    option.setAttribute("data-text", label);
                    option.textContent = label;
                    option.addEventListener("click", function() {
                        selectedText.textContent = label;
                        hiddenInput.value = bank.number;
                        dropdown.classList.add("st_hidden");
                        arrowIcon === null || arrowIcon === void 0 ? void 0 : arrowIcon.classList.remove("st_arrow_rotated");
                        clearSelectionIcon.classList.remove("st_hidden");
                        var errorMsg = document.querySelector(".st_bank_error_message_JS");
                        errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.classList.add("st_hidden");
                    });
                    container.appendChild(option);
                });
            };
            _this.handleFormSubmitValidation = function() {
                var form = document.querySelector(".bc_payment_information_popup_content_JS");
                var hiddenInput = document.querySelector(".st_bank_hidden_input_JS");
                var errorMsg = document.querySelector(".st_bank_error_message_JS");
                if (!form || !hiddenInput || !errorMsg) return;
                form.addEventListener("submit", function(e) {
                    if (!hiddenInput.value.trim()) {
                        e.preventDefault();
                        errorMsg.classList.remove("st_hidden");
                    } else {
                        errorMsg.classList.add("st_hidden");
                    }
                });
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StSearchDropdown;
    }(st_module_31.StModule);
    exports.StSearchDropdown = StSearchDropdown;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/form/loader", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/_general-methods/currency", "extension/shopify-app/st-modules/seller-enrollment/seller-enrollment", "extension/shopify-app/st-modules/seller-enrollment/seller-enrollment-class-config", "extension/shopify-app/st-modules/seller-enrollment/seller-enrollment-approved", "extension/shopify-app/st-modules/seller-dashboard/seller-dashboard", "extension/shopify-app/st-modules/seller-dashboard/navigation/seller-dashboard-primary-navigation", "extension/shopify-app/st-modules/seller-dashboard/seller-dashboard-class-config", "extension/shopify-app/st-modules/seller-dashboard/sales/seller-dashboard-sales", "extension/shopify-app/st-modules/seller-dashboard/summary/seller-dashboard-summary", "extension/shopify-app/st-modules/seller-dashboard/contacts/seller-dashboard-contacts", "extension/shopify-app/st-modules/seller-dashboard/share-cart/seller-dashboard-share-cart", "extension/shopify-app/st-modules/seller-dashboard/profile/seller-dashboard-profile", "extension/shopify-app/st-modules/seller-dashboard/payouts/seller-dashboard-payouts", "extension/shopify-app/st-modules/seller-dashboard/shared-cart-page/shared-cart-page", "extension/shopify-app/st-modules/seller-dashboard/referrals/seller-dashboard-referral", "extension/shopify-app/st-modules/seller-dashboard/assets/seller-dashboard-assets", "extension/shopify-app/st-modules/seller-dashboard/shared-components/seller-dashboard-shared-components", "extension/shopify-app/st-modules/main/main", "extension/shopify-app/st-modules/seller-dashboard/sales/seller-dashboard-sales-filters", "extension/shopify-app/st-modules/connected-sellers/connected-sellers", "extension/shopify-app/st-modules/seller-dashboard/summary/seller-dashboard-summary-filters", "extension/shopify-app/st-modules/seller-dashboard/payouts/seller-dashboard-payouts-filters", "extension/shopify-app/st-modules/seller-enrollment/search-dropdown" ], function(require, exports, static_2, customer_type_1, loader_2, general_methods_1, button_actions_1, notification_1, object_formatting_1, di_container_public_1, date_input_1, form_class_config_1, currency_7, seller_enrollment_1, seller_enrollment_class_config_1, seller_enrollment_approved_1, seller_dashboard_1, seller_dashboard_primary_navigation_1, seller_dashboard_class_config_1, seller_dashboard_sales_1, seller_dashboard_summary_1, seller_dashboard_contacts_1, seller_dashboard_share_cart_1, seller_dashboard_profile_1, seller_dashboard_payouts_1, shared_cart_page_1, seller_dashboard_referral_1, seller_dashboard_assets_1, seller_dashboard_shared_components_1, main_1, seller_dashboard_sales_filters_1, connected_sellers_1, seller_dashboard_summary_filters_1, seller_dashboard_payouts_filters_1, search_dropdown_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_2.StStatic.Instance();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StLoaderComponent = new loader_2.StLoader();
                _this.StButtonActionsComponent = new button_actions_1.StButtonActions();
                _this.StNotificationComponent = new notification_1.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCurrencyComponent = new currency_7.StCurrency();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StMainComponent = new main_1.StMain();
                _this.StSellerEnrollmentClassConfigComponent = new seller_enrollment_class_config_1.StSellerEnrollmentClassConfig();
                _this.StSellerEnrollmentComponent = new seller_enrollment_1.StSellerEnrollment(_this.StGeneralMethodsComponent, _this.StSellerEnrollmentClassConfigComponent, _this.StButtonActionsComponent);
                _this.StSellerEnrollmentApprovedComponent = new seller_enrollment_approved_1.StSellerEnrollmentApproved(_this.StSellerEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent);
                _this.StSellerDashboardClassConfigComponent = new seller_dashboard_class_config_1.StSellerDashboardClassConfig();
                _this.StSellerDashboardSharedComponent = new seller_dashboard_shared_components_1.StSellerDashboardSharedComponent(_this.StGeneralMethodsComponent, _this.StCurrencyComponent);
                _this.StSellerDashboardSalesFilterComponent = new seller_dashboard_sales_filters_1.StSellerDashboardSalesFilters(_this.StSellerDashboardSharedComponent, _this.StGeneralMethodsComponent);
                _this.StDashboardSales = new seller_dashboard_sales_1.StDashboardSales(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StCurrencyComponent, _this.StGeneralMethodsComponent, _this.StSellerDashboardSalesFilterComponent);
                _this.StSellerDashboardSummaryFilters = new seller_dashboard_summary_filters_1.StSellerDashboardSummaryFilters(_this.StSellerDashboardSharedComponent, _this.StGeneralMethodsComponent);
                _this.StSellerDashboardSummary = new seller_dashboard_summary_1.StSellerDashboardSummary(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StCurrencyComponent, _this.StSellerDashboardSummaryFilters);
                _this.StSellerDashboardAssetsComponent = new seller_dashboard_assets_1.StSellerDashboardAssets(_this.StGeneralMethodsComponent, _this.StSellerDashboardSharedComponent, _this.StObjectFormattingComponent);
                _this.StSellerDashboardReferral = new seller_dashboard_referral_1.StSellerDashboardReferral(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StCurrencyComponent);
                _this.StSellerDashboardContactsComponent = new seller_dashboard_contacts_1.StSellerDashboardContacts(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StCurrencyComponent);
                _this.StSellerDashboardPayoutsFilters = new seller_dashboard_payouts_filters_1.StSellerDashboardPayoutsFilters(_this.StSellerDashboardSharedComponent, _this.StGeneralMethodsComponent);
                _this.StSellerDashboardPayouts = new seller_dashboard_payouts_1.StSellerDashboardPayouts(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StCurrencyComponent, _this.StSellerDashboardPayoutsFilters);
                _this.StSellerDashboardProfileComponent = new seller_dashboard_profile_1.StSellerDashboardProfile(_this.StSellerEnrollmentApprovedComponent, _this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent, _this.StButtonActionsComponent, _this.StGeneralMethodsComponent);
                _this.StSharedCartPageComponent = new shared_cart_page_1.StSharedCartPage(_this.StObjectFormattingComponent, _this.StSellerDashboardSharedComponent);
                _this.StSellerDashboardPrimaryNavigationComponent = new seller_dashboard_primary_navigation_1.StSellerDashboardPrimaryNavigation(_this.StSellerDashboardClassConfigComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StSellerDashboardSummary, _this.StDashboardSales, _this.StSellerDashboardAssetsComponent, _this.StSellerDashboardSharedComponent, _this.StSellerDashboardReferral, _this.StSellerDashboardContactsComponent, _this.StSellerDashboardPayouts, _this.StSellerDashboardProfileComponent, _this.StSharedCartPageComponent);
                _this.StSellerDashboardComponent = new seller_dashboard_1.StSellerDashboard(_this.StSellerDashboardPrimaryNavigationComponent, _this.StObjectFormattingComponent);
                _this.StSellerDashboardShareCartComponent = new seller_dashboard_share_cart_1.StSellerDashboardShareCart(_this.StGeneralMethodsComponent, _this.StSellerDashboardSharedComponent);
                _this.StConnectedSellersComponent = new connected_sellers_1.StConnectedSellers(_this.StSellerDashboardSharedComponent);
                _this.StSearchDropdownComponent = new search_dropdown_1.StSearchDropdown(_this.StObjectFormattingComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StMainComponent, _this.StSellerEnrollmentComponent, _this.StSellerEnrollmentApprovedComponent, _this.StSearchDropdownComponent ]);
                    break;

                  case "seller-dashboard":
                    hierarchy = hierarchy.concat([ _this.StSellerDashboardComponent, _this.StSellerDashboardShareCartComponent ]);
                    break;

                  case "connected-sellers":
                    hierarchy = hierarchy.concat([ _this.StConnectedSellersComponent ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_32.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_33.StModule);
    exports.StCookies = StCookies;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_34.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_35.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_36) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_36.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_3.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_37.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/account-login/account-login-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfig = void 0;
    var StAccountLoginClassConfig = function(_super) {
        __extends(StAccountLoginClassConfig, _super);
        function StAccountLoginClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classLoginPasswordInput = "st_login-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            _this.classLoginPasswordFormControl = "st_login-password-form-control_JS";
            _this.selectorLoginPasswordFormControl = "." + _this.classLoginPasswordFormControl;
            return _this;
        }
        return StAccountLoginClassConfig;
    }(st_module_38.StModule);
    exports.StAccountLoginClassConfig = StAccountLoginClassConfig;
});

define("core/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_39) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLogin = void 0;
    var StAccountLogin = function(_super) {
        __extends(StAccountLogin, _super);
        function StAccountLogin(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountLogin";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.togglePassword();
                });
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var formControl = document.querySelector(_this_1.classConfig.selectorLoginPasswordFormControl);
                var passwordEyeIcons = formControl.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordInput = formControl.querySelector(_this.classConfig.selectorLoginPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountLogin;
    }(st_module_39.StModule);
    exports.StAccountLogin = StAccountLogin;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_40) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_40.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_41, notification_2, _features_config_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                    _this_1.togglePassword();
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    window.location.assign(redirectUrlResponse);
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", error);
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_2.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_2.defaultWebAlias) {
                        _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                    } else {
                        var payload_1 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_1,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                        } else {
                                            _this.registerCustomer(payload_1);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordLabel = _this.generalMethods.getClosestByTag(this, "div");
                        var passwordInput = passwordLabel.querySelector(_this.classConfig.selectorRegisterPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_41.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNamePasswordVisibilityButton = "st_toggle-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_42.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_43.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_44) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = provinceSource.value ? provinceSource.value : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    provinceSelector.value = selectedOption.value;
                    provinceSelector.selectedIndex = parseInt(selectedOption.getAttribute("data-ind"));
                    provinceOptions.forEach(function(provinceOption) {
                        provinceOption.removeAttribute("selected");
                    });
                    selectedOption.selected = true;
                    selectedOption.setAttribute("selected", "selected");
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_44.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_45, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_3.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_45.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_46) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_46.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_47, notification_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_3.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_3.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_3.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_3.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_47.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_48, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_4.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_48.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_49, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_4.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_49.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_50, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.customerId,
                    sponsorId: customerInfoMetafields.representativeId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_50.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_51) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_51.StModule);
    exports.StAccountNav = StAccountNav;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_52) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.initCartSetup();
                    _this_1.cartFetchInterceptorInit();
                });
            };
            _this_1.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                if (this.isGetCartRequest(response.url)) {}
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this_1.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this_1.setShopifyCartData(cartObj);
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.log("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this_1.processCartItemsRecursive(items, 0, alias);
                    });
                });
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.processCartItemsRecursive = function(cartItems, index, alias) {
                if (index < cartItems.length) {
                    var item = cartItems[index];
                    var propertiesData = item.properties;
                    if (propertiesData._sponsorWebAlias !== alias) {
                        propertiesData = __assign(__assign({}, propertiesData), {
                            _sponsorWebAlias: !!alias ? alias : ""
                        });
                        var updateData = {
                            id: "" + item.key,
                            quantity: item.quantity,
                            properties: propertiesData
                        };
                        _this_1.changeCart(updateData, function(cartRes) {
                            _this_1.processCartItemsRecursive(cartRes.items, index + 1, alias);
                        }, false);
                    } else {
                        _this_1.processCartItemsRecursive(cartItems, index + 1, alias);
                    }
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_52.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_53) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountClassConfig = void 0;
    var StEnrollmentAccountClassConfig = function(_super) {
        __extends(StEnrollmentAccountClassConfig, _super);
        function StEnrollmentAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameEnrollmentAccountPageWrp = "st_enrollment-account-page_JS";
            _this.selectorEnrollmentAccountPageWrp = "." + _this.classNameEnrollmentAccountPageWrp;
            _this.classNameEnrollmentLoginForm = "st_enrollment-login_JS";
            _this.selectorEnrollmentLoginForm = "." + _this.classNameEnrollmentLoginForm;
            _this.classNameEnrollmentCreateAccountWrp = "st_enrollment-create-account_JS";
            _this.selectorEnrollmentCreateAccountWrp = "." + _this.classNameEnrollmentCreateAccountWrp;
            _this.classNameEnrollmentCreateAccountForm = "st_enrollment-create-account--form_JS";
            _this.selectorEnrollmentCreateAccountForm = "." + _this.classNameEnrollmentCreateAccountForm;
            _this.classNameEnrollmentCreateAccountOpenButton = "st_enrollment-create-account--open_JS";
            _this.selectorEnrollmentCreateAccountOpenButton = "." + _this.classNameEnrollmentCreateAccountOpenButton;
            _this.classNameEnrollmentCreateAccountSubmit = "st_submit--btn_JS";
            _this.selectorEnrollmentCreateAccountSubmit = "." + _this.classNameEnrollmentCreateAccountSubmit;
            _this.classNameEnrollmentPasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorEnrollmentPasswordVisibilityButton = "." + _this.classNameEnrollmentPasswordVisibilityButton;
            _this.classNameEnrollmentAccountPassword = "st_enrollment-account-create-password_JS";
            _this.selectorEnrollmentAccountPassword = "." + _this.classNameEnrollmentAccountPassword;
            _this.classNameEnrollmentAccountRepeatPassword = "st_enrollment-account-create-repeat-password_JS";
            _this.selectorEnrollmentAccountRepeatPassword = "." + _this.classNameEnrollmentAccountRepeatPassword;
            _this.classNamePrimaryInput = "st_primary-input_JS";
            _this.selectorPrimaryInput = "." + _this.classNamePrimaryInput;
            return _this;
        }
        return StEnrollmentAccountClassConfig;
    }(st_module_53.StModule);
    exports.StEnrollmentAccountClassConfig = StEnrollmentAccountClassConfig;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_54) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRepeatPasswordValidation = void 0;
    var StEnrollmentRepeatPasswordValidation = function(_super) {
        __extends(StEnrollmentRepeatPasswordValidation, _super);
        function StEnrollmentRepeatPasswordValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentRepeatPassword";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentAccountPageWrp);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountRepeatPassword);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isValid = input.value === input.value;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "Your passwords are not matching!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentRepeatPasswordValidation;
    }(st_module_54.StModule);
    exports.StEnrollmentRepeatPasswordValidation = StEnrollmentRepeatPasswordValidation;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_55, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_5.enrollmentParams !== null && _features_config_5.enrollmentParams !== void 0 ? _features_config_5.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_55.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_56, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccount = void 0;
    var StEnrollmentAccount = function(_super) {
        __extends(StEnrollmentAccount, _super);
        function StEnrollmentAccount(classConfig, buttonActions, notification, form, generalMethod, enrollmentCleanup, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentAccount";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.enrollmentLoginPreventDefault();
                    _this_1.togglePassword();
                    _this_1.toggleCreateAccount();
                    _this_1.enrollmentCreateAccountForm();
                });
            };
            _this_1.enrollmentLoginPreventDefault = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentLoginForm);
                enrollmentForms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentLogin(form, _this.prepareForLogin(form));
                    });
                });
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["customer[email]"],
                    password: formData["customer[password]"]
                };
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var redirectUrl = form.getAttribute("data-url");
                var submitBtn = form.querySelector(".st_submit--btn_JS");
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var cartData = _this.stCart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                        });
                                    } else {
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.toggleCreateAccount = function() {
                var _this = _this_1;
                var createAccountBtns = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountOpenButton);
                createAccountBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showEnrollmentCreateAccount(this);
                    });
                });
            };
            _this_1.showEnrollmentCreateAccount = function(triggerBtn) {
                var enrollmentCreateAccount = document.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountWrp);
                if (!!enrollmentCreateAccount) {
                    enrollmentCreateAccount.classList.remove("st_visibility-hidden");
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var enrollmentAccountPage = _this_1.generalMethod.getClosestByClass(triggerBtn, _this_1.classConfig.classNameEnrollmentAccountPageWrp);
                    if (!!enrollmentAccountPage) {
                        enrollmentAccountPage.classList.add("st_visibility-hidden");
                    }
                }
            };
            _this_1.enrollmentCreateAccountForm = function() {
                var _this = _this_1;
                var enrollmentCreateAccountForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountForm);
                enrollmentCreateAccountForms.forEach(function(form) {
                    _this.onRepeatPassword(form);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentCreateAccountFormSubmit(form);
                    });
                });
            };
            _this_1.enrollmentCreateAccountFormSubmit = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountSubmit);
                _this.form.clearFormatting(form, [ "repeatPassword" ]);
                _this.buttonActions.prevent(submitBtn);
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                if (passwordInputElement.value.length > 40) {
                    _this.notification.showNotification(notification_6.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                    _this.buttonActions.allow(submitBtn);
                } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["enrollment"]["createAccount"],
                        method: "post",
                        contentType: "json",
                        data: formData,
                        callback: function(response) {
                            try {
                                var createAccountResponse = JSON.parse(response.response);
                                if (createAccountResponse.status === 200) {
                                    _this.buttonActions.allow(submitBtn);
                                    var formDataLogin = {
                                        email: formData.email,
                                        password: formData.password
                                    };
                                    _this.enrollmentLogin(form, formDataLogin);
                                } else if (createAccountResponse.status === 400) {
                                    var validationErrors = _this.prepareErrorArray(createAccountResponse.data);
                                    _this.notification.showNotification(notification_6.ENotificationType.error, "Validation Error", validationErrors);
                                    _this.buttonActions.allow(submitBtn);
                                    var errors = [];
                                    for (var validationParam in createAccountResponse.data) {
                                        var validationResult = createAccountResponse.data[validationParam];
                                        if (!validationResult.isValid) {
                                            errors.push(validationResult.message);
                                        }
                                    }
                                    _this.notification.showNotification(notification_6.ENotificationType.error, "Validation Error", errors);
                                    _this.buttonActions.allow(submitBtn);
                                } else {
                                    _this.notification.showNotification(notification_6.ENotificationType.error, "Validation Error", createAccountResponse.message);
                                    _this.buttonActions.allow(submitBtn);
                                }
                            } catch (error) {
                                console.error(error);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                                _this.buttonActions.allow(submitBtn);
                            }
                        }
                    });
                } else {
                    _this.form.markValidationResults(form, _this.checkPasswordMatch({}));
                    _this.notification.showNotification(notification_6.ENotificationType.error, "Validation Error", "Passwords not matching!");
                    _this.buttonActions.allow(submitBtn);
                }
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordLabel = _this.generalMethod.getClosestByTag(this, "label");
                        if (!!passwordLabel) {
                            var passwordInput = passwordLabel.querySelector(_this.classConfig.selectorPrimaryInput);
                            if (!!passwordInput) {
                                if (passwordInput.getAttribute("type") === "password") {
                                    passwordInput.setAttribute("type", "text");
                                    this.classList.add("st_password-visible");
                                } else {
                                    passwordInput.setAttribute("type", "password");
                                    this.classList.remove("st_password-visible");
                                }
                            }
                        }
                    });
                });
            };
            _this_1.onRepeatPassword = function(form) {
                var _this = _this_1;
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                passwordInputElement.oninput = function(e) {
                    var validationProperties = _this.checkPasswordMatch({});
                    if (Object.keys(validationProperties).length === 0) {
                        _this.form.clearFormatting(form, [ "repeatPassword" ]);
                    } else {
                        _this.form.markValidationResults(form, validationProperties);
                    }
                };
                if (repeatPasswordInputElement) {
                    repeatPasswordInputElement.oninput = function() {
                        var validationProperties = _this.checkPasswordMatch({});
                        if (Object.keys(validationProperties).length === 0) {
                            _this.form.clearFormatting(form, [ "repeatPassword" ]);
                        } else {
                            _this.form.markValidationResults(form, validationProperties);
                        }
                    };
                }
            };
            _this_1.checkPasswordMatch = function(validationProperties) {
                var passwordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountPassword);
                var repeatPasswordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountRepeatPassword);
                if (repeatPasswordInputElement) {
                    if (passwordInputElement.value !== repeatPasswordInputElement.value) {
                        return __assign(__assign({}, validationProperties), {
                            repeatPassword: {
                                isValid: false,
                                message: "Passwords not matching!"
                            }
                        });
                    }
                }
                return validationProperties;
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.form = form;
            _this_1.generalMethod = generalMethod;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.stCart = cart;
            return _this_1;
        }
        return StEnrollmentAccount;
    }(st_module_56.StModule);
    exports.StEnrollmentAccount = StEnrollmentAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_57.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_58) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_58.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_59, notification_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_7.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_59.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_60) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_60.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_61) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_61.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "webAlias" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_62) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_62.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_63) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_63.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_64) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_64.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_65, currency_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_8.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_65.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_66) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_66.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_67.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_68.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_69) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_69.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_70) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_70.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_71, notification_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_8.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_8.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_71.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_72, notification_9, button_actions_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_2 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_2.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_9.ENotificationType.error, "Some fields are invalid!", errorMessage_2);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        webAlias: data.webAlias,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_72.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "_features.config" ], function(require, exports, st_module_73, _features_config_6, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_7.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_6.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_73.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_74, notification_10, _features_config_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_8.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_8.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var als = urlParams.als;
                var refCode = {
                    promoCode: referralCode,
                    webAlias: als
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_10.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_74.StModule);
    exports.StReferral = StReferral;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_75) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_75.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_76) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_76.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_77) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_77.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_78) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ResetPassword";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.togglePassword();
                });
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordLabel = _this.generalMethods.getClosestByTag(this, "div");
                        var passwordInput = passwordLabel.querySelector(_this.classConfig.selectorLoginPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StResetPassword;
    }(st_module_78.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_79) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_79.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_80, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var als = _this.objectFormatting.convertQueryStringToObject(window.location.search).als;
                        _this.toggleCantGoUnderCorporateSite(als === _features_config_9.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_9.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var als = _this.objectFormatting.convertQueryStringToObject(window.location.search).als;
                    _this.toggleCantGoUnderCorporateSite(als === _features_config_9.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_80.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_81) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_81.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_82, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_10.ECustomerType.retail && _features_config_10.lockedRepresentativeSite || customerType == _features_config_10.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_10.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_10.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_10.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_10.corporationName, "", _features_config_10.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var als = urlParams.als;
                if (als !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), {
                        als: newAlias
                    });
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperies(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_10.canGoUnderCorporateSite || !_features_config_10.canGoUnderCorporateSite && alias !== _features_config_10.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias) {
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_10.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        _this.getSponsorInfo(_features_config_10.defaultWebAlias);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.webAlias);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_10.lockedRepresentativeSite && customerType !== _features_config_10.ECustomerType.noType) {
                    repSite = customerType === _features_config_10.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.als) {
                        repSite = webAlias.als;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_10.defaultWebAlias) fullName = _features_config_10.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_82.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_83) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_83.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_11, st_module_84) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_11.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?als=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_11.defaultWebAlias) {
                    fullName = _features_config_11.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_84.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_85, _features_config_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    console.log("lockedRepresentativeSite: ", _features_config_12.lockedRepresentativeSite);
                    console.log("canGoUnderCorporateSite: ", _features_config_12.canGoUnderCorporateSite);
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var als = _this.objectFormatting.convertQueryStringToObject(window.location.search).als;
                var urlAliasExists = !!als;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(als);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var als = _this.objectFormatting.convertQueryStringToObject(window.location.search).als;
                var urlAliasExists = !!als;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_12.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(als);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isAliasEqualToStored(webAlias)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                } else {
                    _this.cartComponent.updateCartItemsProperies(webAlias);
                }
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_12.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_12.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_12.defaultWebAlias,
                    firstName: _features_config_12.corporationName,
                    lastName: ""
                };
                if (_features_config_12.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_12.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var als = _this.objectFormatting.convertQueryStringToObject(window.location.search).als;
                return als === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), {
                    als: alias
                });
                var newURL = window.location.href.replace(window.location.search, "");
                _this.cartComponent.updateCartItemsProperies(alias);
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_12.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorWebAliasFieldChange = function() {
                var representativeWebAliasInput = document.querySelectorAll(".st_representative-alias_JS");
                representativeWebAliasInput.forEach(function(webAliasInput) {
                    webAliasInput.oninput = function() {
                        return _this.updateWebAliasOnSponsorFieldChange(webAliasInput);
                    };
                });
            };
            _this.updateWebAliasOnSponsorFieldChange = function(representativeWebAliasInput) {
                clearTimeout(_this.sponsorWebAliasInputTimeout);
                _this.sponsorWebAliasInputTimeout = setTimeout(function() {
                    var currentUrlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var newUrlParams = __assign(__assign({}, currentUrlParams), {
                        als: representativeWebAliasInput.value
                    });
                    var newQueryString = _this.objectFormatting.convertObjectToQueryString(newUrlParams);
                    _this.cartComponent.updateCartItemsProperies(representativeWebAliasInput.value);
                    var newURL = window.location.origin + window.location.pathname + newQueryString;
                    window.location.replace(newURL);
                }, 1e3);
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_12.sponsorGenealogyTimeout ? _features_config_12.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;
            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_12.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_12.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_12.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_85.StModule);
    exports.StWebAlias = StWebAlias;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;